/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var ajv = {exports: {}};

var core$1 = {};

var validate = {};

var boolSchema = {};

var errors = {};

var codegen = {};

var code$1 = {};

var hasRequiredCode$1;

function requireCode$1 () {
	if (hasRequiredCode$1) return code$1;
	hasRequiredCode$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.regexpCode = exports.getEsmExportName = exports.getProperty = exports.safeStringify = exports.stringify = exports.strConcat = exports.addCodeArg = exports.str = exports._ = exports.nil = exports._Code = exports.Name = exports.IDENTIFIER = exports._CodeOrName = void 0;
		// eslint-disable-next-line @typescript-eslint/no-extraneous-class
		class _CodeOrName {
		}
		exports._CodeOrName = _CodeOrName;
		exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
		class Name extends _CodeOrName {
		    constructor(s) {
		        super();
		        if (!exports.IDENTIFIER.test(s))
		            throw new Error("CodeGen: name must be a valid identifier");
		        this.str = s;
		    }
		    toString() {
		        return this.str;
		    }
		    emptyStr() {
		        return false;
		    }
		    get names() {
		        return { [this.str]: 1 };
		    }
		}
		exports.Name = Name;
		class _Code extends _CodeOrName {
		    constructor(code) {
		        super();
		        this._items = typeof code === "string" ? [code] : code;
		    }
		    toString() {
		        return this.str;
		    }
		    emptyStr() {
		        if (this._items.length > 1)
		            return false;
		        const item = this._items[0];
		        return item === "" || item === '""';
		    }
		    get str() {
		        var _a;
		        return ((_a = this._str) !== null && _a !== void 0 ? _a : (this._str = this._items.reduce((s, c) => `${s}${c}`, "")));
		    }
		    get names() {
		        var _a;
		        return ((_a = this._names) !== null && _a !== void 0 ? _a : (this._names = this._items.reduce((names, c) => {
		            if (c instanceof Name)
		                names[c.str] = (names[c.str] || 0) + 1;
		            return names;
		        }, {})));
		    }
		}
		exports._Code = _Code;
		exports.nil = new _Code("");
		function _(strs, ...args) {
		    const code = [strs[0]];
		    let i = 0;
		    while (i < args.length) {
		        addCodeArg(code, args[i]);
		        code.push(strs[++i]);
		    }
		    return new _Code(code);
		}
		exports._ = _;
		const plus = new _Code("+");
		function str(strs, ...args) {
		    const expr = [safeStringify(strs[0])];
		    let i = 0;
		    while (i < args.length) {
		        expr.push(plus);
		        addCodeArg(expr, args[i]);
		        expr.push(plus, safeStringify(strs[++i]));
		    }
		    optimize(expr);
		    return new _Code(expr);
		}
		exports.str = str;
		function addCodeArg(code, arg) {
		    if (arg instanceof _Code)
		        code.push(...arg._items);
		    else if (arg instanceof Name)
		        code.push(arg);
		    else
		        code.push(interpolate(arg));
		}
		exports.addCodeArg = addCodeArg;
		function optimize(expr) {
		    let i = 1;
		    while (i < expr.length - 1) {
		        if (expr[i] === plus) {
		            const res = mergeExprItems(expr[i - 1], expr[i + 1]);
		            if (res !== undefined) {
		                expr.splice(i - 1, 3, res);
		                continue;
		            }
		            expr[i++] = "+";
		        }
		        i++;
		    }
		}
		function mergeExprItems(a, b) {
		    if (b === '""')
		        return a;
		    if (a === '""')
		        return b;
		    if (typeof a == "string") {
		        if (b instanceof Name || a[a.length - 1] !== '"')
		            return;
		        if (typeof b != "string")
		            return `${a.slice(0, -1)}${b}"`;
		        if (b[0] === '"')
		            return a.slice(0, -1) + b.slice(1);
		        return;
		    }
		    if (typeof b == "string" && b[0] === '"' && !(a instanceof Name))
		        return `"${a}${b.slice(1)}`;
		    return;
		}
		function strConcat(c1, c2) {
		    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : str `${c1}${c2}`;
		}
		exports.strConcat = strConcat;
		// TODO do not allow arrays here
		function interpolate(x) {
		    return typeof x == "number" || typeof x == "boolean" || x === null
		        ? x
		        : safeStringify(Array.isArray(x) ? x.join(",") : x);
		}
		function stringify(x) {
		    return new _Code(safeStringify(x));
		}
		exports.stringify = stringify;
		function safeStringify(x) {
		    return JSON.stringify(x)
		        .replace(/\u2028/g, "\\u2028")
		        .replace(/\u2029/g, "\\u2029");
		}
		exports.safeStringify = safeStringify;
		function getProperty(key) {
		    return typeof key == "string" && exports.IDENTIFIER.test(key) ? new _Code(`.${key}`) : _ `[${key}]`;
		}
		exports.getProperty = getProperty;
		//Does best effort to format the name properly
		function getEsmExportName(key) {
		    if (typeof key == "string" && exports.IDENTIFIER.test(key)) {
		        return new _Code(`${key}`);
		    }
		    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
		}
		exports.getEsmExportName = getEsmExportName;
		function regexpCode(rx) {
		    return new _Code(rx.toString());
		}
		exports.regexpCode = regexpCode;
		
	} (code$1));
	return code$1;
}

var scope = {};

var hasRequiredScope;

function requireScope () {
	if (hasRequiredScope) return scope;
	hasRequiredScope = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.ValueScope = exports.ValueScopeName = exports.Scope = exports.varKinds = exports.UsedValueState = void 0;
		const code_1 = /*@__PURE__*/ requireCode$1();
		class ValueError extends Error {
		    constructor(name) {
		        super(`CodeGen: "code" for ${name} not defined`);
		        this.value = name.value;
		    }
		}
		var UsedValueState;
		(function (UsedValueState) {
		    UsedValueState[UsedValueState["Started"] = 0] = "Started";
		    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
		})(UsedValueState || (exports.UsedValueState = UsedValueState = {}));
		exports.varKinds = {
		    const: new code_1.Name("const"),
		    let: new code_1.Name("let"),
		    var: new code_1.Name("var"),
		};
		class Scope {
		    constructor({ prefixes, parent } = {}) {
		        this._names = {};
		        this._prefixes = prefixes;
		        this._parent = parent;
		    }
		    toName(nameOrPrefix) {
		        return nameOrPrefix instanceof code_1.Name ? nameOrPrefix : this.name(nameOrPrefix);
		    }
		    name(prefix) {
		        return new code_1.Name(this._newName(prefix));
		    }
		    _newName(prefix) {
		        const ng = this._names[prefix] || this._nameGroup(prefix);
		        return `${prefix}${ng.index++}`;
		    }
		    _nameGroup(prefix) {
		        var _a, _b;
		        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || (this._prefixes && !this._prefixes.has(prefix))) {
		            throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
		        }
		        return (this._names[prefix] = { prefix, index: 0 });
		    }
		}
		exports.Scope = Scope;
		class ValueScopeName extends code_1.Name {
		    constructor(prefix, nameStr) {
		        super(nameStr);
		        this.prefix = prefix;
		    }
		    setValue(value, { property, itemIndex }) {
		        this.value = value;
		        this.scopePath = (0, code_1._) `.${new code_1.Name(property)}[${itemIndex}]`;
		    }
		}
		exports.ValueScopeName = ValueScopeName;
		const line = (0, code_1._) `\n`;
		class ValueScope extends Scope {
		    constructor(opts) {
		        super(opts);
		        this._values = {};
		        this._scope = opts.scope;
		        this.opts = { ...opts, _n: opts.lines ? line : code_1.nil };
		    }
		    get() {
		        return this._scope;
		    }
		    name(prefix) {
		        return new ValueScopeName(prefix, this._newName(prefix));
		    }
		    value(nameOrPrefix, value) {
		        var _a;
		        if (value.ref === undefined)
		            throw new Error("CodeGen: ref must be passed in value");
		        const name = this.toName(nameOrPrefix);
		        const { prefix } = name;
		        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
		        let vs = this._values[prefix];
		        if (vs) {
		            const _name = vs.get(valueKey);
		            if (_name)
		                return _name;
		        }
		        else {
		            vs = this._values[prefix] = new Map();
		        }
		        vs.set(valueKey, name);
		        const s = this._scope[prefix] || (this._scope[prefix] = []);
		        const itemIndex = s.length;
		        s[itemIndex] = value.ref;
		        name.setValue(value, { property: prefix, itemIndex });
		        return name;
		    }
		    getValue(prefix, keyOrRef) {
		        const vs = this._values[prefix];
		        if (!vs)
		            return;
		        return vs.get(keyOrRef);
		    }
		    scopeRefs(scopeName, values = this._values) {
		        return this._reduceValues(values, (name) => {
		            if (name.scopePath === undefined)
		                throw new Error(`CodeGen: name "${name}" has no value`);
		            return (0, code_1._) `${scopeName}${name.scopePath}`;
		        });
		    }
		    scopeCode(values = this._values, usedValues, getCode) {
		        return this._reduceValues(values, (name) => {
		            if (name.value === undefined)
		                throw new Error(`CodeGen: name "${name}" has no value`);
		            return name.value.code;
		        }, usedValues, getCode);
		    }
		    _reduceValues(values, valueCode, usedValues = {}, getCode) {
		        let code = code_1.nil;
		        for (const prefix in values) {
		            const vs = values[prefix];
		            if (!vs)
		                continue;
		            const nameSet = (usedValues[prefix] = usedValues[prefix] || new Map());
		            vs.forEach((name) => {
		                if (nameSet.has(name))
		                    return;
		                nameSet.set(name, UsedValueState.Started);
		                let c = valueCode(name);
		                if (c) {
		                    const def = this.opts.es5 ? exports.varKinds.var : exports.varKinds.const;
		                    code = (0, code_1._) `${code}${def} ${name} = ${c};${this.opts._n}`;
		                }
		                else if ((c = getCode === null || getCode === void 0 ? void 0 : getCode(name))) {
		                    code = (0, code_1._) `${code}${c}${this.opts._n}`;
		                }
		                else {
		                    throw new ValueError(name);
		                }
		                nameSet.set(name, UsedValueState.Completed);
		            });
		        }
		        return code;
		    }
		}
		exports.ValueScope = ValueScope;
		
	} (scope));
	return scope;
}

var hasRequiredCodegen;

function requireCodegen () {
	if (hasRequiredCodegen) return codegen;
	hasRequiredCodegen = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.or = exports.and = exports.not = exports.CodeGen = exports.operators = exports.varKinds = exports.ValueScopeName = exports.ValueScope = exports.Scope = exports.Name = exports.regexpCode = exports.stringify = exports.getProperty = exports.nil = exports.strConcat = exports.str = exports._ = void 0;
		const code_1 = /*@__PURE__*/ requireCode$1();
		const scope_1 = /*@__PURE__*/ requireScope();
		var code_2 = /*@__PURE__*/ requireCode$1();
		Object.defineProperty(exports, "_", { enumerable: true, get: function () { return code_2._; } });
		Object.defineProperty(exports, "str", { enumerable: true, get: function () { return code_2.str; } });
		Object.defineProperty(exports, "strConcat", { enumerable: true, get: function () { return code_2.strConcat; } });
		Object.defineProperty(exports, "nil", { enumerable: true, get: function () { return code_2.nil; } });
		Object.defineProperty(exports, "getProperty", { enumerable: true, get: function () { return code_2.getProperty; } });
		Object.defineProperty(exports, "stringify", { enumerable: true, get: function () { return code_2.stringify; } });
		Object.defineProperty(exports, "regexpCode", { enumerable: true, get: function () { return code_2.regexpCode; } });
		Object.defineProperty(exports, "Name", { enumerable: true, get: function () { return code_2.Name; } });
		var scope_2 = /*@__PURE__*/ requireScope();
		Object.defineProperty(exports, "Scope", { enumerable: true, get: function () { return scope_2.Scope; } });
		Object.defineProperty(exports, "ValueScope", { enumerable: true, get: function () { return scope_2.ValueScope; } });
		Object.defineProperty(exports, "ValueScopeName", { enumerable: true, get: function () { return scope_2.ValueScopeName; } });
		Object.defineProperty(exports, "varKinds", { enumerable: true, get: function () { return scope_2.varKinds; } });
		exports.operators = {
		    GT: new code_1._Code(">"),
		    GTE: new code_1._Code(">="),
		    LT: new code_1._Code("<"),
		    LTE: new code_1._Code("<="),
		    EQ: new code_1._Code("==="),
		    NEQ: new code_1._Code("!=="),
		    NOT: new code_1._Code("!"),
		    OR: new code_1._Code("||"),
		    AND: new code_1._Code("&&"),
		    ADD: new code_1._Code("+"),
		};
		class Node {
		    optimizeNodes() {
		        return this;
		    }
		    optimizeNames(_names, _constants) {
		        return this;
		    }
		}
		class Def extends Node {
		    constructor(varKind, name, rhs) {
		        super();
		        this.varKind = varKind;
		        this.name = name;
		        this.rhs = rhs;
		    }
		    render({ es5, _n }) {
		        const varKind = es5 ? scope_1.varKinds.var : this.varKind;
		        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
		        return `${varKind} ${this.name}${rhs};` + _n;
		    }
		    optimizeNames(names, constants) {
		        if (!names[this.name.str])
		            return;
		        if (this.rhs)
		            this.rhs = optimizeExpr(this.rhs, names, constants);
		        return this;
		    }
		    get names() {
		        return this.rhs instanceof code_1._CodeOrName ? this.rhs.names : {};
		    }
		}
		class Assign extends Node {
		    constructor(lhs, rhs, sideEffects) {
		        super();
		        this.lhs = lhs;
		        this.rhs = rhs;
		        this.sideEffects = sideEffects;
		    }
		    render({ _n }) {
		        return `${this.lhs} = ${this.rhs};` + _n;
		    }
		    optimizeNames(names, constants) {
		        if (this.lhs instanceof code_1.Name && !names[this.lhs.str] && !this.sideEffects)
		            return;
		        this.rhs = optimizeExpr(this.rhs, names, constants);
		        return this;
		    }
		    get names() {
		        const names = this.lhs instanceof code_1.Name ? {} : { ...this.lhs.names };
		        return addExprNames(names, this.rhs);
		    }
		}
		class AssignOp extends Assign {
		    constructor(lhs, op, rhs, sideEffects) {
		        super(lhs, rhs, sideEffects);
		        this.op = op;
		    }
		    render({ _n }) {
		        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
		    }
		}
		class Label extends Node {
		    constructor(label) {
		        super();
		        this.label = label;
		        this.names = {};
		    }
		    render({ _n }) {
		        return `${this.label}:` + _n;
		    }
		}
		class Break extends Node {
		    constructor(label) {
		        super();
		        this.label = label;
		        this.names = {};
		    }
		    render({ _n }) {
		        const label = this.label ? ` ${this.label}` : "";
		        return `break${label};` + _n;
		    }
		}
		class Throw extends Node {
		    constructor(error) {
		        super();
		        this.error = error;
		    }
		    render({ _n }) {
		        return `throw ${this.error};` + _n;
		    }
		    get names() {
		        return this.error.names;
		    }
		}
		class AnyCode extends Node {
		    constructor(code) {
		        super();
		        this.code = code;
		    }
		    render({ _n }) {
		        return `${this.code};` + _n;
		    }
		    optimizeNodes() {
		        return `${this.code}` ? this : undefined;
		    }
		    optimizeNames(names, constants) {
		        this.code = optimizeExpr(this.code, names, constants);
		        return this;
		    }
		    get names() {
		        return this.code instanceof code_1._CodeOrName ? this.code.names : {};
		    }
		}
		class ParentNode extends Node {
		    constructor(nodes = []) {
		        super();
		        this.nodes = nodes;
		    }
		    render(opts) {
		        return this.nodes.reduce((code, n) => code + n.render(opts), "");
		    }
		    optimizeNodes() {
		        const { nodes } = this;
		        let i = nodes.length;
		        while (i--) {
		            const n = nodes[i].optimizeNodes();
		            if (Array.isArray(n))
		                nodes.splice(i, 1, ...n);
		            else if (n)
		                nodes[i] = n;
		            else
		                nodes.splice(i, 1);
		        }
		        return nodes.length > 0 ? this : undefined;
		    }
		    optimizeNames(names, constants) {
		        const { nodes } = this;
		        let i = nodes.length;
		        while (i--) {
		            // iterating backwards improves 1-pass optimization
		            const n = nodes[i];
		            if (n.optimizeNames(names, constants))
		                continue;
		            subtractNames(names, n.names);
		            nodes.splice(i, 1);
		        }
		        return nodes.length > 0 ? this : undefined;
		    }
		    get names() {
		        return this.nodes.reduce((names, n) => addNames(names, n.names), {});
		    }
		}
		class BlockNode extends ParentNode {
		    render(opts) {
		        return "{" + opts._n + super.render(opts) + "}" + opts._n;
		    }
		}
		class Root extends ParentNode {
		}
		class Else extends BlockNode {
		}
		Else.kind = "else";
		class If extends BlockNode {
		    constructor(condition, nodes) {
		        super(nodes);
		        this.condition = condition;
		    }
		    render(opts) {
		        let code = `if(${this.condition})` + super.render(opts);
		        if (this.else)
		            code += "else " + this.else.render(opts);
		        return code;
		    }
		    optimizeNodes() {
		        super.optimizeNodes();
		        const cond = this.condition;
		        if (cond === true)
		            return this.nodes; // else is ignored here
		        let e = this.else;
		        if (e) {
		            const ns = e.optimizeNodes();
		            e = this.else = Array.isArray(ns) ? new Else(ns) : ns;
		        }
		        if (e) {
		            if (cond === false)
		                return e instanceof If ? e : e.nodes;
		            if (this.nodes.length)
		                return this;
		            return new If(not(cond), e instanceof If ? [e] : e.nodes);
		        }
		        if (cond === false || !this.nodes.length)
		            return undefined;
		        return this;
		    }
		    optimizeNames(names, constants) {
		        var _a;
		        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
		        if (!(super.optimizeNames(names, constants) || this.else))
		            return;
		        this.condition = optimizeExpr(this.condition, names, constants);
		        return this;
		    }
		    get names() {
		        const names = super.names;
		        addExprNames(names, this.condition);
		        if (this.else)
		            addNames(names, this.else.names);
		        return names;
		    }
		}
		If.kind = "if";
		class For extends BlockNode {
		}
		For.kind = "for";
		class ForLoop extends For {
		    constructor(iteration) {
		        super();
		        this.iteration = iteration;
		    }
		    render(opts) {
		        return `for(${this.iteration})` + super.render(opts);
		    }
		    optimizeNames(names, constants) {
		        if (!super.optimizeNames(names, constants))
		            return;
		        this.iteration = optimizeExpr(this.iteration, names, constants);
		        return this;
		    }
		    get names() {
		        return addNames(super.names, this.iteration.names);
		    }
		}
		class ForRange extends For {
		    constructor(varKind, name, from, to) {
		        super();
		        this.varKind = varKind;
		        this.name = name;
		        this.from = from;
		        this.to = to;
		    }
		    render(opts) {
		        const varKind = opts.es5 ? scope_1.varKinds.var : this.varKind;
		        const { name, from, to } = this;
		        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
		    }
		    get names() {
		        const names = addExprNames(super.names, this.from);
		        return addExprNames(names, this.to);
		    }
		}
		class ForIter extends For {
		    constructor(loop, varKind, name, iterable) {
		        super();
		        this.loop = loop;
		        this.varKind = varKind;
		        this.name = name;
		        this.iterable = iterable;
		    }
		    render(opts) {
		        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
		    }
		    optimizeNames(names, constants) {
		        if (!super.optimizeNames(names, constants))
		            return;
		        this.iterable = optimizeExpr(this.iterable, names, constants);
		        return this;
		    }
		    get names() {
		        return addNames(super.names, this.iterable.names);
		    }
		}
		class Func extends BlockNode {
		    constructor(name, args, async) {
		        super();
		        this.name = name;
		        this.args = args;
		        this.async = async;
		    }
		    render(opts) {
		        const _async = this.async ? "async " : "";
		        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
		    }
		}
		Func.kind = "func";
		class Return extends ParentNode {
		    render(opts) {
		        return "return " + super.render(opts);
		    }
		}
		Return.kind = "return";
		class Try extends BlockNode {
		    render(opts) {
		        let code = "try" + super.render(opts);
		        if (this.catch)
		            code += this.catch.render(opts);
		        if (this.finally)
		            code += this.finally.render(opts);
		        return code;
		    }
		    optimizeNodes() {
		        var _a, _b;
		        super.optimizeNodes();
		        (_a = this.catch) === null || _a === void 0 ? void 0 : _a.optimizeNodes();
		        (_b = this.finally) === null || _b === void 0 ? void 0 : _b.optimizeNodes();
		        return this;
		    }
		    optimizeNames(names, constants) {
		        var _a, _b;
		        super.optimizeNames(names, constants);
		        (_a = this.catch) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
		        (_b = this.finally) === null || _b === void 0 ? void 0 : _b.optimizeNames(names, constants);
		        return this;
		    }
		    get names() {
		        const names = super.names;
		        if (this.catch)
		            addNames(names, this.catch.names);
		        if (this.finally)
		            addNames(names, this.finally.names);
		        return names;
		    }
		}
		class Catch extends BlockNode {
		    constructor(error) {
		        super();
		        this.error = error;
		    }
		    render(opts) {
		        return `catch(${this.error})` + super.render(opts);
		    }
		}
		Catch.kind = "catch";
		class Finally extends BlockNode {
		    render(opts) {
		        return "finally" + super.render(opts);
		    }
		}
		Finally.kind = "finally";
		class CodeGen {
		    constructor(extScope, opts = {}) {
		        this._values = {};
		        this._blockStarts = [];
		        this._constants = {};
		        this.opts = { ...opts, _n: opts.lines ? "\n" : "" };
		        this._extScope = extScope;
		        this._scope = new scope_1.Scope({ parent: extScope });
		        this._nodes = [new Root()];
		    }
		    toString() {
		        return this._root.render(this.opts);
		    }
		    // returns unique name in the internal scope
		    name(prefix) {
		        return this._scope.name(prefix);
		    }
		    // reserves unique name in the external scope
		    scopeName(prefix) {
		        return this._extScope.name(prefix);
		    }
		    // reserves unique name in the external scope and assigns value to it
		    scopeValue(prefixOrName, value) {
		        const name = this._extScope.value(prefixOrName, value);
		        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
		        vs.add(name);
		        return name;
		    }
		    getScopeValue(prefix, keyOrRef) {
		        return this._extScope.getValue(prefix, keyOrRef);
		    }
		    // return code that assigns values in the external scope to the names that are used internally
		    // (same names that were returned by gen.scopeName or gen.scopeValue)
		    scopeRefs(scopeName) {
		        return this._extScope.scopeRefs(scopeName, this._values);
		    }
		    scopeCode() {
		        return this._extScope.scopeCode(this._values);
		    }
		    _def(varKind, nameOrPrefix, rhs, constant) {
		        const name = this._scope.toName(nameOrPrefix);
		        if (rhs !== undefined && constant)
		            this._constants[name.str] = rhs;
		        this._leafNode(new Def(varKind, name, rhs));
		        return name;
		    }
		    // `const` declaration (`var` in es5 mode)
		    const(nameOrPrefix, rhs, _constant) {
		        return this._def(scope_1.varKinds.const, nameOrPrefix, rhs, _constant);
		    }
		    // `let` declaration with optional assignment (`var` in es5 mode)
		    let(nameOrPrefix, rhs, _constant) {
		        return this._def(scope_1.varKinds.let, nameOrPrefix, rhs, _constant);
		    }
		    // `var` declaration with optional assignment
		    var(nameOrPrefix, rhs, _constant) {
		        return this._def(scope_1.varKinds.var, nameOrPrefix, rhs, _constant);
		    }
		    // assignment code
		    assign(lhs, rhs, sideEffects) {
		        return this._leafNode(new Assign(lhs, rhs, sideEffects));
		    }
		    // `+=` code
		    add(lhs, rhs) {
		        return this._leafNode(new AssignOp(lhs, exports.operators.ADD, rhs));
		    }
		    // appends passed SafeExpr to code or executes Block
		    code(c) {
		        if (typeof c == "function")
		            c();
		        else if (c !== code_1.nil)
		            this._leafNode(new AnyCode(c));
		        return this;
		    }
		    // returns code for object literal for the passed argument list of key-value pairs
		    object(...keyValues) {
		        const code = ["{"];
		        for (const [key, value] of keyValues) {
		            if (code.length > 1)
		                code.push(",");
		            code.push(key);
		            if (key !== value || this.opts.es5) {
		                code.push(":");
		                (0, code_1.addCodeArg)(code, value);
		            }
		        }
		        code.push("}");
		        return new code_1._Code(code);
		    }
		    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
		    if(condition, thenBody, elseBody) {
		        this._blockNode(new If(condition));
		        if (thenBody && elseBody) {
		            this.code(thenBody).else().code(elseBody).endIf();
		        }
		        else if (thenBody) {
		            this.code(thenBody).endIf();
		        }
		        else if (elseBody) {
		            throw new Error('CodeGen: "else" body without "then" body');
		        }
		        return this;
		    }
		    // `else if` clause - invalid without `if` or after `else` clauses
		    elseIf(condition) {
		        return this._elseNode(new If(condition));
		    }
		    // `else` clause - only valid after `if` or `else if` clauses
		    else() {
		        return this._elseNode(new Else());
		    }
		    // end `if` statement (needed if gen.if was used only with condition)
		    endIf() {
		        return this._endBlockNode(If, Else);
		    }
		    _for(node, forBody) {
		        this._blockNode(node);
		        if (forBody)
		            this.code(forBody).endFor();
		        return this;
		    }
		    // a generic `for` clause (or statement if `forBody` is passed)
		    for(iteration, forBody) {
		        return this._for(new ForLoop(iteration), forBody);
		    }
		    // `for` statement for a range of values
		    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.let) {
		        const name = this._scope.toName(nameOrPrefix);
		        return this._for(new ForRange(varKind, name, from, to), () => forBody(name));
		    }
		    // `for-of` statement (in es5 mode replace with a normal for loop)
		    forOf(nameOrPrefix, iterable, forBody, varKind = scope_1.varKinds.const) {
		        const name = this._scope.toName(nameOrPrefix);
		        if (this.opts.es5) {
		            const arr = iterable instanceof code_1.Name ? iterable : this.var("_arr", iterable);
		            return this.forRange("_i", 0, (0, code_1._) `${arr}.length`, (i) => {
		                this.var(name, (0, code_1._) `${arr}[${i}]`);
		                forBody(name);
		            });
		        }
		        return this._for(new ForIter("of", varKind, name, iterable), () => forBody(name));
		    }
		    // `for-in` statement.
		    // With option `ownProperties` replaced with a `for-of` loop for object keys
		    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? scope_1.varKinds.var : scope_1.varKinds.const) {
		        if (this.opts.ownProperties) {
		            return this.forOf(nameOrPrefix, (0, code_1._) `Object.keys(${obj})`, forBody);
		        }
		        const name = this._scope.toName(nameOrPrefix);
		        return this._for(new ForIter("in", varKind, name, obj), () => forBody(name));
		    }
		    // end `for` loop
		    endFor() {
		        return this._endBlockNode(For);
		    }
		    // `label` statement
		    label(label) {
		        return this._leafNode(new Label(label));
		    }
		    // `break` statement
		    break(label) {
		        return this._leafNode(new Break(label));
		    }
		    // `return` statement
		    return(value) {
		        const node = new Return();
		        this._blockNode(node);
		        this.code(value);
		        if (node.nodes.length !== 1)
		            throw new Error('CodeGen: "return" should have one node');
		        return this._endBlockNode(Return);
		    }
		    // `try` statement
		    try(tryBody, catchCode, finallyCode) {
		        if (!catchCode && !finallyCode)
		            throw new Error('CodeGen: "try" without "catch" and "finally"');
		        const node = new Try();
		        this._blockNode(node);
		        this.code(tryBody);
		        if (catchCode) {
		            const error = this.name("e");
		            this._currNode = node.catch = new Catch(error);
		            catchCode(error);
		        }
		        if (finallyCode) {
		            this._currNode = node.finally = new Finally();
		            this.code(finallyCode);
		        }
		        return this._endBlockNode(Catch, Finally);
		    }
		    // `throw` statement
		    throw(error) {
		        return this._leafNode(new Throw(error));
		    }
		    // start self-balancing block
		    block(body, nodeCount) {
		        this._blockStarts.push(this._nodes.length);
		        if (body)
		            this.code(body).endBlock(nodeCount);
		        return this;
		    }
		    // end the current self-balancing block
		    endBlock(nodeCount) {
		        const len = this._blockStarts.pop();
		        if (len === undefined)
		            throw new Error("CodeGen: not in self-balancing block");
		        const toClose = this._nodes.length - len;
		        if (toClose < 0 || (nodeCount !== undefined && toClose !== nodeCount)) {
		            throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
		        }
		        this._nodes.length = len;
		        return this;
		    }
		    // `function` heading (or definition if funcBody is passed)
		    func(name, args = code_1.nil, async, funcBody) {
		        this._blockNode(new Func(name, args, async));
		        if (funcBody)
		            this.code(funcBody).endFunc();
		        return this;
		    }
		    // end function definition
		    endFunc() {
		        return this._endBlockNode(Func);
		    }
		    optimize(n = 1) {
		        while (n-- > 0) {
		            this._root.optimizeNodes();
		            this._root.optimizeNames(this._root.names, this._constants);
		        }
		    }
		    _leafNode(node) {
		        this._currNode.nodes.push(node);
		        return this;
		    }
		    _blockNode(node) {
		        this._currNode.nodes.push(node);
		        this._nodes.push(node);
		    }
		    _endBlockNode(N1, N2) {
		        const n = this._currNode;
		        if (n instanceof N1 || (N2 && n instanceof N2)) {
		            this._nodes.pop();
		            return this;
		        }
		        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
		    }
		    _elseNode(node) {
		        const n = this._currNode;
		        if (!(n instanceof If)) {
		            throw new Error('CodeGen: "else" without "if"');
		        }
		        this._currNode = n.else = node;
		        return this;
		    }
		    get _root() {
		        return this._nodes[0];
		    }
		    get _currNode() {
		        const ns = this._nodes;
		        return ns[ns.length - 1];
		    }
		    set _currNode(node) {
		        const ns = this._nodes;
		        ns[ns.length - 1] = node;
		    }
		}
		exports.CodeGen = CodeGen;
		function addNames(names, from) {
		    for (const n in from)
		        names[n] = (names[n] || 0) + (from[n] || 0);
		    return names;
		}
		function addExprNames(names, from) {
		    return from instanceof code_1._CodeOrName ? addNames(names, from.names) : names;
		}
		function optimizeExpr(expr, names, constants) {
		    if (expr instanceof code_1.Name)
		        return replaceName(expr);
		    if (!canOptimize(expr))
		        return expr;
		    return new code_1._Code(expr._items.reduce((items, c) => {
		        if (c instanceof code_1.Name)
		            c = replaceName(c);
		        if (c instanceof code_1._Code)
		            items.push(...c._items);
		        else
		            items.push(c);
		        return items;
		    }, []));
		    function replaceName(n) {
		        const c = constants[n.str];
		        if (c === undefined || names[n.str] !== 1)
		            return n;
		        delete names[n.str];
		        return c;
		    }
		    function canOptimize(e) {
		        return (e instanceof code_1._Code &&
		            e._items.some((c) => c instanceof code_1.Name && names[c.str] === 1 && constants[c.str] !== undefined));
		    }
		}
		function subtractNames(names, from) {
		    for (const n in from)
		        names[n] = (names[n] || 0) - (from[n] || 0);
		}
		function not(x) {
		    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, code_1._) `!${par(x)}`;
		}
		exports.not = not;
		const andCode = mappend(exports.operators.AND);
		// boolean AND (&&) expression with the passed arguments
		function and(...args) {
		    return args.reduce(andCode);
		}
		exports.and = and;
		const orCode = mappend(exports.operators.OR);
		// boolean OR (||) expression with the passed arguments
		function or(...args) {
		    return args.reduce(orCode);
		}
		exports.or = or;
		function mappend(op) {
		    return (x, y) => (x === code_1.nil ? y : y === code_1.nil ? x : (0, code_1._) `${par(x)} ${op} ${par(y)}`);
		}
		function par(x) {
		    return x instanceof code_1.Name ? x : (0, code_1._) `(${x})`;
		}
		
	} (codegen));
	return codegen;
}

var util = {};

var hasRequiredUtil;

function requireUtil () {
	if (hasRequiredUtil) return util;
	hasRequiredUtil = 1;
	Object.defineProperty(util, "__esModule", { value: true });
	util.checkStrictMode = util.getErrorPath = util.Type = util.useFunc = util.setEvaluated = util.evaluatedPropsToName = util.mergeEvaluated = util.eachItem = util.unescapeJsonPointer = util.escapeJsonPointer = util.escapeFragment = util.unescapeFragment = util.schemaRefOrVal = util.schemaHasRulesButRef = util.schemaHasRules = util.checkUnknownRules = util.alwaysValidSchema = util.toHash = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const code_1 = /*@__PURE__*/ requireCode$1();
	// TODO refactor to use Set
	function toHash(arr) {
	    const hash = {};
	    for (const item of arr)
	        hash[item] = true;
	    return hash;
	}
	util.toHash = toHash;
	function alwaysValidSchema(it, schema) {
	    if (typeof schema == "boolean")
	        return schema;
	    if (Object.keys(schema).length === 0)
	        return true;
	    checkUnknownRules(it, schema);
	    return !schemaHasRules(schema, it.self.RULES.all);
	}
	util.alwaysValidSchema = alwaysValidSchema;
	function checkUnknownRules(it, schema = it.schema) {
	    const { opts, self } = it;
	    if (!opts.strictSchema)
	        return;
	    if (typeof schema === "boolean")
	        return;
	    const rules = self.RULES.keywords;
	    for (const key in schema) {
	        if (!rules[key])
	            checkStrictMode(it, `unknown keyword: "${key}"`);
	    }
	}
	util.checkUnknownRules = checkUnknownRules;
	function schemaHasRules(schema, rules) {
	    if (typeof schema == "boolean")
	        return !schema;
	    for (const key in schema)
	        if (rules[key])
	            return true;
	    return false;
	}
	util.schemaHasRules = schemaHasRules;
	function schemaHasRulesButRef(schema, RULES) {
	    if (typeof schema == "boolean")
	        return !schema;
	    for (const key in schema)
	        if (key !== "$ref" && RULES.all[key])
	            return true;
	    return false;
	}
	util.schemaHasRulesButRef = schemaHasRulesButRef;
	function schemaRefOrVal({ topSchemaRef, schemaPath }, schema, keyword, $data) {
	    if (!$data) {
	        if (typeof schema == "number" || typeof schema == "boolean")
	            return schema;
	        if (typeof schema == "string")
	            return (0, codegen_1._) `${schema}`;
	    }
	    return (0, codegen_1._) `${topSchemaRef}${schemaPath}${(0, codegen_1.getProperty)(keyword)}`;
	}
	util.schemaRefOrVal = schemaRefOrVal;
	function unescapeFragment(str) {
	    return unescapeJsonPointer(decodeURIComponent(str));
	}
	util.unescapeFragment = unescapeFragment;
	function escapeFragment(str) {
	    return encodeURIComponent(escapeJsonPointer(str));
	}
	util.escapeFragment = escapeFragment;
	function escapeJsonPointer(str) {
	    if (typeof str == "number")
	        return `${str}`;
	    return str.replace(/~/g, "~0").replace(/\//g, "~1");
	}
	util.escapeJsonPointer = escapeJsonPointer;
	function unescapeJsonPointer(str) {
	    return str.replace(/~1/g, "/").replace(/~0/g, "~");
	}
	util.unescapeJsonPointer = unescapeJsonPointer;
	function eachItem(xs, f) {
	    if (Array.isArray(xs)) {
	        for (const x of xs)
	            f(x);
	    }
	    else {
	        f(xs);
	    }
	}
	util.eachItem = eachItem;
	function makeMergeEvaluated({ mergeNames, mergeToName, mergeValues, resultToName, }) {
	    return (gen, from, to, toName) => {
	        const res = to === undefined
	            ? from
	            : to instanceof codegen_1.Name
	                ? (from instanceof codegen_1.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to)
	                : from instanceof codegen_1.Name
	                    ? (mergeToName(gen, to, from), from)
	                    : mergeValues(from, to);
	        return toName === codegen_1.Name && !(res instanceof codegen_1.Name) ? resultToName(gen, res) : res;
	    };
	}
	util.mergeEvaluated = {
	    props: makeMergeEvaluated({
	        mergeNames: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true && ${from} !== undefined`, () => {
	            gen.if((0, codegen_1._) `${from} === true`, () => gen.assign(to, true), () => gen.assign(to, (0, codegen_1._) `${to} || {}`).code((0, codegen_1._) `Object.assign(${to}, ${from})`));
	        }),
	        mergeToName: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true`, () => {
	            if (from === true) {
	                gen.assign(to, true);
	            }
	            else {
	                gen.assign(to, (0, codegen_1._) `${to} || {}`);
	                setEvaluated(gen, to, from);
	            }
	        }),
	        mergeValues: (from, to) => (from === true ? true : { ...from, ...to }),
	        resultToName: evaluatedPropsToName,
	    }),
	    items: makeMergeEvaluated({
	        mergeNames: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true && ${from} !== undefined`, () => gen.assign(to, (0, codegen_1._) `${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
	        mergeToName: (gen, from, to) => gen.if((0, codegen_1._) `${to} !== true`, () => gen.assign(to, from === true ? true : (0, codegen_1._) `${to} > ${from} ? ${to} : ${from}`)),
	        mergeValues: (from, to) => (from === true ? true : Math.max(from, to)),
	        resultToName: (gen, items) => gen.var("items", items),
	    }),
	};
	function evaluatedPropsToName(gen, ps) {
	    if (ps === true)
	        return gen.var("props", true);
	    const props = gen.var("props", (0, codegen_1._) `{}`);
	    if (ps !== undefined)
	        setEvaluated(gen, props, ps);
	    return props;
	}
	util.evaluatedPropsToName = evaluatedPropsToName;
	function setEvaluated(gen, props, ps) {
	    Object.keys(ps).forEach((p) => gen.assign((0, codegen_1._) `${props}${(0, codegen_1.getProperty)(p)}`, true));
	}
	util.setEvaluated = setEvaluated;
	const snippets = {};
	function useFunc(gen, f) {
	    return gen.scopeValue("func", {
	        ref: f,
	        code: snippets[f.code] || (snippets[f.code] = new code_1._Code(f.code)),
	    });
	}
	util.useFunc = useFunc;
	var Type;
	(function (Type) {
	    Type[Type["Num"] = 0] = "Num";
	    Type[Type["Str"] = 1] = "Str";
	})(Type || (util.Type = Type = {}));
	function getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
	    // let path
	    if (dataProp instanceof codegen_1.Name) {
	        const isNumber = dataPropType === Type.Num;
	        return jsPropertySyntax
	            ? isNumber
	                ? (0, codegen_1._) `"[" + ${dataProp} + "]"`
	                : (0, codegen_1._) `"['" + ${dataProp} + "']"`
	            : isNumber
	                ? (0, codegen_1._) `"/" + ${dataProp}`
	                : (0, codegen_1._) `"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
	    }
	    return jsPropertySyntax ? (0, codegen_1.getProperty)(dataProp).toString() : "/" + escapeJsonPointer(dataProp);
	}
	util.getErrorPath = getErrorPath;
	function checkStrictMode(it, msg, mode = it.opts.strictSchema) {
	    if (!mode)
	        return;
	    msg = `strict mode: ${msg}`;
	    if (mode === true)
	        throw new Error(msg);
	    it.self.logger.warn(msg);
	}
	util.checkStrictMode = checkStrictMode;
	
	return util;
}

var names = {};

var hasRequiredNames;

function requireNames () {
	if (hasRequiredNames) return names;
	hasRequiredNames = 1;
	Object.defineProperty(names, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const names$1 = {
	    // validation function arguments
	    data: new codegen_1.Name("data"), // data passed to validation function
	    // args passed from referencing schema
	    valCxt: new codegen_1.Name("valCxt"), // validation/data context - should not be used directly, it is destructured to the names below
	    instancePath: new codegen_1.Name("instancePath"),
	    parentData: new codegen_1.Name("parentData"),
	    parentDataProperty: new codegen_1.Name("parentDataProperty"),
	    rootData: new codegen_1.Name("rootData"), // root data - same as the data passed to the first/top validation function
	    dynamicAnchors: new codegen_1.Name("dynamicAnchors"), // used to support recursiveRef and dynamicRef
	    // function scoped variables
	    vErrors: new codegen_1.Name("vErrors"), // null or array of validation errors
	    errors: new codegen_1.Name("errors"), // counter of validation errors
	    this: new codegen_1.Name("this"),
	    // "globals"
	    self: new codegen_1.Name("self"),
	    scope: new codegen_1.Name("scope"),
	    // JTD serialize/parse name for JSON string and position
	    json: new codegen_1.Name("json"),
	    jsonPos: new codegen_1.Name("jsonPos"),
	    jsonLen: new codegen_1.Name("jsonLen"),
	    jsonPart: new codegen_1.Name("jsonPart"),
	};
	names.default = names$1;
	
	return names;
}

var hasRequiredErrors;

function requireErrors () {
	if (hasRequiredErrors) return errors;
	hasRequiredErrors = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.extendErrors = exports.resetErrorsCount = exports.reportExtraError = exports.reportError = exports.keyword$DataError = exports.keywordError = void 0;
		const codegen_1 = /*@__PURE__*/ requireCodegen();
		const util_1 = /*@__PURE__*/ requireUtil();
		const names_1 = /*@__PURE__*/ requireNames();
		exports.keywordError = {
		    message: ({ keyword }) => (0, codegen_1.str) `must pass "${keyword}" keyword validation`,
		};
		exports.keyword$DataError = {
		    message: ({ keyword, schemaType }) => schemaType
		        ? (0, codegen_1.str) `"${keyword}" keyword must be ${schemaType} ($data)`
		        : (0, codegen_1.str) `"${keyword}" keyword is invalid ($data)`,
		};
		function reportError(cxt, error = exports.keywordError, errorPaths, overrideAllErrors) {
		    const { it } = cxt;
		    const { gen, compositeRule, allErrors } = it;
		    const errObj = errorObjectCode(cxt, error, errorPaths);
		    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : (compositeRule || allErrors)) {
		        addError(gen, errObj);
		    }
		    else {
		        returnErrors(it, (0, codegen_1._) `[${errObj}]`);
		    }
		}
		exports.reportError = reportError;
		function reportExtraError(cxt, error = exports.keywordError, errorPaths) {
		    const { it } = cxt;
		    const { gen, compositeRule, allErrors } = it;
		    const errObj = errorObjectCode(cxt, error, errorPaths);
		    addError(gen, errObj);
		    if (!(compositeRule || allErrors)) {
		        returnErrors(it, names_1.default.vErrors);
		    }
		}
		exports.reportExtraError = reportExtraError;
		function resetErrorsCount(gen, errsCount) {
		    gen.assign(names_1.default.errors, errsCount);
		    gen.if((0, codegen_1._) `${names_1.default.vErrors} !== null`, () => gen.if(errsCount, () => gen.assign((0, codegen_1._) `${names_1.default.vErrors}.length`, errsCount), () => gen.assign(names_1.default.vErrors, null)));
		}
		exports.resetErrorsCount = resetErrorsCount;
		function extendErrors({ gen, keyword, schemaValue, data, errsCount, it, }) {
		    /* istanbul ignore if */
		    if (errsCount === undefined)
		        throw new Error("ajv implementation error");
		    const err = gen.name("err");
		    gen.forRange("i", errsCount, names_1.default.errors, (i) => {
		        gen.const(err, (0, codegen_1._) `${names_1.default.vErrors}[${i}]`);
		        gen.if((0, codegen_1._) `${err}.instancePath === undefined`, () => gen.assign((0, codegen_1._) `${err}.instancePath`, (0, codegen_1.strConcat)(names_1.default.instancePath, it.errorPath)));
		        gen.assign((0, codegen_1._) `${err}.schemaPath`, (0, codegen_1.str) `${it.errSchemaPath}/${keyword}`);
		        if (it.opts.verbose) {
		            gen.assign((0, codegen_1._) `${err}.schema`, schemaValue);
		            gen.assign((0, codegen_1._) `${err}.data`, data);
		        }
		    });
		}
		exports.extendErrors = extendErrors;
		function addError(gen, errObj) {
		    const err = gen.const("err", errObj);
		    gen.if((0, codegen_1._) `${names_1.default.vErrors} === null`, () => gen.assign(names_1.default.vErrors, (0, codegen_1._) `[${err}]`), (0, codegen_1._) `${names_1.default.vErrors}.push(${err})`);
		    gen.code((0, codegen_1._) `${names_1.default.errors}++`);
		}
		function returnErrors(it, errs) {
		    const { gen, validateName, schemaEnv } = it;
		    if (schemaEnv.$async) {
		        gen.throw((0, codegen_1._) `new ${it.ValidationError}(${errs})`);
		    }
		    else {
		        gen.assign((0, codegen_1._) `${validateName}.errors`, errs);
		        gen.return(false);
		    }
		}
		const E = {
		    keyword: new codegen_1.Name("keyword"),
		    schemaPath: new codegen_1.Name("schemaPath"), // also used in JTD errors
		    params: new codegen_1.Name("params"),
		    propertyName: new codegen_1.Name("propertyName"),
		    message: new codegen_1.Name("message"),
		    schema: new codegen_1.Name("schema"),
		    parentSchema: new codegen_1.Name("parentSchema"),
		};
		function errorObjectCode(cxt, error, errorPaths) {
		    const { createErrors } = cxt.it;
		    if (createErrors === false)
		        return (0, codegen_1._) `{}`;
		    return errorObject(cxt, error, errorPaths);
		}
		function errorObject(cxt, error, errorPaths = {}) {
		    const { gen, it } = cxt;
		    const keyValues = [
		        errorInstancePath(it, errorPaths),
		        errorSchemaPath(cxt, errorPaths),
		    ];
		    extraErrorProps(cxt, error, keyValues);
		    return gen.object(...keyValues);
		}
		function errorInstancePath({ errorPath }, { instancePath }) {
		    const instPath = instancePath
		        ? (0, codegen_1.str) `${errorPath}${(0, util_1.getErrorPath)(instancePath, util_1.Type.Str)}`
		        : errorPath;
		    return [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, instPath)];
		}
		function errorSchemaPath({ keyword, it: { errSchemaPath } }, { schemaPath, parentSchema }) {
		    let schPath = parentSchema ? errSchemaPath : (0, codegen_1.str) `${errSchemaPath}/${keyword}`;
		    if (schemaPath) {
		        schPath = (0, codegen_1.str) `${schPath}${(0, util_1.getErrorPath)(schemaPath, util_1.Type.Str)}`;
		    }
		    return [E.schemaPath, schPath];
		}
		function extraErrorProps(cxt, { params, message }, keyValues) {
		    const { keyword, data, schemaValue, it } = cxt;
		    const { opts, propertyName, topSchemaRef, schemaPath } = it;
		    keyValues.push([E.keyword, keyword], [E.params, typeof params == "function" ? params(cxt) : params || (0, codegen_1._) `{}`]);
		    if (opts.messages) {
		        keyValues.push([E.message, typeof message == "function" ? message(cxt) : message]);
		    }
		    if (opts.verbose) {
		        keyValues.push([E.schema, schemaValue], [E.parentSchema, (0, codegen_1._) `${topSchemaRef}${schemaPath}`], [names_1.default.data, data]);
		    }
		    if (propertyName)
		        keyValues.push([E.propertyName, propertyName]);
		}
		
	} (errors));
	return errors;
}

var hasRequiredBoolSchema;

function requireBoolSchema () {
	if (hasRequiredBoolSchema) return boolSchema;
	hasRequiredBoolSchema = 1;
	Object.defineProperty(boolSchema, "__esModule", { value: true });
	boolSchema.boolOrEmptySchema = boolSchema.topBoolOrEmptySchema = void 0;
	const errors_1 = /*@__PURE__*/ requireErrors();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const names_1 = /*@__PURE__*/ requireNames();
	const boolError = {
	    message: "boolean schema is false",
	};
	function topBoolOrEmptySchema(it) {
	    const { gen, schema, validateName } = it;
	    if (schema === false) {
	        falseSchemaError(it, false);
	    }
	    else if (typeof schema == "object" && schema.$async === true) {
	        gen.return(names_1.default.data);
	    }
	    else {
	        gen.assign((0, codegen_1._) `${validateName}.errors`, null);
	        gen.return(true);
	    }
	}
	boolSchema.topBoolOrEmptySchema = topBoolOrEmptySchema;
	function boolOrEmptySchema(it, valid) {
	    const { gen, schema } = it;
	    if (schema === false) {
	        gen.var(valid, false); // TODO var
	        falseSchemaError(it);
	    }
	    else {
	        gen.var(valid, true); // TODO var
	    }
	}
	boolSchema.boolOrEmptySchema = boolOrEmptySchema;
	function falseSchemaError(it, overrideAllErrors) {
	    const { gen, data } = it;
	    // TODO maybe some other interface should be used for non-keyword validation errors...
	    const cxt = {
	        gen,
	        keyword: "false schema",
	        data,
	        schema: false,
	        schemaCode: false,
	        schemaValue: false,
	        params: {},
	        it,
	    };
	    (0, errors_1.reportError)(cxt, boolError, undefined, overrideAllErrors);
	}
	
	return boolSchema;
}

var dataType = {};

var rules = {};

var hasRequiredRules;

function requireRules () {
	if (hasRequiredRules) return rules;
	hasRequiredRules = 1;
	Object.defineProperty(rules, "__esModule", { value: true });
	rules.getRules = rules.isJSONType = void 0;
	const _jsonTypes = ["string", "number", "integer", "boolean", "null", "object", "array"];
	const jsonTypes = new Set(_jsonTypes);
	function isJSONType(x) {
	    return typeof x == "string" && jsonTypes.has(x);
	}
	rules.isJSONType = isJSONType;
	function getRules() {
	    const groups = {
	        number: { type: "number", rules: [] },
	        string: { type: "string", rules: [] },
	        array: { type: "array", rules: [] },
	        object: { type: "object", rules: [] },
	    };
	    return {
	        types: { ...groups, integer: true, boolean: true, null: true },
	        rules: [{ rules: [] }, groups.number, groups.string, groups.array, groups.object],
	        post: { rules: [] },
	        all: {},
	        keywords: {},
	    };
	}
	rules.getRules = getRules;
	
	return rules;
}

var applicability = {};

var hasRequiredApplicability;

function requireApplicability () {
	if (hasRequiredApplicability) return applicability;
	hasRequiredApplicability = 1;
	Object.defineProperty(applicability, "__esModule", { value: true });
	applicability.shouldUseRule = applicability.shouldUseGroup = applicability.schemaHasRulesForType = void 0;
	function schemaHasRulesForType({ schema, self }, type) {
	    const group = self.RULES.types[type];
	    return group && group !== true && shouldUseGroup(schema, group);
	}
	applicability.schemaHasRulesForType = schemaHasRulesForType;
	function shouldUseGroup(schema, group) {
	    return group.rules.some((rule) => shouldUseRule(schema, rule));
	}
	applicability.shouldUseGroup = shouldUseGroup;
	function shouldUseRule(schema, rule) {
	    var _a;
	    return (schema[rule.keyword] !== undefined ||
	        ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd) => schema[kwd] !== undefined)));
	}
	applicability.shouldUseRule = shouldUseRule;
	
	return applicability;
}

var hasRequiredDataType;

function requireDataType () {
	if (hasRequiredDataType) return dataType;
	hasRequiredDataType = 1;
	Object.defineProperty(dataType, "__esModule", { value: true });
	dataType.reportTypeError = dataType.checkDataTypes = dataType.checkDataType = dataType.coerceAndCheckDataType = dataType.getJSONTypes = dataType.getSchemaTypes = dataType.DataType = void 0;
	const rules_1 = /*@__PURE__*/ requireRules();
	const applicability_1 = /*@__PURE__*/ requireApplicability();
	const errors_1 = /*@__PURE__*/ requireErrors();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	var DataType;
	(function (DataType) {
	    DataType[DataType["Correct"] = 0] = "Correct";
	    DataType[DataType["Wrong"] = 1] = "Wrong";
	})(DataType || (dataType.DataType = DataType = {}));
	function getSchemaTypes(schema) {
	    const types = getJSONTypes(schema.type);
	    const hasNull = types.includes("null");
	    if (hasNull) {
	        if (schema.nullable === false)
	            throw new Error("type: null contradicts nullable: false");
	    }
	    else {
	        if (!types.length && schema.nullable !== undefined) {
	            throw new Error('"nullable" cannot be used without "type"');
	        }
	        if (schema.nullable === true)
	            types.push("null");
	    }
	    return types;
	}
	dataType.getSchemaTypes = getSchemaTypes;
	// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
	function getJSONTypes(ts) {
	    const types = Array.isArray(ts) ? ts : ts ? [ts] : [];
	    if (types.every(rules_1.isJSONType))
	        return types;
	    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
	}
	dataType.getJSONTypes = getJSONTypes;
	function coerceAndCheckDataType(it, types) {
	    const { gen, data, opts } = it;
	    const coerceTo = coerceToTypes(types, opts.coerceTypes);
	    const checkTypes = types.length > 0 &&
	        !(coerceTo.length === 0 && types.length === 1 && (0, applicability_1.schemaHasRulesForType)(it, types[0]));
	    if (checkTypes) {
	        const wrongType = checkDataTypes(types, data, opts.strictNumbers, DataType.Wrong);
	        gen.if(wrongType, () => {
	            if (coerceTo.length)
	                coerceData(it, types, coerceTo);
	            else
	                reportTypeError(it);
	        });
	    }
	    return checkTypes;
	}
	dataType.coerceAndCheckDataType = coerceAndCheckDataType;
	const COERCIBLE = new Set(["string", "number", "integer", "boolean", "null"]);
	function coerceToTypes(types, coerceTypes) {
	    return coerceTypes
	        ? types.filter((t) => COERCIBLE.has(t) || (coerceTypes === "array" && t === "array"))
	        : [];
	}
	function coerceData(it, types, coerceTo) {
	    const { gen, data, opts } = it;
	    const dataType = gen.let("dataType", (0, codegen_1._) `typeof ${data}`);
	    const coerced = gen.let("coerced", (0, codegen_1._) `undefined`);
	    if (opts.coerceTypes === "array") {
	        gen.if((0, codegen_1._) `${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, () => gen
	            .assign(data, (0, codegen_1._) `${data}[0]`)
	            .assign(dataType, (0, codegen_1._) `typeof ${data}`)
	            .if(checkDataTypes(types, data, opts.strictNumbers), () => gen.assign(coerced, data)));
	    }
	    gen.if((0, codegen_1._) `${coerced} !== undefined`);
	    for (const t of coerceTo) {
	        if (COERCIBLE.has(t) || (t === "array" && opts.coerceTypes === "array")) {
	            coerceSpecificType(t);
	        }
	    }
	    gen.else();
	    reportTypeError(it);
	    gen.endIf();
	    gen.if((0, codegen_1._) `${coerced} !== undefined`, () => {
	        gen.assign(data, coerced);
	        assignParentData(it, coerced);
	    });
	    function coerceSpecificType(t) {
	        switch (t) {
	            case "string":
	                gen
	                    .elseIf((0, codegen_1._) `${dataType} == "number" || ${dataType} == "boolean"`)
	                    .assign(coerced, (0, codegen_1._) `"" + ${data}`)
	                    .elseIf((0, codegen_1._) `${data} === null`)
	                    .assign(coerced, (0, codegen_1._) `""`);
	                return;
	            case "number":
	                gen
	                    .elseIf((0, codegen_1._) `${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`)
	                    .assign(coerced, (0, codegen_1._) `+${data}`);
	                return;
	            case "integer":
	                gen
	                    .elseIf((0, codegen_1._) `${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`)
	                    .assign(coerced, (0, codegen_1._) `+${data}`);
	                return;
	            case "boolean":
	                gen
	                    .elseIf((0, codegen_1._) `${data} === "false" || ${data} === 0 || ${data} === null`)
	                    .assign(coerced, false)
	                    .elseIf((0, codegen_1._) `${data} === "true" || ${data} === 1`)
	                    .assign(coerced, true);
	                return;
	            case "null":
	                gen.elseIf((0, codegen_1._) `${data} === "" || ${data} === 0 || ${data} === false`);
	                gen.assign(coerced, null);
	                return;
	            case "array":
	                gen
	                    .elseIf((0, codegen_1._) `${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`)
	                    .assign(coerced, (0, codegen_1._) `[${data}]`);
	        }
	    }
	}
	function assignParentData({ gen, parentData, parentDataProperty }, expr) {
	    // TODO use gen.property
	    gen.if((0, codegen_1._) `${parentData} !== undefined`, () => gen.assign((0, codegen_1._) `${parentData}[${parentDataProperty}]`, expr));
	}
	function checkDataType(dataType, data, strictNums, correct = DataType.Correct) {
	    const EQ = correct === DataType.Correct ? codegen_1.operators.EQ : codegen_1.operators.NEQ;
	    let cond;
	    switch (dataType) {
	        case "null":
	            return (0, codegen_1._) `${data} ${EQ} null`;
	        case "array":
	            cond = (0, codegen_1._) `Array.isArray(${data})`;
	            break;
	        case "object":
	            cond = (0, codegen_1._) `${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
	            break;
	        case "integer":
	            cond = numCond((0, codegen_1._) `!(${data} % 1) && !isNaN(${data})`);
	            break;
	        case "number":
	            cond = numCond();
	            break;
	        default:
	            return (0, codegen_1._) `typeof ${data} ${EQ} ${dataType}`;
	    }
	    return correct === DataType.Correct ? cond : (0, codegen_1.not)(cond);
	    function numCond(_cond = codegen_1.nil) {
	        return (0, codegen_1.and)((0, codegen_1._) `typeof ${data} == "number"`, _cond, strictNums ? (0, codegen_1._) `isFinite(${data})` : codegen_1.nil);
	    }
	}
	dataType.checkDataType = checkDataType;
	function checkDataTypes(dataTypes, data, strictNums, correct) {
	    if (dataTypes.length === 1) {
	        return checkDataType(dataTypes[0], data, strictNums, correct);
	    }
	    let cond;
	    const types = (0, util_1.toHash)(dataTypes);
	    if (types.array && types.object) {
	        const notObj = (0, codegen_1._) `typeof ${data} != "object"`;
	        cond = types.null ? notObj : (0, codegen_1._) `!${data} || ${notObj}`;
	        delete types.null;
	        delete types.array;
	        delete types.object;
	    }
	    else {
	        cond = codegen_1.nil;
	    }
	    if (types.number)
	        delete types.integer;
	    for (const t in types)
	        cond = (0, codegen_1.and)(cond, checkDataType(t, data, strictNums, correct));
	    return cond;
	}
	dataType.checkDataTypes = checkDataTypes;
	const typeError = {
	    message: ({ schema }) => `must be ${schema}`,
	    params: ({ schema, schemaValue }) => typeof schema == "string" ? (0, codegen_1._) `{type: ${schema}}` : (0, codegen_1._) `{type: ${schemaValue}}`,
	};
	function reportTypeError(it) {
	    const cxt = getTypeErrorContext(it);
	    (0, errors_1.reportError)(cxt, typeError);
	}
	dataType.reportTypeError = reportTypeError;
	function getTypeErrorContext(it) {
	    const { gen, data, schema } = it;
	    const schemaCode = (0, util_1.schemaRefOrVal)(it, schema, "type");
	    return {
	        gen,
	        keyword: "type",
	        data,
	        schema: schema.type,
	        schemaCode,
	        schemaValue: schemaCode,
	        parentSchema: schema,
	        params: {},
	        it,
	    };
	}
	
	return dataType;
}

var defaults = {};

var hasRequiredDefaults;

function requireDefaults () {
	if (hasRequiredDefaults) return defaults;
	hasRequiredDefaults = 1;
	Object.defineProperty(defaults, "__esModule", { value: true });
	defaults.assignDefaults = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	function assignDefaults(it, ty) {
	    const { properties, items } = it.schema;
	    if (ty === "object" && properties) {
	        for (const key in properties) {
	            assignDefault(it, key, properties[key].default);
	        }
	    }
	    else if (ty === "array" && Array.isArray(items)) {
	        items.forEach((sch, i) => assignDefault(it, i, sch.default));
	    }
	}
	defaults.assignDefaults = assignDefaults;
	function assignDefault(it, prop, defaultValue) {
	    const { gen, compositeRule, data, opts } = it;
	    if (defaultValue === undefined)
	        return;
	    const childData = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(prop)}`;
	    if (compositeRule) {
	        (0, util_1.checkStrictMode)(it, `default is ignored for: ${childData}`);
	        return;
	    }
	    let condition = (0, codegen_1._) `${childData} === undefined`;
	    if (opts.useDefaults === "empty") {
	        condition = (0, codegen_1._) `${condition} || ${childData} === null || ${childData} === ""`;
	    }
	    // `${childData} === undefined` +
	    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
	    gen.if(condition, (0, codegen_1._) `${childData} = ${(0, codegen_1.stringify)(defaultValue)}`);
	}
	
	return defaults;
}

var keyword = {};

var code = {};

var hasRequiredCode;

function requireCode () {
	if (hasRequiredCode) return code;
	hasRequiredCode = 1;
	Object.defineProperty(code, "__esModule", { value: true });
	code.validateUnion = code.validateArray = code.usePattern = code.callValidateCode = code.schemaProperties = code.allSchemaProperties = code.noPropertyInData = code.propertyInData = code.isOwnProperty = code.hasPropFunc = code.reportMissingProp = code.checkMissingProp = code.checkReportMissingProp = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const names_1 = /*@__PURE__*/ requireNames();
	const util_2 = /*@__PURE__*/ requireUtil();
	function checkReportMissingProp(cxt, prop) {
	    const { gen, data, it } = cxt;
	    gen.if(noPropertyInData(gen, data, prop, it.opts.ownProperties), () => {
	        cxt.setParams({ missingProperty: (0, codegen_1._) `${prop}` }, true);
	        cxt.error();
	    });
	}
	code.checkReportMissingProp = checkReportMissingProp;
	function checkMissingProp({ gen, data, it: { opts } }, properties, missing) {
	    return (0, codegen_1.or)(...properties.map((prop) => (0, codegen_1.and)(noPropertyInData(gen, data, prop, opts.ownProperties), (0, codegen_1._) `${missing} = ${prop}`)));
	}
	code.checkMissingProp = checkMissingProp;
	function reportMissingProp(cxt, missing) {
	    cxt.setParams({ missingProperty: missing }, true);
	    cxt.error();
	}
	code.reportMissingProp = reportMissingProp;
	function hasPropFunc(gen) {
	    return gen.scopeValue("func", {
	        // eslint-disable-next-line @typescript-eslint/unbound-method
	        ref: Object.prototype.hasOwnProperty,
	        code: (0, codegen_1._) `Object.prototype.hasOwnProperty`,
	    });
	}
	code.hasPropFunc = hasPropFunc;
	function isOwnProperty(gen, data, property) {
	    return (0, codegen_1._) `${hasPropFunc(gen)}.call(${data}, ${property})`;
	}
	code.isOwnProperty = isOwnProperty;
	function propertyInData(gen, data, property, ownProperties) {
	    const cond = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(property)} !== undefined`;
	    return ownProperties ? (0, codegen_1._) `${cond} && ${isOwnProperty(gen, data, property)}` : cond;
	}
	code.propertyInData = propertyInData;
	function noPropertyInData(gen, data, property, ownProperties) {
	    const cond = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(property)} === undefined`;
	    return ownProperties ? (0, codegen_1.or)(cond, (0, codegen_1.not)(isOwnProperty(gen, data, property))) : cond;
	}
	code.noPropertyInData = noPropertyInData;
	function allSchemaProperties(schemaMap) {
	    return schemaMap ? Object.keys(schemaMap).filter((p) => p !== "__proto__") : [];
	}
	code.allSchemaProperties = allSchemaProperties;
	function schemaProperties(it, schemaMap) {
	    return allSchemaProperties(schemaMap).filter((p) => !(0, util_1.alwaysValidSchema)(it, schemaMap[p]));
	}
	code.schemaProperties = schemaProperties;
	function callValidateCode({ schemaCode, data, it: { gen, topSchemaRef, schemaPath, errorPath }, it }, func, context, passSchema) {
	    const dataAndSchema = passSchema ? (0, codegen_1._) `${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
	    const valCxt = [
	        [names_1.default.instancePath, (0, codegen_1.strConcat)(names_1.default.instancePath, errorPath)],
	        [names_1.default.parentData, it.parentData],
	        [names_1.default.parentDataProperty, it.parentDataProperty],
	        [names_1.default.rootData, names_1.default.rootData],
	    ];
	    if (it.opts.dynamicRef)
	        valCxt.push([names_1.default.dynamicAnchors, names_1.default.dynamicAnchors]);
	    const args = (0, codegen_1._) `${dataAndSchema}, ${gen.object(...valCxt)}`;
	    return context !== codegen_1.nil ? (0, codegen_1._) `${func}.call(${context}, ${args})` : (0, codegen_1._) `${func}(${args})`;
	}
	code.callValidateCode = callValidateCode;
	const newRegExp = (0, codegen_1._) `new RegExp`;
	function usePattern({ gen, it: { opts } }, pattern) {
	    const u = opts.unicodeRegExp ? "u" : "";
	    const { regExp } = opts.code;
	    const rx = regExp(pattern, u);
	    return gen.scopeValue("pattern", {
	        key: rx.toString(),
	        ref: rx,
	        code: (0, codegen_1._) `${regExp.code === "new RegExp" ? newRegExp : (0, util_2.useFunc)(gen, regExp)}(${pattern}, ${u})`,
	    });
	}
	code.usePattern = usePattern;
	function validateArray(cxt) {
	    const { gen, data, keyword, it } = cxt;
	    const valid = gen.name("valid");
	    if (it.allErrors) {
	        const validArr = gen.let("valid", true);
	        validateItems(() => gen.assign(validArr, false));
	        return validArr;
	    }
	    gen.var(valid, true);
	    validateItems(() => gen.break());
	    return valid;
	    function validateItems(notValid) {
	        const len = gen.const("len", (0, codegen_1._) `${data}.length`);
	        gen.forRange("i", 0, len, (i) => {
	            cxt.subschema({
	                keyword,
	                dataProp: i,
	                dataPropType: util_1.Type.Num,
	            }, valid);
	            gen.if((0, codegen_1.not)(valid), notValid);
	        });
	    }
	}
	code.validateArray = validateArray;
	function validateUnion(cxt) {
	    const { gen, schema, keyword, it } = cxt;
	    /* istanbul ignore if */
	    if (!Array.isArray(schema))
	        throw new Error("ajv implementation error");
	    const alwaysValid = schema.some((sch) => (0, util_1.alwaysValidSchema)(it, sch));
	    if (alwaysValid && !it.opts.unevaluated)
	        return;
	    const valid = gen.let("valid", false);
	    const schValid = gen.name("_valid");
	    gen.block(() => schema.forEach((_sch, i) => {
	        const schCxt = cxt.subschema({
	            keyword,
	            schemaProp: i,
	            compositeRule: true,
	        }, schValid);
	        gen.assign(valid, (0, codegen_1._) `${valid} || ${schValid}`);
	        const merged = cxt.mergeValidEvaluated(schCxt, schValid);
	        // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
	        // or if all properties and items were evaluated (it.props === true && it.items === true)
	        if (!merged)
	            gen.if((0, codegen_1.not)(valid));
	    }));
	    cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
	}
	code.validateUnion = validateUnion;
	
	return code;
}

var hasRequiredKeyword;

function requireKeyword () {
	if (hasRequiredKeyword) return keyword;
	hasRequiredKeyword = 1;
	Object.defineProperty(keyword, "__esModule", { value: true });
	keyword.validateKeywordUsage = keyword.validSchemaType = keyword.funcKeywordCode = keyword.macroKeywordCode = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const names_1 = /*@__PURE__*/ requireNames();
	const code_1 = /*@__PURE__*/ requireCode();
	const errors_1 = /*@__PURE__*/ requireErrors();
	function macroKeywordCode(cxt, def) {
	    const { gen, keyword, schema, parentSchema, it } = cxt;
	    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
	    const schemaRef = useKeyword(gen, keyword, macroSchema);
	    if (it.opts.validateSchema !== false)
	        it.self.validateSchema(macroSchema, true);
	    const valid = gen.name("valid");
	    cxt.subschema({
	        schema: macroSchema,
	        schemaPath: codegen_1.nil,
	        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
	        topSchemaRef: schemaRef,
	        compositeRule: true,
	    }, valid);
	    cxt.pass(valid, () => cxt.error(true));
	}
	keyword.macroKeywordCode = macroKeywordCode;
	function funcKeywordCode(cxt, def) {
	    var _a;
	    const { gen, keyword, schema, parentSchema, $data, it } = cxt;
	    checkAsyncKeyword(it, def);
	    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
	    const validateRef = useKeyword(gen, keyword, validate);
	    const valid = gen.let("valid");
	    cxt.block$data(valid, validateKeyword);
	    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
	    function validateKeyword() {
	        if (def.errors === false) {
	            assignValid();
	            if (def.modifying)
	                modifyData(cxt);
	            reportErrs(() => cxt.error());
	        }
	        else {
	            const ruleErrs = def.async ? validateAsync() : validateSync();
	            if (def.modifying)
	                modifyData(cxt);
	            reportErrs(() => addErrs(cxt, ruleErrs));
	        }
	    }
	    function validateAsync() {
	        const ruleErrs = gen.let("ruleErrs", null);
	        gen.try(() => assignValid((0, codegen_1._) `await `), (e) => gen.assign(valid, false).if((0, codegen_1._) `${e} instanceof ${it.ValidationError}`, () => gen.assign(ruleErrs, (0, codegen_1._) `${e}.errors`), () => gen.throw(e)));
	        return ruleErrs;
	    }
	    function validateSync() {
	        const validateErrs = (0, codegen_1._) `${validateRef}.errors`;
	        gen.assign(validateErrs, null);
	        assignValid(codegen_1.nil);
	        return validateErrs;
	    }
	    function assignValid(_await = def.async ? (0, codegen_1._) `await ` : codegen_1.nil) {
	        const passCxt = it.opts.passContext ? names_1.default.this : names_1.default.self;
	        const passSchema = !(("compile" in def && !$data) || def.schema === false);
	        gen.assign(valid, (0, codegen_1._) `${_await}${(0, code_1.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
	    }
	    function reportErrs(errors) {
	        var _a;
	        gen.if((0, codegen_1.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
	    }
	}
	keyword.funcKeywordCode = funcKeywordCode;
	function modifyData(cxt) {
	    const { gen, data, it } = cxt;
	    gen.if(it.parentData, () => gen.assign(data, (0, codegen_1._) `${it.parentData}[${it.parentDataProperty}]`));
	}
	function addErrs(cxt, errs) {
	    const { gen } = cxt;
	    gen.if((0, codegen_1._) `Array.isArray(${errs})`, () => {
	        gen
	            .assign(names_1.default.vErrors, (0, codegen_1._) `${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`)
	            .assign(names_1.default.errors, (0, codegen_1._) `${names_1.default.vErrors}.length`);
	        (0, errors_1.extendErrors)(cxt);
	    }, () => cxt.error());
	}
	function checkAsyncKeyword({ schemaEnv }, def) {
	    if (def.async && !schemaEnv.$async)
	        throw new Error("async keyword in sync schema");
	}
	function useKeyword(gen, keyword, result) {
	    if (result === undefined)
	        throw new Error(`keyword "${keyword}" failed to compile`);
	    return gen.scopeValue("keyword", typeof result == "function" ? { ref: result } : { ref: result, code: (0, codegen_1.stringify)(result) });
	}
	function validSchemaType(schema, schemaType, allowUndefined = false) {
	    // TODO add tests
	    return (!schemaType.length ||
	        schemaType.some((st) => st === "array"
	            ? Array.isArray(schema)
	            : st === "object"
	                ? schema && typeof schema == "object" && !Array.isArray(schema)
	                : typeof schema == st || (allowUndefined && typeof schema == "undefined")));
	}
	keyword.validSchemaType = validSchemaType;
	function validateKeywordUsage({ schema, opts, self, errSchemaPath }, def, keyword) {
	    /* istanbul ignore if */
	    if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) {
	        throw new Error("ajv implementation error");
	    }
	    const deps = def.dependencies;
	    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd) => !Object.prototype.hasOwnProperty.call(schema, kwd))) {
	        throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
	    }
	    if (def.validateSchema) {
	        const valid = def.validateSchema(schema[keyword]);
	        if (!valid) {
	            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` +
	                self.errorsText(def.validateSchema.errors);
	            if (opts.validateSchema === "log")
	                self.logger.error(msg);
	            else
	                throw new Error(msg);
	        }
	    }
	}
	keyword.validateKeywordUsage = validateKeywordUsage;
	
	return keyword;
}

var subschema = {};

var hasRequiredSubschema;

function requireSubschema () {
	if (hasRequiredSubschema) return subschema;
	hasRequiredSubschema = 1;
	Object.defineProperty(subschema, "__esModule", { value: true });
	subschema.extendSubschemaMode = subschema.extendSubschemaData = subschema.getSubschema = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	function getSubschema(it, { keyword, schemaProp, schema, schemaPath, errSchemaPath, topSchemaRef }) {
	    if (keyword !== undefined && schema !== undefined) {
	        throw new Error('both "keyword" and "schema" passed, only one allowed');
	    }
	    if (keyword !== undefined) {
	        const sch = it.schema[keyword];
	        return schemaProp === undefined
	            ? {
	                schema: sch,
	                schemaPath: (0, codegen_1._) `${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}`,
	                errSchemaPath: `${it.errSchemaPath}/${keyword}`,
	            }
	            : {
	                schema: sch[schemaProp],
	                schemaPath: (0, codegen_1._) `${it.schemaPath}${(0, codegen_1.getProperty)(keyword)}${(0, codegen_1.getProperty)(schemaProp)}`,
	                errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, util_1.escapeFragment)(schemaProp)}`,
	            };
	    }
	    if (schema !== undefined) {
	        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) {
	            throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
	        }
	        return {
	            schema,
	            schemaPath,
	            topSchemaRef,
	            errSchemaPath,
	        };
	    }
	    throw new Error('either "keyword" or "schema" must be passed');
	}
	subschema.getSubschema = getSubschema;
	function extendSubschemaData(subschema, it, { dataProp, dataPropType: dpType, data, dataTypes, propertyName }) {
	    if (data !== undefined && dataProp !== undefined) {
	        throw new Error('both "data" and "dataProp" passed, only one allowed');
	    }
	    const { gen } = it;
	    if (dataProp !== undefined) {
	        const { errorPath, dataPathArr, opts } = it;
	        const nextData = gen.let("data", (0, codegen_1._) `${it.data}${(0, codegen_1.getProperty)(dataProp)}`, true);
	        dataContextProps(nextData);
	        subschema.errorPath = (0, codegen_1.str) `${errorPath}${(0, util_1.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
	        subschema.parentDataProperty = (0, codegen_1._) `${dataProp}`;
	        subschema.dataPathArr = [...dataPathArr, subschema.parentDataProperty];
	    }
	    if (data !== undefined) {
	        const nextData = data instanceof codegen_1.Name ? data : gen.let("data", data, true); // replaceable if used once?
	        dataContextProps(nextData);
	        if (propertyName !== undefined)
	            subschema.propertyName = propertyName;
	        // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
	    }
	    if (dataTypes)
	        subschema.dataTypes = dataTypes;
	    function dataContextProps(_nextData) {
	        subschema.data = _nextData;
	        subschema.dataLevel = it.dataLevel + 1;
	        subschema.dataTypes = [];
	        it.definedProperties = new Set();
	        subschema.parentData = it.data;
	        subschema.dataNames = [...it.dataNames, _nextData];
	    }
	}
	subschema.extendSubschemaData = extendSubschemaData;
	function extendSubschemaMode(subschema, { jtdDiscriminator, jtdMetadata, compositeRule, createErrors, allErrors }) {
	    if (compositeRule !== undefined)
	        subschema.compositeRule = compositeRule;
	    if (createErrors !== undefined)
	        subschema.createErrors = createErrors;
	    if (allErrors !== undefined)
	        subschema.allErrors = allErrors;
	    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
	    subschema.jtdMetadata = jtdMetadata; // not inherited
	}
	subschema.extendSubschemaMode = extendSubschemaMode;
	
	return subschema;
}

var resolve = {};

var fastDeepEqual;
var hasRequiredFastDeepEqual;

function requireFastDeepEqual () {
	if (hasRequiredFastDeepEqual) return fastDeepEqual;
	hasRequiredFastDeepEqual = 1;

	// do not edit .js files directly - edit src/index.jst



	fastDeepEqual = function equal(a, b) {
	  if (a === b) return true;

	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    if (a.constructor !== b.constructor) return false;

	    var length, i, keys;
	    if (Array.isArray(a)) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }



	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
	    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
	    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

	    keys = Object.keys(a);
	    length = keys.length;
	    if (length !== Object.keys(b).length) return false;

	    for (i = length; i-- !== 0;)
	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

	    for (i = length; i-- !== 0;) {
	      var key = keys[i];

	      if (!equal(a[key], b[key])) return false;
	    }

	    return true;
	  }

	  // true if both NaN, false otherwise
	  return a!==a && b!==b;
	};
	return fastDeepEqual;
}

var jsonSchemaTraverse = {exports: {}};

var hasRequiredJsonSchemaTraverse;

function requireJsonSchemaTraverse () {
	if (hasRequiredJsonSchemaTraverse) return jsonSchemaTraverse.exports;
	hasRequiredJsonSchemaTraverse = 1;

	var traverse = jsonSchemaTraverse.exports = function (schema, opts, cb) {
	  // Legacy support for v0.3.1 and earlier.
	  if (typeof opts == 'function') {
	    cb = opts;
	    opts = {};
	  }

	  cb = opts.cb || cb;
	  var pre = (typeof cb == 'function') ? cb : cb.pre || function() {};
	  var post = cb.post || function() {};

	  _traverse(opts, pre, post, schema, '', schema);
	};


	traverse.keywords = {
	  additionalItems: true,
	  items: true,
	  contains: true,
	  additionalProperties: true,
	  propertyNames: true,
	  not: true,
	  if: true,
	  then: true,
	  else: true
	};

	traverse.arrayKeywords = {
	  items: true,
	  allOf: true,
	  anyOf: true,
	  oneOf: true
	};

	traverse.propsKeywords = {
	  $defs: true,
	  definitions: true,
	  properties: true,
	  patternProperties: true,
	  dependencies: true
	};

	traverse.skipKeywords = {
	  default: true,
	  enum: true,
	  const: true,
	  required: true,
	  maximum: true,
	  minimum: true,
	  exclusiveMaximum: true,
	  exclusiveMinimum: true,
	  multipleOf: true,
	  maxLength: true,
	  minLength: true,
	  pattern: true,
	  format: true,
	  maxItems: true,
	  minItems: true,
	  uniqueItems: true,
	  maxProperties: true,
	  minProperties: true
	};


	function _traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
	  if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
	    pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
	    for (var key in schema) {
	      var sch = schema[key];
	      if (Array.isArray(sch)) {
	        if (key in traverse.arrayKeywords) {
	          for (var i=0; i<sch.length; i++)
	            _traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
	        }
	      } else if (key in traverse.propsKeywords) {
	        if (sch && typeof sch == 'object') {
	          for (var prop in sch)
	            _traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
	        }
	      } else if (key in traverse.keywords || (opts.allKeys && !(key in traverse.skipKeywords))) {
	        _traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
	      }
	    }
	    post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
	  }
	}


	function escapeJsonPtr(str) {
	  return str.replace(/~/g, '~0').replace(/\//g, '~1');
	}
	return jsonSchemaTraverse.exports;
}

var hasRequiredResolve;

function requireResolve () {
	if (hasRequiredResolve) return resolve;
	hasRequiredResolve = 1;
	Object.defineProperty(resolve, "__esModule", { value: true });
	resolve.getSchemaRefs = resolve.resolveUrl = resolve.normalizeId = resolve._getFullPath = resolve.getFullPath = resolve.inlineRef = void 0;
	const util_1 = /*@__PURE__*/ requireUtil();
	const equal = requireFastDeepEqual();
	const traverse = requireJsonSchemaTraverse();
	// TODO refactor to use keyword definitions
	const SIMPLE_INLINED = new Set([
	    "type",
	    "format",
	    "pattern",
	    "maxLength",
	    "minLength",
	    "maxProperties",
	    "minProperties",
	    "maxItems",
	    "minItems",
	    "maximum",
	    "minimum",
	    "uniqueItems",
	    "multipleOf",
	    "required",
	    "enum",
	    "const",
	]);
	function inlineRef(schema, limit = true) {
	    if (typeof schema == "boolean")
	        return true;
	    if (limit === true)
	        return !hasRef(schema);
	    if (!limit)
	        return false;
	    return countKeys(schema) <= limit;
	}
	resolve.inlineRef = inlineRef;
	const REF_KEYWORDS = new Set([
	    "$ref",
	    "$recursiveRef",
	    "$recursiveAnchor",
	    "$dynamicRef",
	    "$dynamicAnchor",
	]);
	function hasRef(schema) {
	    for (const key in schema) {
	        if (REF_KEYWORDS.has(key))
	            return true;
	        const sch = schema[key];
	        if (Array.isArray(sch) && sch.some(hasRef))
	            return true;
	        if (typeof sch == "object" && hasRef(sch))
	            return true;
	    }
	    return false;
	}
	function countKeys(schema) {
	    let count = 0;
	    for (const key in schema) {
	        if (key === "$ref")
	            return Infinity;
	        count++;
	        if (SIMPLE_INLINED.has(key))
	            continue;
	        if (typeof schema[key] == "object") {
	            (0, util_1.eachItem)(schema[key], (sch) => (count += countKeys(sch)));
	        }
	        if (count === Infinity)
	            return Infinity;
	    }
	    return count;
	}
	function getFullPath(resolver, id = "", normalize) {
	    if (normalize !== false)
	        id = normalizeId(id);
	    const p = resolver.parse(id);
	    return _getFullPath(resolver, p);
	}
	resolve.getFullPath = getFullPath;
	function _getFullPath(resolver, p) {
	    const serialized = resolver.serialize(p);
	    return serialized.split("#")[0] + "#";
	}
	resolve._getFullPath = _getFullPath;
	const TRAILING_SLASH_HASH = /#\/?$/;
	function normalizeId(id) {
	    return id ? id.replace(TRAILING_SLASH_HASH, "") : "";
	}
	resolve.normalizeId = normalizeId;
	function resolveUrl(resolver, baseId, id) {
	    id = normalizeId(id);
	    return resolver.resolve(baseId, id);
	}
	resolve.resolveUrl = resolveUrl;
	const ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
	function getSchemaRefs(schema, baseId) {
	    if (typeof schema == "boolean")
	        return {};
	    const { schemaId, uriResolver } = this.opts;
	    const schId = normalizeId(schema[schemaId] || baseId);
	    const baseIds = { "": schId };
	    const pathPrefix = getFullPath(uriResolver, schId, false);
	    const localRefs = {};
	    const schemaRefs = new Set();
	    traverse(schema, { allKeys: true }, (sch, jsonPtr, _, parentJsonPtr) => {
	        if (parentJsonPtr === undefined)
	            return;
	        const fullPath = pathPrefix + jsonPtr;
	        let innerBaseId = baseIds[parentJsonPtr];
	        if (typeof sch[schemaId] == "string")
	            innerBaseId = addRef.call(this, sch[schemaId]);
	        addAnchor.call(this, sch.$anchor);
	        addAnchor.call(this, sch.$dynamicAnchor);
	        baseIds[jsonPtr] = innerBaseId;
	        function addRef(ref) {
	            // eslint-disable-next-line @typescript-eslint/unbound-method
	            const _resolve = this.opts.uriResolver.resolve;
	            ref = normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
	            if (schemaRefs.has(ref))
	                throw ambiguos(ref);
	            schemaRefs.add(ref);
	            let schOrRef = this.refs[ref];
	            if (typeof schOrRef == "string")
	                schOrRef = this.refs[schOrRef];
	            if (typeof schOrRef == "object") {
	                checkAmbiguosRef(sch, schOrRef.schema, ref);
	            }
	            else if (ref !== normalizeId(fullPath)) {
	                if (ref[0] === "#") {
	                    checkAmbiguosRef(sch, localRefs[ref], ref);
	                    localRefs[ref] = sch;
	                }
	                else {
	                    this.refs[ref] = fullPath;
	                }
	            }
	            return ref;
	        }
	        function addAnchor(anchor) {
	            if (typeof anchor == "string") {
	                if (!ANCHOR.test(anchor))
	                    throw new Error(`invalid anchor "${anchor}"`);
	                addRef.call(this, `#${anchor}`);
	            }
	        }
	    });
	    return localRefs;
	    function checkAmbiguosRef(sch1, sch2, ref) {
	        if (sch2 !== undefined && !equal(sch1, sch2))
	            throw ambiguos(ref);
	    }
	    function ambiguos(ref) {
	        return new Error(`reference "${ref}" resolves to more than one schema`);
	    }
	}
	resolve.getSchemaRefs = getSchemaRefs;
	
	return resolve;
}

var hasRequiredValidate;

function requireValidate () {
	if (hasRequiredValidate) return validate;
	hasRequiredValidate = 1;
	Object.defineProperty(validate, "__esModule", { value: true });
	validate.getData = validate.KeywordCxt = validate.validateFunctionCode = void 0;
	const boolSchema_1 = /*@__PURE__*/ requireBoolSchema();
	const dataType_1 = /*@__PURE__*/ requireDataType();
	const applicability_1 = /*@__PURE__*/ requireApplicability();
	const dataType_2 = /*@__PURE__*/ requireDataType();
	const defaults_1 = /*@__PURE__*/ requireDefaults();
	const keyword_1 = /*@__PURE__*/ requireKeyword();
	const subschema_1 = /*@__PURE__*/ requireSubschema();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const names_1 = /*@__PURE__*/ requireNames();
	const resolve_1 = /*@__PURE__*/ requireResolve();
	const util_1 = /*@__PURE__*/ requireUtil();
	const errors_1 = /*@__PURE__*/ requireErrors();
	// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
	function validateFunctionCode(it) {
	    if (isSchemaObj(it)) {
	        checkKeywords(it);
	        if (schemaCxtHasRules(it)) {
	            topSchemaObjCode(it);
	            return;
	        }
	    }
	    validateFunction(it, () => (0, boolSchema_1.topBoolOrEmptySchema)(it));
	}
	validate.validateFunctionCode = validateFunctionCode;
	function validateFunction({ gen, validateName, schema, schemaEnv, opts }, body) {
	    if (opts.code.es5) {
	        gen.func(validateName, (0, codegen_1._) `${names_1.default.data}, ${names_1.default.valCxt}`, schemaEnv.$async, () => {
	            gen.code((0, codegen_1._) `"use strict"; ${funcSourceUrl(schema, opts)}`);
	            destructureValCxtES5(gen, opts);
	            gen.code(body);
	        });
	    }
	    else {
	        gen.func(validateName, (0, codegen_1._) `${names_1.default.data}, ${destructureValCxt(opts)}`, schemaEnv.$async, () => gen.code(funcSourceUrl(schema, opts)).code(body));
	    }
	}
	function destructureValCxt(opts) {
	    return (0, codegen_1._) `{${names_1.default.instancePath}="", ${names_1.default.parentData}, ${names_1.default.parentDataProperty}, ${names_1.default.rootData}=${names_1.default.data}${opts.dynamicRef ? (0, codegen_1._) `, ${names_1.default.dynamicAnchors}={}` : codegen_1.nil}}={}`;
	}
	function destructureValCxtES5(gen, opts) {
	    gen.if(names_1.default.valCxt, () => {
	        gen.var(names_1.default.instancePath, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.instancePath}`);
	        gen.var(names_1.default.parentData, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.parentData}`);
	        gen.var(names_1.default.parentDataProperty, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.parentDataProperty}`);
	        gen.var(names_1.default.rootData, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.rootData}`);
	        if (opts.dynamicRef)
	            gen.var(names_1.default.dynamicAnchors, (0, codegen_1._) `${names_1.default.valCxt}.${names_1.default.dynamicAnchors}`);
	    }, () => {
	        gen.var(names_1.default.instancePath, (0, codegen_1._) `""`);
	        gen.var(names_1.default.parentData, (0, codegen_1._) `undefined`);
	        gen.var(names_1.default.parentDataProperty, (0, codegen_1._) `undefined`);
	        gen.var(names_1.default.rootData, names_1.default.data);
	        if (opts.dynamicRef)
	            gen.var(names_1.default.dynamicAnchors, (0, codegen_1._) `{}`);
	    });
	}
	function topSchemaObjCode(it) {
	    const { schema, opts, gen } = it;
	    validateFunction(it, () => {
	        if (opts.$comment && schema.$comment)
	            commentKeyword(it);
	        checkNoDefault(it);
	        gen.let(names_1.default.vErrors, null);
	        gen.let(names_1.default.errors, 0);
	        if (opts.unevaluated)
	            resetEvaluated(it);
	        typeAndKeywords(it);
	        returnResults(it);
	    });
	    return;
	}
	function resetEvaluated(it) {
	    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
	    const { gen, validateName } = it;
	    it.evaluated = gen.const("evaluated", (0, codegen_1._) `${validateName}.evaluated`);
	    gen.if((0, codegen_1._) `${it.evaluated}.dynamicProps`, () => gen.assign((0, codegen_1._) `${it.evaluated}.props`, (0, codegen_1._) `undefined`));
	    gen.if((0, codegen_1._) `${it.evaluated}.dynamicItems`, () => gen.assign((0, codegen_1._) `${it.evaluated}.items`, (0, codegen_1._) `undefined`));
	}
	function funcSourceUrl(schema, opts) {
	    const schId = typeof schema == "object" && schema[opts.schemaId];
	    return schId && (opts.code.source || opts.code.process) ? (0, codegen_1._) `/*# sourceURL=${schId} */` : codegen_1.nil;
	}
	// schema compilation - this function is used recursively to generate code for sub-schemas
	function subschemaCode(it, valid) {
	    if (isSchemaObj(it)) {
	        checkKeywords(it);
	        if (schemaCxtHasRules(it)) {
	            subSchemaObjCode(it, valid);
	            return;
	        }
	    }
	    (0, boolSchema_1.boolOrEmptySchema)(it, valid);
	}
	function schemaCxtHasRules({ schema, self }) {
	    if (typeof schema == "boolean")
	        return !schema;
	    for (const key in schema)
	        if (self.RULES.all[key])
	            return true;
	    return false;
	}
	function isSchemaObj(it) {
	    return typeof it.schema != "boolean";
	}
	function subSchemaObjCode(it, valid) {
	    const { schema, gen, opts } = it;
	    if (opts.$comment && schema.$comment)
	        commentKeyword(it);
	    updateContext(it);
	    checkAsyncSchema(it);
	    const errsCount = gen.const("_errs", names_1.default.errors);
	    typeAndKeywords(it, errsCount);
	    // TODO var
	    gen.var(valid, (0, codegen_1._) `${errsCount} === ${names_1.default.errors}`);
	}
	function checkKeywords(it) {
	    (0, util_1.checkUnknownRules)(it);
	    checkRefsAndKeywords(it);
	}
	function typeAndKeywords(it, errsCount) {
	    if (it.opts.jtd)
	        return schemaKeywords(it, [], false, errsCount);
	    const types = (0, dataType_1.getSchemaTypes)(it.schema);
	    const checkedTypes = (0, dataType_1.coerceAndCheckDataType)(it, types);
	    schemaKeywords(it, types, !checkedTypes, errsCount);
	}
	function checkRefsAndKeywords(it) {
	    const { schema, errSchemaPath, opts, self } = it;
	    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, util_1.schemaHasRulesButRef)(schema, self.RULES)) {
	        self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
	    }
	}
	function checkNoDefault(it) {
	    const { schema, opts } = it;
	    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) {
	        (0, util_1.checkStrictMode)(it, "default is ignored in the schema root");
	    }
	}
	function updateContext(it) {
	    const schId = it.schema[it.opts.schemaId];
	    if (schId)
	        it.baseId = (0, resolve_1.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
	}
	function checkAsyncSchema(it) {
	    if (it.schema.$async && !it.schemaEnv.$async)
	        throw new Error("async schema in sync schema");
	}
	function commentKeyword({ gen, schemaEnv, schema, errSchemaPath, opts }) {
	    const msg = schema.$comment;
	    if (opts.$comment === true) {
	        gen.code((0, codegen_1._) `${names_1.default.self}.logger.log(${msg})`);
	    }
	    else if (typeof opts.$comment == "function") {
	        const schemaPath = (0, codegen_1.str) `${errSchemaPath}/$comment`;
	        const rootName = gen.scopeValue("root", { ref: schemaEnv.root });
	        gen.code((0, codegen_1._) `${names_1.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
	    }
	}
	function returnResults(it) {
	    const { gen, schemaEnv, validateName, ValidationError, opts } = it;
	    if (schemaEnv.$async) {
	        // TODO assign unevaluated
	        gen.if((0, codegen_1._) `${names_1.default.errors} === 0`, () => gen.return(names_1.default.data), () => gen.throw((0, codegen_1._) `new ${ValidationError}(${names_1.default.vErrors})`));
	    }
	    else {
	        gen.assign((0, codegen_1._) `${validateName}.errors`, names_1.default.vErrors);
	        if (opts.unevaluated)
	            assignEvaluated(it);
	        gen.return((0, codegen_1._) `${names_1.default.errors} === 0`);
	    }
	}
	function assignEvaluated({ gen, evaluated, props, items }) {
	    if (props instanceof codegen_1.Name)
	        gen.assign((0, codegen_1._) `${evaluated}.props`, props);
	    if (items instanceof codegen_1.Name)
	        gen.assign((0, codegen_1._) `${evaluated}.items`, items);
	}
	function schemaKeywords(it, types, typeErrors, errsCount) {
	    const { gen, schema, data, allErrors, opts, self } = it;
	    const { RULES } = self;
	    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, util_1.schemaHasRulesButRef)(schema, RULES))) {
	        gen.block(() => keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
	        return;
	    }
	    if (!opts.jtd)
	        checkStrictTypes(it, types);
	    gen.block(() => {
	        for (const group of RULES.rules)
	            groupKeywords(group);
	        groupKeywords(RULES.post);
	    });
	    function groupKeywords(group) {
	        if (!(0, applicability_1.shouldUseGroup)(schema, group))
	            return;
	        if (group.type) {
	            gen.if((0, dataType_2.checkDataType)(group.type, data, opts.strictNumbers));
	            iterateKeywords(it, group);
	            if (types.length === 1 && types[0] === group.type && typeErrors) {
	                gen.else();
	                (0, dataType_2.reportTypeError)(it);
	            }
	            gen.endIf();
	        }
	        else {
	            iterateKeywords(it, group);
	        }
	        // TODO make it "ok" call?
	        if (!allErrors)
	            gen.if((0, codegen_1._) `${names_1.default.errors} === ${errsCount || 0}`);
	    }
	}
	function iterateKeywords(it, group) {
	    const { gen, schema, opts: { useDefaults }, } = it;
	    if (useDefaults)
	        (0, defaults_1.assignDefaults)(it, group.type);
	    gen.block(() => {
	        for (const rule of group.rules) {
	            if ((0, applicability_1.shouldUseRule)(schema, rule)) {
	                keywordCode(it, rule.keyword, rule.definition, group.type);
	            }
	        }
	    });
	}
	function checkStrictTypes(it, types) {
	    if (it.schemaEnv.meta || !it.opts.strictTypes)
	        return;
	    checkContextTypes(it, types);
	    if (!it.opts.allowUnionTypes)
	        checkMultipleTypes(it, types);
	    checkKeywordTypes(it, it.dataTypes);
	}
	function checkContextTypes(it, types) {
	    if (!types.length)
	        return;
	    if (!it.dataTypes.length) {
	        it.dataTypes = types;
	        return;
	    }
	    types.forEach((t) => {
	        if (!includesType(it.dataTypes, t)) {
	            strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
	        }
	    });
	    narrowSchemaTypes(it, types);
	}
	function checkMultipleTypes(it, ts) {
	    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) {
	        strictTypesError(it, "use allowUnionTypes to allow union type keyword");
	    }
	}
	function checkKeywordTypes(it, ts) {
	    const rules = it.self.RULES.all;
	    for (const keyword in rules) {
	        const rule = rules[keyword];
	        if (typeof rule == "object" && (0, applicability_1.shouldUseRule)(it.schema, rule)) {
	            const { type } = rule.definition;
	            if (type.length && !type.some((t) => hasApplicableType(ts, t))) {
	                strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
	            }
	        }
	    }
	}
	function hasApplicableType(schTs, kwdT) {
	    return schTs.includes(kwdT) || (kwdT === "number" && schTs.includes("integer"));
	}
	function includesType(ts, t) {
	    return ts.includes(t) || (t === "integer" && ts.includes("number"));
	}
	function narrowSchemaTypes(it, withTypes) {
	    const ts = [];
	    for (const t of it.dataTypes) {
	        if (includesType(withTypes, t))
	            ts.push(t);
	        else if (withTypes.includes("integer") && t === "number")
	            ts.push("integer");
	    }
	    it.dataTypes = ts;
	}
	function strictTypesError(it, msg) {
	    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
	    msg += ` at "${schemaPath}" (strictTypes)`;
	    (0, util_1.checkStrictMode)(it, msg, it.opts.strictTypes);
	}
	class KeywordCxt {
	    constructor(it, def, keyword) {
	        (0, keyword_1.validateKeywordUsage)(it, def, keyword);
	        this.gen = it.gen;
	        this.allErrors = it.allErrors;
	        this.keyword = keyword;
	        this.data = it.data;
	        this.schema = it.schema[keyword];
	        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
	        this.schemaValue = (0, util_1.schemaRefOrVal)(it, this.schema, keyword, this.$data);
	        this.schemaType = def.schemaType;
	        this.parentSchema = it.schema;
	        this.params = {};
	        this.it = it;
	        this.def = def;
	        if (this.$data) {
	            this.schemaCode = it.gen.const("vSchema", getData(this.$data, it));
	        }
	        else {
	            this.schemaCode = this.schemaValue;
	            if (!(0, keyword_1.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) {
	                throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
	            }
	        }
	        if ("code" in def ? def.trackErrors : def.errors !== false) {
	            this.errsCount = it.gen.const("_errs", names_1.default.errors);
	        }
	    }
	    result(condition, successAction, failAction) {
	        this.failResult((0, codegen_1.not)(condition), successAction, failAction);
	    }
	    failResult(condition, successAction, failAction) {
	        this.gen.if(condition);
	        if (failAction)
	            failAction();
	        else
	            this.error();
	        if (successAction) {
	            this.gen.else();
	            successAction();
	            if (this.allErrors)
	                this.gen.endIf();
	        }
	        else {
	            if (this.allErrors)
	                this.gen.endIf();
	            else
	                this.gen.else();
	        }
	    }
	    pass(condition, failAction) {
	        this.failResult((0, codegen_1.not)(condition), undefined, failAction);
	    }
	    fail(condition) {
	        if (condition === undefined) {
	            this.error();
	            if (!this.allErrors)
	                this.gen.if(false); // this branch will be removed by gen.optimize
	            return;
	        }
	        this.gen.if(condition);
	        this.error();
	        if (this.allErrors)
	            this.gen.endIf();
	        else
	            this.gen.else();
	    }
	    fail$data(condition) {
	        if (!this.$data)
	            return this.fail(condition);
	        const { schemaCode } = this;
	        this.fail((0, codegen_1._) `${schemaCode} !== undefined && (${(0, codegen_1.or)(this.invalid$data(), condition)})`);
	    }
	    error(append, errorParams, errorPaths) {
	        if (errorParams) {
	            this.setParams(errorParams);
	            this._error(append, errorPaths);
	            this.setParams({});
	            return;
	        }
	        this._error(append, errorPaths);
	    }
	    _error(append, errorPaths) {
	        (append ? errors_1.reportExtraError : errors_1.reportError)(this, this.def.error, errorPaths);
	    }
	    $dataError() {
	        (0, errors_1.reportError)(this, this.def.$dataError || errors_1.keyword$DataError);
	    }
	    reset() {
	        if (this.errsCount === undefined)
	            throw new Error('add "trackErrors" to keyword definition');
	        (0, errors_1.resetErrorsCount)(this.gen, this.errsCount);
	    }
	    ok(cond) {
	        if (!this.allErrors)
	            this.gen.if(cond);
	    }
	    setParams(obj, assign) {
	        if (assign)
	            Object.assign(this.params, obj);
	        else
	            this.params = obj;
	    }
	    block$data(valid, codeBlock, $dataValid = codegen_1.nil) {
	        this.gen.block(() => {
	            this.check$data(valid, $dataValid);
	            codeBlock();
	        });
	    }
	    check$data(valid = codegen_1.nil, $dataValid = codegen_1.nil) {
	        if (!this.$data)
	            return;
	        const { gen, schemaCode, schemaType, def } = this;
	        gen.if((0, codegen_1.or)((0, codegen_1._) `${schemaCode} === undefined`, $dataValid));
	        if (valid !== codegen_1.nil)
	            gen.assign(valid, true);
	        if (schemaType.length || def.validateSchema) {
	            gen.elseIf(this.invalid$data());
	            this.$dataError();
	            if (valid !== codegen_1.nil)
	                gen.assign(valid, false);
	        }
	        gen.else();
	    }
	    invalid$data() {
	        const { gen, schemaCode, schemaType, def, it } = this;
	        return (0, codegen_1.or)(wrong$DataType(), invalid$DataSchema());
	        function wrong$DataType() {
	            if (schemaType.length) {
	                /* istanbul ignore if */
	                if (!(schemaCode instanceof codegen_1.Name))
	                    throw new Error("ajv implementation error");
	                const st = Array.isArray(schemaType) ? schemaType : [schemaType];
	                return (0, codegen_1._) `${(0, dataType_2.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, dataType_2.DataType.Wrong)}`;
	            }
	            return codegen_1.nil;
	        }
	        function invalid$DataSchema() {
	            if (def.validateSchema) {
	                const validateSchemaRef = gen.scopeValue("validate$data", { ref: def.validateSchema }); // TODO value.code for standalone
	                return (0, codegen_1._) `!${validateSchemaRef}(${schemaCode})`;
	            }
	            return codegen_1.nil;
	        }
	    }
	    subschema(appl, valid) {
	        const subschema = (0, subschema_1.getSubschema)(this.it, appl);
	        (0, subschema_1.extendSubschemaData)(subschema, this.it, appl);
	        (0, subschema_1.extendSubschemaMode)(subschema, appl);
	        const nextContext = { ...this.it, ...subschema, items: undefined, props: undefined };
	        subschemaCode(nextContext, valid);
	        return nextContext;
	    }
	    mergeEvaluated(schemaCxt, toName) {
	        const { it, gen } = this;
	        if (!it.opts.unevaluated)
	            return;
	        if (it.props !== true && schemaCxt.props !== undefined) {
	            it.props = util_1.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
	        }
	        if (it.items !== true && schemaCxt.items !== undefined) {
	            it.items = util_1.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
	        }
	    }
	    mergeValidEvaluated(schemaCxt, valid) {
	        const { it, gen } = this;
	        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
	            gen.if(valid, () => this.mergeEvaluated(schemaCxt, codegen_1.Name));
	            return true;
	        }
	    }
	}
	validate.KeywordCxt = KeywordCxt;
	function keywordCode(it, keyword, def, ruleType) {
	    const cxt = new KeywordCxt(it, def, keyword);
	    if ("code" in def) {
	        def.code(cxt, ruleType);
	    }
	    else if (cxt.$data && def.validate) {
	        (0, keyword_1.funcKeywordCode)(cxt, def);
	    }
	    else if ("macro" in def) {
	        (0, keyword_1.macroKeywordCode)(cxt, def);
	    }
	    else if (def.compile || def.validate) {
	        (0, keyword_1.funcKeywordCode)(cxt, def);
	    }
	}
	const JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
	const RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
	function getData($data, { dataLevel, dataNames, dataPathArr }) {
	    let jsonPointer;
	    let data;
	    if ($data === "")
	        return names_1.default.rootData;
	    if ($data[0] === "/") {
	        if (!JSON_POINTER.test($data))
	            throw new Error(`Invalid JSON-pointer: ${$data}`);
	        jsonPointer = $data;
	        data = names_1.default.rootData;
	    }
	    else {
	        const matches = RELATIVE_JSON_POINTER.exec($data);
	        if (!matches)
	            throw new Error(`Invalid JSON-pointer: ${$data}`);
	        const up = +matches[1];
	        jsonPointer = matches[2];
	        if (jsonPointer === "#") {
	            if (up >= dataLevel)
	                throw new Error(errorMsg("property/index", up));
	            return dataPathArr[dataLevel - up];
	        }
	        if (up > dataLevel)
	            throw new Error(errorMsg("data", up));
	        data = dataNames[dataLevel - up];
	        if (!jsonPointer)
	            return data;
	    }
	    let expr = data;
	    const segments = jsonPointer.split("/");
	    for (const segment of segments) {
	        if (segment) {
	            data = (0, codegen_1._) `${data}${(0, codegen_1.getProperty)((0, util_1.unescapeJsonPointer)(segment))}`;
	            expr = (0, codegen_1._) `${expr} && ${data}`;
	        }
	    }
	    return expr;
	    function errorMsg(pointerType, up) {
	        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
	    }
	}
	validate.getData = getData;
	
	return validate;
}

var validation_error = {};

var hasRequiredValidation_error;

function requireValidation_error () {
	if (hasRequiredValidation_error) return validation_error;
	hasRequiredValidation_error = 1;
	Object.defineProperty(validation_error, "__esModule", { value: true });
	class ValidationError extends Error {
	    constructor(errors) {
	        super("validation failed");
	        this.errors = errors;
	        this.ajv = this.validation = true;
	    }
	}
	validation_error.default = ValidationError;
	
	return validation_error;
}

var ref_error = {};

var hasRequiredRef_error;

function requireRef_error () {
	if (hasRequiredRef_error) return ref_error;
	hasRequiredRef_error = 1;
	Object.defineProperty(ref_error, "__esModule", { value: true });
	const resolve_1 = /*@__PURE__*/ requireResolve();
	class MissingRefError extends Error {
	    constructor(resolver, baseId, ref, msg) {
	        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
	        this.missingRef = (0, resolve_1.resolveUrl)(resolver, baseId, ref);
	        this.missingSchema = (0, resolve_1.normalizeId)((0, resolve_1.getFullPath)(resolver, this.missingRef));
	    }
	}
	ref_error.default = MissingRefError;
	
	return ref_error;
}

var compile = {};

var hasRequiredCompile;

function requireCompile () {
	if (hasRequiredCompile) return compile;
	hasRequiredCompile = 1;
	Object.defineProperty(compile, "__esModule", { value: true });
	compile.resolveSchema = compile.getCompilingSchema = compile.resolveRef = compile.compileSchema = compile.SchemaEnv = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const validation_error_1 = /*@__PURE__*/ requireValidation_error();
	const names_1 = /*@__PURE__*/ requireNames();
	const resolve_1 = /*@__PURE__*/ requireResolve();
	const util_1 = /*@__PURE__*/ requireUtil();
	const validate_1 = /*@__PURE__*/ requireValidate();
	class SchemaEnv {
	    constructor(env) {
	        var _a;
	        this.refs = {};
	        this.dynamicAnchors = {};
	        let schema;
	        if (typeof env.schema == "object")
	            schema = env.schema;
	        this.schema = env.schema;
	        this.schemaId = env.schemaId;
	        this.root = env.root || this;
	        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, resolve_1.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
	        this.schemaPath = env.schemaPath;
	        this.localRefs = env.localRefs;
	        this.meta = env.meta;
	        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
	        this.refs = {};
	    }
	}
	compile.SchemaEnv = SchemaEnv;
	// let codeSize = 0
	// let nodeCount = 0
	// Compiles schema in SchemaEnv
	function compileSchema(sch) {
	    // TODO refactor - remove compilations
	    const _sch = getCompilingSchema.call(this, sch);
	    if (_sch)
	        return _sch;
	    const rootId = (0, resolve_1.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
	    const { es5, lines } = this.opts.code;
	    const { ownProperties } = this.opts;
	    const gen = new codegen_1.CodeGen(this.scope, { es5, lines, ownProperties });
	    let _ValidationError;
	    if (sch.$async) {
	        _ValidationError = gen.scopeValue("Error", {
	            ref: validation_error_1.default,
	            code: (0, codegen_1._) `require("ajv/dist/runtime/validation_error").default`,
	        });
	    }
	    const validateName = gen.scopeName("validate");
	    sch.validateName = validateName;
	    const schemaCxt = {
	        gen,
	        allErrors: this.opts.allErrors,
	        data: names_1.default.data,
	        parentData: names_1.default.parentData,
	        parentDataProperty: names_1.default.parentDataProperty,
	        dataNames: [names_1.default.data],
	        dataPathArr: [codegen_1.nil], // TODO can its length be used as dataLevel if nil is removed?
	        dataLevel: 0,
	        dataTypes: [],
	        definedProperties: new Set(),
	        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true
	            ? { ref: sch.schema, code: (0, codegen_1.stringify)(sch.schema) }
	            : { ref: sch.schema }),
	        validateName,
	        ValidationError: _ValidationError,
	        schema: sch.schema,
	        schemaEnv: sch,
	        rootId,
	        baseId: sch.baseId || rootId,
	        schemaPath: codegen_1.nil,
	        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
	        errorPath: (0, codegen_1._) `""`,
	        opts: this.opts,
	        self: this,
	    };
	    let sourceCode;
	    try {
	        this._compilations.add(sch);
	        (0, validate_1.validateFunctionCode)(schemaCxt);
	        gen.optimize(this.opts.code.optimize);
	        // gen.optimize(1)
	        const validateCode = gen.toString();
	        sourceCode = `${gen.scopeRefs(names_1.default.scope)}return ${validateCode}`;
	        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
	        if (this.opts.code.process)
	            sourceCode = this.opts.code.process(sourceCode, sch);
	        // console.log("\n\n\n *** \n", sourceCode)
	        const makeValidate = new Function(`${names_1.default.self}`, `${names_1.default.scope}`, sourceCode);
	        const validate = makeValidate(this, this.scope.get());
	        this.scope.value(validateName, { ref: validate });
	        validate.errors = null;
	        validate.schema = sch.schema;
	        validate.schemaEnv = sch;
	        if (sch.$async)
	            validate.$async = true;
	        if (this.opts.code.source === true) {
	            validate.source = { validateName, validateCode, scopeValues: gen._values };
	        }
	        if (this.opts.unevaluated) {
	            const { props, items } = schemaCxt;
	            validate.evaluated = {
	                props: props instanceof codegen_1.Name ? undefined : props,
	                items: items instanceof codegen_1.Name ? undefined : items,
	                dynamicProps: props instanceof codegen_1.Name,
	                dynamicItems: items instanceof codegen_1.Name,
	            };
	            if (validate.source)
	                validate.source.evaluated = (0, codegen_1.stringify)(validate.evaluated);
	        }
	        sch.validate = validate;
	        return sch;
	    }
	    catch (e) {
	        delete sch.validate;
	        delete sch.validateName;
	        if (sourceCode)
	            this.logger.error("Error compiling schema, function code:", sourceCode);
	        // console.log("\n\n\n *** \n", sourceCode, this.opts)
	        throw e;
	    }
	    finally {
	        this._compilations.delete(sch);
	    }
	}
	compile.compileSchema = compileSchema;
	function resolveRef(root, baseId, ref) {
	    var _a;
	    ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, ref);
	    const schOrFunc = root.refs[ref];
	    if (schOrFunc)
	        return schOrFunc;
	    let _sch = resolve.call(this, root, ref);
	    if (_sch === undefined) {
	        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
	        const { schemaId } = this.opts;
	        if (schema)
	            _sch = new SchemaEnv({ schema, schemaId, root, baseId });
	    }
	    if (_sch === undefined)
	        return;
	    return (root.refs[ref] = inlineOrCompile.call(this, _sch));
	}
	compile.resolveRef = resolveRef;
	function inlineOrCompile(sch) {
	    if ((0, resolve_1.inlineRef)(sch.schema, this.opts.inlineRefs))
	        return sch.schema;
	    return sch.validate ? sch : compileSchema.call(this, sch);
	}
	// Index of schema compilation in the currently compiled list
	function getCompilingSchema(schEnv) {
	    for (const sch of this._compilations) {
	        if (sameSchemaEnv(sch, schEnv))
	            return sch;
	    }
	}
	compile.getCompilingSchema = getCompilingSchema;
	function sameSchemaEnv(s1, s2) {
	    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
	}
	// resolve and compile the references ($ref)
	// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
	function resolve(root, // information about the root schema for the current schema
	ref // reference to resolve
	) {
	    let sch;
	    while (typeof (sch = this.refs[ref]) == "string")
	        ref = sch;
	    return sch || this.schemas[ref] || resolveSchema.call(this, root, ref);
	}
	// Resolve schema, its root and baseId
	function resolveSchema(root, // root object with properties schema, refs TODO below SchemaEnv is assigned to it
	ref // reference to resolve
	) {
	    const p = this.opts.uriResolver.parse(ref);
	    const refPath = (0, resolve_1._getFullPath)(this.opts.uriResolver, p);
	    let baseId = (0, resolve_1.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
	    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
	    if (Object.keys(root.schema).length > 0 && refPath === baseId) {
	        return getJsonPointer.call(this, p, root);
	    }
	    const id = (0, resolve_1.normalizeId)(refPath);
	    const schOrRef = this.refs[id] || this.schemas[id];
	    if (typeof schOrRef == "string") {
	        const sch = resolveSchema.call(this, root, schOrRef);
	        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object")
	            return;
	        return getJsonPointer.call(this, p, sch);
	    }
	    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object")
	        return;
	    if (!schOrRef.validate)
	        compileSchema.call(this, schOrRef);
	    if (id === (0, resolve_1.normalizeId)(ref)) {
	        const { schema } = schOrRef;
	        const { schemaId } = this.opts;
	        const schId = schema[schemaId];
	        if (schId)
	            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
	        return new SchemaEnv({ schema, schemaId, root, baseId });
	    }
	    return getJsonPointer.call(this, p, schOrRef);
	}
	compile.resolveSchema = resolveSchema;
	const PREVENT_SCOPE_CHANGE = new Set([
	    "properties",
	    "patternProperties",
	    "enum",
	    "dependencies",
	    "definitions",
	]);
	function getJsonPointer(parsedRef, { baseId, schema, root }) {
	    var _a;
	    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/")
	        return;
	    for (const part of parsedRef.fragment.slice(1).split("/")) {
	        if (typeof schema === "boolean")
	            return;
	        const partSchema = schema[(0, util_1.unescapeFragment)(part)];
	        if (partSchema === undefined)
	            return;
	        schema = partSchema;
	        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
	        const schId = typeof schema === "object" && schema[this.opts.schemaId];
	        if (!PREVENT_SCOPE_CHANGE.has(part) && schId) {
	            baseId = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schId);
	        }
	    }
	    let env;
	    if (typeof schema != "boolean" && schema.$ref && !(0, util_1.schemaHasRulesButRef)(schema, this.RULES)) {
	        const $ref = (0, resolve_1.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
	        env = resolveSchema.call(this, root, $ref);
	    }
	    // even though resolution failed we need to return SchemaEnv to throw exception
	    // so that compileAsync loads missing schema.
	    const { schemaId } = this.opts;
	    env = env || new SchemaEnv({ schema, schemaId, root, baseId });
	    if (env.schema !== env.root.schema)
	        return env;
	    return undefined;
	}
	
	return compile;
}

var $id$1 = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#";
var description = "Meta-schema for $data reference (JSON AnySchema extension proposal)";
var type$1 = "object";
var required$1 = [
	"$data"
];
var properties$2 = {
	$data: {
		type: "string",
		anyOf: [
			{
				format: "relative-json-pointer"
			},
			{
				format: "json-pointer"
			}
		]
	}
};
var additionalProperties$1 = false;
var require$$9 = {
	$id: $id$1,
	description: description,
	type: type$1,
	required: required$1,
	properties: properties$2,
	additionalProperties: additionalProperties$1
};

var uri = {};

var fastUri = {exports: {}};

var utils;
var hasRequiredUtils;

function requireUtils () {
	if (hasRequiredUtils) return utils;
	hasRequiredUtils = 1;

	/** @type {(value: string) => boolean} */
	const isUUID = RegExp.prototype.test.bind(/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/iu);

	/** @type {(value: string) => boolean} */
	const isIPv4 = RegExp.prototype.test.bind(/^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)$/u);

	/** @type {(value: string) => boolean} */
	const isHexPair = RegExp.prototype.test.bind(/^[\da-f]{2}$/iu);

	/** @type {(value: string) => boolean} */
	const isUnreserved = RegExp.prototype.test.bind(/^[\da-z\-._~]$/iu);

	/** @type {(value: string) => boolean} */
	const isPathCharacter = RegExp.prototype.test.bind(/^[\da-z\-._~!$&'()*+,;=:@/]$/iu);

	/**
	 * @param {Array<string>} input
	 * @returns {string}
	 */
	function stringArrayToHexStripped (input) {
	  let acc = '';
	  let code = 0;
	  let i = 0;

	  for (i = 0; i < input.length; i++) {
	    code = input[i].charCodeAt(0);
	    if (code === 48) {
	      continue
	    }
	    if (!((code >= 48 && code <= 57) || (code >= 65 && code <= 70) || (code >= 97 && code <= 102))) {
	      return ''
	    }
	    acc += input[i];
	    break
	  }

	  for (i += 1; i < input.length; i++) {
	    code = input[i].charCodeAt(0);
	    if (!((code >= 48 && code <= 57) || (code >= 65 && code <= 70) || (code >= 97 && code <= 102))) {
	      return ''
	    }
	    acc += input[i];
	  }
	  return acc
	}

	/**
	 * @typedef {Object} GetIPV6Result
	 * @property {boolean} error - Indicates if there was an error parsing the IPv6 address.
	 * @property {string} address - The parsed IPv6 address.
	 * @property {string} [zone] - The zone identifier, if present.
	 */

	/**
	 * @param {string} value
	 * @returns {boolean}
	 */
	const nonSimpleDomain = RegExp.prototype.test.bind(/[^!"$&'()*+,\-.;=_`a-z{}~]/u);

	/**
	 * @param {Array<string>} buffer
	 * @returns {boolean}
	 */
	function consumeIsZone (buffer) {
	  buffer.length = 0;
	  return true
	}

	/**
	 * @param {Array<string>} buffer
	 * @param {Array<string>} address
	 * @param {GetIPV6Result} output
	 * @returns {boolean}
	 */
	function consumeHextets (buffer, address, output) {
	  if (buffer.length) {
	    const hex = stringArrayToHexStripped(buffer);
	    if (hex !== '') {
	      address.push(hex);
	    } else {
	      output.error = true;
	      return false
	    }
	    buffer.length = 0;
	  }
	  return true
	}

	/**
	 * @param {string} input
	 * @returns {GetIPV6Result}
	 */
	function getIPV6 (input) {
	  let tokenCount = 0;
	  const output = { error: false, address: '', zone: '' };
	  /** @type {Array<string>} */
	  const address = [];
	  /** @type {Array<string>} */
	  const buffer = [];
	  let endipv6Encountered = false;
	  let endIpv6 = false;

	  let consume = consumeHextets;

	  for (let i = 0; i < input.length; i++) {
	    const cursor = input[i];
	    if (cursor === '[' || cursor === ']') { continue }
	    if (cursor === ':') {
	      if (endipv6Encountered === true) {
	        endIpv6 = true;
	      }
	      if (!consume(buffer, address, output)) { break }
	      if (++tokenCount > 7) {
	        // not valid
	        output.error = true;
	        break
	      }
	      if (i > 0 && input[i - 1] === ':') {
	        endipv6Encountered = true;
	      }
	      address.push(':');
	      continue
	    } else if (cursor === '%') {
	      if (!consume(buffer, address, output)) { break }
	      // switch to zone detection
	      consume = consumeIsZone;
	    } else {
	      buffer.push(cursor);
	      continue
	    }
	  }
	  if (buffer.length) {
	    if (consume === consumeIsZone) {
	      output.zone = buffer.join('');
	    } else if (endIpv6) {
	      address.push(buffer.join(''));
	    } else {
	      address.push(stringArrayToHexStripped(buffer));
	    }
	  }
	  output.address = address.join('');
	  return output
	}

	/**
	 * @typedef {Object} NormalizeIPv6Result
	 * @property {string} host - The normalized host.
	 * @property {string} [escapedHost] - The escaped host.
	 * @property {boolean} isIPV6 - Indicates if the host is an IPv6 address.
	 */

	/**
	 * @param {string} host
	 * @returns {NormalizeIPv6Result}
	 */
	function normalizeIPv6 (host) {
	  if (findToken(host, ':') < 2) { return { host, isIPV6: false } }
	  const ipv6 = getIPV6(host);

	  if (!ipv6.error) {
	    let newHost = ipv6.address;
	    let escapedHost = ipv6.address;
	    if (ipv6.zone) {
	      newHost += '%' + ipv6.zone;
	      escapedHost += '%25' + ipv6.zone;
	    }
	    return { host: newHost, isIPV6: true, escapedHost }
	  } else {
	    return { host, isIPV6: false }
	  }
	}

	/**
	 * @param {string} str
	 * @param {string} token
	 * @returns {number}
	 */
	function findToken (str, token) {
	  let ind = 0;
	  for (let i = 0; i < str.length; i++) {
	    if (str[i] === token) ind++;
	  }
	  return ind
	}

	/**
	 * @param {string} path
	 * @returns {string}
	 *
	 * @see https://datatracker.ietf.org/doc/html/rfc3986#section-5.2.4
	 */
	function removeDotSegments (path) {
	  let input = path;
	  const output = [];
	  let nextSlash = -1;
	  let len = 0;

	  // eslint-disable-next-line no-cond-assign
	  while (len = input.length) {
	    if (len === 1) {
	      if (input === '.') {
	        break
	      } else if (input === '/') {
	        output.push('/');
	        break
	      } else {
	        output.push(input);
	        break
	      }
	    } else if (len === 2) {
	      if (input[0] === '.') {
	        if (input[1] === '.') {
	          break
	        } else if (input[1] === '/') {
	          input = input.slice(2);
	          continue
	        }
	      } else if (input[0] === '/') {
	        if (input[1] === '.' || input[1] === '/') {
	          output.push('/');
	          break
	        }
	      }
	    } else if (len === 3) {
	      if (input === '/..') {
	        if (output.length !== 0) {
	          output.pop();
	        }
	        output.push('/');
	        break
	      }
	    }
	    if (input[0] === '.') {
	      if (input[1] === '.') {
	        if (input[2] === '/') {
	          input = input.slice(3);
	          continue
	        }
	      } else if (input[1] === '/') {
	        input = input.slice(2);
	        continue
	      }
	    } else if (input[0] === '/') {
	      if (input[1] === '.') {
	        if (input[2] === '/') {
	          input = input.slice(2);
	          continue
	        } else if (input[2] === '.') {
	          if (input[3] === '/') {
	            input = input.slice(3);
	            if (output.length !== 0) {
	              output.pop();
	            }
	            continue
	          }
	        }
	      }
	    }

	    // Rule 2E: Move normal path segment to output
	    if ((nextSlash = input.indexOf('/', 1)) === -1) {
	      output.push(input);
	      break
	    } else {
	      output.push(input.slice(0, nextSlash));
	      input = input.slice(nextSlash);
	    }
	  }

	  return output.join('')
	}

	/**
	 * Re-escape RFC 3986 gen-delims that must not appear literally in the host.
	 * After the URI regex parses, these characters cannot be literal in the host
	 * field, so any that appear after decoding came from percent-encoding and
	 * must be restored to prevent authority structure changes.
	 *
	 * @param {string} host
	 * @param {boolean} isIP - true for IPv4/IPv6 hosts (skip colon re-escaping)
	 * @returns {string}
	 */
	const HOST_DELIMS = { '@': '%40', '/': '%2F', '?': '%3F', '#': '%23', ':': '%3A' };
	const HOST_DELIM_RE = /[@/?#:]/g;
	const HOST_DELIM_NO_COLON_RE = /[@/?#]/g;

	function reescapeHostDelimiters (host, isIP) {
	  const re = isIP ? HOST_DELIM_NO_COLON_RE : HOST_DELIM_RE;
	  re.lastIndex = 0;
	  return host.replace(re, (ch) => HOST_DELIMS[ch])
	}

	/**
	 * Normalizes percent escapes and optionally decodes only unreserved ASCII bytes.
	 * Reserved delimiters such as `%2F` and `%2E` stay escaped.
	 *
	 * @param {string} input
	 * @param {boolean} [decodeUnreserved=false]
	 * @returns {string}
	 */
	function normalizePercentEncoding (input, decodeUnreserved = false) {
	  if (input.indexOf('%') === -1) {
	    return input
	  }

	  let output = '';

	  for (let i = 0; i < input.length; i++) {
	    if (input[i] === '%' && i + 2 < input.length) {
	      const hex = input.slice(i + 1, i + 3);
	      if (isHexPair(hex)) {
	        const normalizedHex = hex.toUpperCase();
	        const decoded = String.fromCharCode(parseInt(normalizedHex, 16));

	        if (decodeUnreserved && isUnreserved(decoded)) {
	          output += decoded;
	        } else {
	          output += '%' + normalizedHex;
	        }

	        i += 2;
	        continue
	      }
	    }

	    output += input[i];
	  }

	  return output
	}

	/**
	 * Normalizes path data without turning reserved escapes into live path syntax.
	 * Valid escapes are uppercased, raw unsafe characters are escaped, and only
	 * unreserved bytes that are not `.` are decoded.
	 *
	 * @param {string} input
	 * @returns {string}
	 */
	function normalizePathEncoding (input) {
	  let output = '';

	  for (let i = 0; i < input.length; i++) {
	    if (input[i] === '%' && i + 2 < input.length) {
	      const hex = input.slice(i + 1, i + 3);
	      if (isHexPair(hex)) {
	        const normalizedHex = hex.toUpperCase();
	        const decoded = String.fromCharCode(parseInt(normalizedHex, 16));

	        if (decoded !== '.' && isUnreserved(decoded)) {
	          output += decoded;
	        } else {
	          output += '%' + normalizedHex;
	        }

	        i += 2;
	        continue
	      }
	    }

	    if (isPathCharacter(input[i])) {
	      output += input[i];
	    } else {
	      output += escape(input[i]);
	    }
	  }

	  return output
	}

	/**
	 * Escapes a component while preserving existing valid percent escapes.
	 *
	 * @param {string} input
	 * @returns {string}
	 */
	function escapePreservingEscapes (input) {
	  let output = '';

	  for (let i = 0; i < input.length; i++) {
	    if (input[i] === '%' && i + 2 < input.length) {
	      const hex = input.slice(i + 1, i + 3);
	      if (isHexPair(hex)) {
	        output += '%' + hex.toUpperCase();
	        i += 2;
	        continue
	      }
	    }

	    output += escape(input[i]);
	  }

	  return output
	}

	/**
	 * @param {import('../types/index').URIComponent} component
	 * @returns {string|undefined}
	 */
	function recomposeAuthority (component) {
	  const uriTokens = [];

	  if (component.userinfo !== undefined) {
	    uriTokens.push(component.userinfo);
	    uriTokens.push('@');
	  }

	  if (component.host !== undefined) {
	    let host = unescape(component.host);
	    if (!isIPv4(host)) {
	      const ipV6res = normalizeIPv6(host);
	      if (ipV6res.isIPV6 === true) {
	        host = `[${ipV6res.escapedHost}]`;
	      } else {
	        host = reescapeHostDelimiters(host, false);
	      }
	    }
	    uriTokens.push(host);
	  }

	  if (typeof component.port === 'number' || typeof component.port === 'string') {
	    uriTokens.push(':');
	    uriTokens.push(String(component.port));
	  }

	  return uriTokens.length ? uriTokens.join('') : undefined
	}
	utils = {
	  nonSimpleDomain,
	  recomposeAuthority,
	  reescapeHostDelimiters,
	  normalizePercentEncoding,
	  normalizePathEncoding,
	  escapePreservingEscapes,
	  removeDotSegments,
	  isIPv4,
	  isUUID,
	  normalizeIPv6,
	  stringArrayToHexStripped
	};
	return utils;
}

var schemes;
var hasRequiredSchemes;

function requireSchemes () {
	if (hasRequiredSchemes) return schemes;
	hasRequiredSchemes = 1;

	const { isUUID } = requireUtils();
	const URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;

	const supportedSchemeNames = /** @type {const} */ (['http', 'https', 'ws',
	  'wss', 'urn', 'urn:uuid']);

	/** @typedef {supportedSchemeNames[number]} SchemeName */

	/**
	 * @param {string} name
	 * @returns {name is SchemeName}
	 */
	function isValidSchemeName (name) {
	  return supportedSchemeNames.indexOf(/** @type {*} */ (name)) !== -1
	}

	/**
	 * @callback SchemeFn
	 * @param {import('../types/index').URIComponent} component
	 * @param {import('../types/index').Options} options
	 * @returns {import('../types/index').URIComponent}
	 */

	/**
	 * @typedef {Object} SchemeHandler
	 * @property {SchemeName} scheme - The scheme name.
	 * @property {boolean} [domainHost] - Indicates if the scheme supports domain hosts.
	 * @property {SchemeFn} parse - Function to parse the URI component for this scheme.
	 * @property {SchemeFn} serialize - Function to serialize the URI component for this scheme.
	 * @property {boolean} [skipNormalize] - Indicates if normalization should be skipped for this scheme.
	 * @property {boolean} [absolutePath] - Indicates if the scheme uses absolute paths.
	 * @property {boolean} [unicodeSupport] - Indicates if the scheme supports Unicode.
	 */

	/**
	 * @param {import('../types/index').URIComponent} wsComponent
	 * @returns {boolean}
	 */
	function wsIsSecure (wsComponent) {
	  if (wsComponent.secure === true) {
	    return true
	  } else if (wsComponent.secure === false) {
	    return false
	  } else if (wsComponent.scheme) {
	    return (
	      wsComponent.scheme.length === 3 &&
	      (wsComponent.scheme[0] === 'w' || wsComponent.scheme[0] === 'W') &&
	      (wsComponent.scheme[1] === 's' || wsComponent.scheme[1] === 'S') &&
	      (wsComponent.scheme[2] === 's' || wsComponent.scheme[2] === 'S')
	    )
	  } else {
	    return false
	  }
	}

	/** @type {SchemeFn} */
	function httpParse (component) {
	  if (!component.host) {
	    component.error = component.error || 'HTTP URIs must have a host.';
	  }

	  return component
	}

	/** @type {SchemeFn} */
	function httpSerialize (component) {
	  const secure = String(component.scheme).toLowerCase() === 'https';

	  // normalize the default port
	  if (component.port === (secure ? 443 : 80) || component.port === '') {
	    component.port = undefined;
	  }

	  // normalize the empty path
	  if (!component.path) {
	    component.path = '/';
	  }

	  // NOTE: We do not parse query strings for HTTP URIs
	  // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
	  // and not the HTTP spec.

	  return component
	}

	/** @type {SchemeFn} */
	function wsParse (wsComponent) {
	// indicate if the secure flag is set
	  wsComponent.secure = wsIsSecure(wsComponent);

	  // construct resouce name
	  wsComponent.resourceName = (wsComponent.path || '/') + (wsComponent.query ? '?' + wsComponent.query : '');
	  wsComponent.path = undefined;
	  wsComponent.query = undefined;

	  return wsComponent
	}

	/** @type {SchemeFn} */
	function wsSerialize (wsComponent) {
	// normalize the default port
	  if (wsComponent.port === (wsIsSecure(wsComponent) ? 443 : 80) || wsComponent.port === '') {
	    wsComponent.port = undefined;
	  }

	  // ensure scheme matches secure flag
	  if (typeof wsComponent.secure === 'boolean') {
	    wsComponent.scheme = (wsComponent.secure ? 'wss' : 'ws');
	    wsComponent.secure = undefined;
	  }

	  // reconstruct path from resource name
	  if (wsComponent.resourceName) {
	    const [path, query] = wsComponent.resourceName.split('?');
	    wsComponent.path = (path && path !== '/' ? path : undefined);
	    wsComponent.query = query;
	    wsComponent.resourceName = undefined;
	  }

	  // forbid fragment component
	  wsComponent.fragment = undefined;

	  return wsComponent
	}

	/** @type {SchemeFn} */
	function urnParse (urnComponent, options) {
	  if (!urnComponent.path) {
	    urnComponent.error = 'URN can not be parsed';
	    return urnComponent
	  }
	  const matches = urnComponent.path.match(URN_REG);
	  if (matches) {
	    const scheme = options.scheme || urnComponent.scheme || 'urn';
	    urnComponent.nid = matches[1].toLowerCase();
	    urnComponent.nss = matches[2];
	    const urnScheme = `${scheme}:${options.nid || urnComponent.nid}`;
	    const schemeHandler = getSchemeHandler(urnScheme);
	    urnComponent.path = undefined;

	    if (schemeHandler) {
	      urnComponent = schemeHandler.parse(urnComponent, options);
	    }
	  } else {
	    urnComponent.error = urnComponent.error || 'URN can not be parsed.';
	  }

	  return urnComponent
	}

	/** @type {SchemeFn} */
	function urnSerialize (urnComponent, options) {
	  if (urnComponent.nid === undefined) {
	    throw new Error('URN without nid cannot be serialized')
	  }
	  const scheme = options.scheme || urnComponent.scheme || 'urn';
	  const nid = urnComponent.nid.toLowerCase();
	  const urnScheme = `${scheme}:${options.nid || nid}`;
	  const schemeHandler = getSchemeHandler(urnScheme);

	  if (schemeHandler) {
	    urnComponent = schemeHandler.serialize(urnComponent, options);
	  }

	  const uriComponent = urnComponent;
	  const nss = urnComponent.nss;
	  uriComponent.path = `${nid || options.nid}:${nss}`;

	  options.skipEscape = true;
	  return uriComponent
	}

	/** @type {SchemeFn} */
	function urnuuidParse (urnComponent, options) {
	  const uuidComponent = urnComponent;
	  uuidComponent.uuid = uuidComponent.nss;
	  uuidComponent.nss = undefined;

	  if (!options.tolerant && (!uuidComponent.uuid || !isUUID(uuidComponent.uuid))) {
	    uuidComponent.error = uuidComponent.error || 'UUID is not valid.';
	  }

	  return uuidComponent
	}

	/** @type {SchemeFn} */
	function urnuuidSerialize (uuidComponent) {
	  const urnComponent = uuidComponent;
	  // normalize UUID
	  urnComponent.nss = (uuidComponent.uuid || '').toLowerCase();
	  return urnComponent
	}

	const http = /** @type {SchemeHandler} */ ({
	  scheme: 'http',
	  domainHost: true,
	  parse: httpParse,
	  serialize: httpSerialize
	});

	const https = /** @type {SchemeHandler} */ ({
	  scheme: 'https',
	  domainHost: http.domainHost,
	  parse: httpParse,
	  serialize: httpSerialize
	});

	const ws = /** @type {SchemeHandler} */ ({
	  scheme: 'ws',
	  domainHost: true,
	  parse: wsParse,
	  serialize: wsSerialize
	});

	const wss = /** @type {SchemeHandler} */ ({
	  scheme: 'wss',
	  domainHost: ws.domainHost,
	  parse: ws.parse,
	  serialize: ws.serialize
	});

	const urn = /** @type {SchemeHandler} */ ({
	  scheme: 'urn',
	  parse: urnParse,
	  serialize: urnSerialize,
	  skipNormalize: true
	});

	const urnuuid = /** @type {SchemeHandler} */ ({
	  scheme: 'urn:uuid',
	  parse: urnuuidParse,
	  serialize: urnuuidSerialize,
	  skipNormalize: true
	});

	const SCHEMES = /** @type {Record<SchemeName, SchemeHandler>} */ ({
	  http,
	  https,
	  ws,
	  wss,
	  urn,
	  'urn:uuid': urnuuid
	});

	Object.setPrototypeOf(SCHEMES, null);

	/**
	 * @param {string|undefined} scheme
	 * @returns {SchemeHandler|undefined}
	 */
	function getSchemeHandler (scheme) {
	  return (
	    scheme && (
	      SCHEMES[/** @type {SchemeName} */ (scheme)] ||
	      SCHEMES[/** @type {SchemeName} */(scheme.toLowerCase())])
	  ) ||
	    undefined
	}

	schemes = {
	  wsIsSecure,
	  SCHEMES,
	  isValidSchemeName,
	  getSchemeHandler,
	};
	return schemes;
}

var hasRequiredFastUri;

function requireFastUri () {
	if (hasRequiredFastUri) return fastUri.exports;
	hasRequiredFastUri = 1;

	const { normalizeIPv6, removeDotSegments, recomposeAuthority, normalizePercentEncoding, normalizePathEncoding, escapePreservingEscapes, reescapeHostDelimiters, isIPv4, nonSimpleDomain } = requireUtils();
	const { SCHEMES, getSchemeHandler } = requireSchemes();

	/**
	 * @template {import('./types/index').URIComponent|string} T
	 * @param {T} uri
	 * @param {import('./types/index').Options} [options]
	 * @returns {T}
	 */
	function normalize (uri, options) {
	  if (typeof uri === 'string') {
	    uri = /** @type {T} */ (normalizeString(uri, options));
	  } else if (typeof uri === 'object') {
	    uri = /** @type {T} */ (parse(serialize(uri, options), options));
	  }
	  return uri
	}

	/**
	 * @param {string} baseURI
	 * @param {string} relativeURI
	 * @param {import('./types/index').Options} [options]
	 * @returns {string}
	 */
	function resolve (baseURI, relativeURI, options) {
	  const schemelessOptions = options ? Object.assign({ scheme: 'null' }, options) : { scheme: 'null' };
	  const resolved = resolveComponent(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true);
	  schemelessOptions.skipEscape = true;
	  return serialize(resolved, schemelessOptions)
	}

	/**
	 * @param {import ('./types/index').URIComponent} base
	 * @param {import ('./types/index').URIComponent} relative
	 * @param {import('./types/index').Options} [options]
	 * @param {boolean} [skipNormalization=false]
	 * @returns {import ('./types/index').URIComponent}
	 */
	function resolveComponent (base, relative, options, skipNormalization) {
	  /** @type {import('./types/index').URIComponent} */
	  const target = {};
	  if (!skipNormalization) {
	    base = parse(serialize(base, options), options); // normalize base component
	    relative = parse(serialize(relative, options), options); // normalize relative component
	  }
	  options = options || {};

	  if (!options.tolerant && relative.scheme) {
	    target.scheme = relative.scheme;
	    // target.authority = relative.authority;
	    target.userinfo = relative.userinfo;
	    target.host = relative.host;
	    target.port = relative.port;
	    target.path = removeDotSegments(relative.path || '');
	    target.query = relative.query;
	  } else {
	    if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
	      // target.authority = relative.authority;
	      target.userinfo = relative.userinfo;
	      target.host = relative.host;
	      target.port = relative.port;
	      target.path = removeDotSegments(relative.path || '');
	      target.query = relative.query;
	    } else {
	      if (!relative.path) {
	        target.path = base.path;
	        if (relative.query !== undefined) {
	          target.query = relative.query;
	        } else {
	          target.query = base.query;
	        }
	      } else {
	        if (relative.path[0] === '/') {
	          target.path = removeDotSegments(relative.path);
	        } else {
	          if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) {
	            target.path = '/' + relative.path;
	          } else if (!base.path) {
	            target.path = relative.path;
	          } else {
	            target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
	          }
	          target.path = removeDotSegments(target.path);
	        }
	        target.query = relative.query;
	      }
	      // target.authority = base.authority;
	      target.userinfo = base.userinfo;
	      target.host = base.host;
	      target.port = base.port;
	    }
	    target.scheme = base.scheme;
	  }

	  target.fragment = relative.fragment;

	  return target
	}

	/**
	 * @param {import ('./types/index').URIComponent|string} uriA
	 * @param {import ('./types/index').URIComponent|string} uriB
	 * @param {import ('./types/index').Options} options
	 * @returns {boolean}
	 */
	function equal (uriA, uriB, options) {
	  const normalizedA = normalizeComparableURI(uriA, options);
	  const normalizedB = normalizeComparableURI(uriB, options);

	  return normalizedA !== undefined && normalizedB !== undefined && normalizedA.toLowerCase() === normalizedB.toLowerCase()
	}

	/**
	 * @param {Readonly<import('./types/index').URIComponent>} cmpts
	 * @param {import('./types/index').Options} [opts]
	 * @returns {string}
	 */
	function serialize (cmpts, opts) {
	  const component = {
	    host: cmpts.host,
	    scheme: cmpts.scheme,
	    userinfo: cmpts.userinfo,
	    port: cmpts.port,
	    path: cmpts.path,
	    query: cmpts.query,
	    nid: cmpts.nid,
	    nss: cmpts.nss,
	    uuid: cmpts.uuid,
	    fragment: cmpts.fragment,
	    reference: cmpts.reference,
	    resourceName: cmpts.resourceName,
	    secure: cmpts.secure,
	    error: ''
	  };
	  const options = Object.assign({}, opts);
	  const uriTokens = [];

	  // find scheme handler
	  const schemeHandler = getSchemeHandler(options.scheme || component.scheme);

	  // perform scheme specific serialization
	  if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(component, options);

	  if (component.path !== undefined) {
	    if (!options.skipEscape) {
	      component.path = escapePreservingEscapes(component.path);

	      if (component.scheme !== undefined) {
	        component.path = component.path.split('%3A').join(':');
	      }
	    } else {
	      component.path = normalizePercentEncoding(component.path);
	    }
	  }

	  if (options.reference !== 'suffix' && component.scheme) {
	    uriTokens.push(component.scheme, ':');
	  }

	  const authority = recomposeAuthority(component);
	  if (authority !== undefined) {
	    if (options.reference !== 'suffix') {
	      uriTokens.push('//');
	    }

	    uriTokens.push(authority);

	    if (component.path && component.path[0] !== '/') {
	      uriTokens.push('/');
	    }
	  }
	  if (component.path !== undefined) {
	    let s = component.path;

	    if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) {
	      s = removeDotSegments(s);
	    }

	    if (
	      authority === undefined &&
	      s[0] === '/' &&
	      s[1] === '/'
	    ) {
	      // don't allow the path to start with "//"
	      s = '/%2F' + s.slice(2);
	    }

	    uriTokens.push(s);
	  }

	  if (component.query !== undefined) {
	    uriTokens.push('?', component.query);
	  }

	  if (component.fragment !== undefined) {
	    uriTokens.push('#', component.fragment);
	  }
	  return uriTokens.join('')
	}

	const URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;

	/**
	 * @param {import('./types/index').URIComponent} parsed
	 * @param {RegExpMatchArray} matches
	 * @returns {string|undefined}
	 */
	function getParseError (parsed, matches) {
	  if (matches[2] !== undefined && parsed.path && parsed.path[0] !== '/') {
	    return 'URI path must start with "/" when authority is present.'
	  }

	  if (typeof parsed.port === 'number' && (parsed.port < 0 || parsed.port > 65535)) {
	    return 'URI port is malformed.'
	  }

	  return undefined
	}

	/**
	 * @param {string} uri
	 * @param {import('./types/index').Options} [opts]
	 * @returns {{ parsed: import('./types/index').URIComponent, malformedAuthorityOrPort: boolean }}
	 */
	function parseWithStatus (uri, opts) {
	  const options = Object.assign({}, opts);
	  /** @type {import('./types/index').URIComponent} */
	  const parsed = {
	    scheme: undefined,
	    userinfo: undefined,
	    host: '',
	    port: undefined,
	    path: '',
	    query: undefined,
	    fragment: undefined
	  };

	  let malformedAuthorityOrPort = false;

	  let isIP = false;
	  if (options.reference === 'suffix') {
	    if (options.scheme) {
	      uri = options.scheme + ':' + uri;
	    } else {
	      uri = '//' + uri;
	    }
	  }

	  const matches = uri.match(URI_PARSE);

	  if (matches) {
	    // store each component
	    parsed.scheme = matches[1];
	    parsed.userinfo = matches[3];
	    parsed.host = matches[4];
	    parsed.port = parseInt(matches[5], 10);
	    parsed.path = matches[6] || '';
	    parsed.query = matches[7];
	    parsed.fragment = matches[8];

	    // fix port number
	    if (isNaN(parsed.port)) {
	      parsed.port = matches[5];
	    }

	    const parseError = getParseError(parsed, matches);
	    if (parseError !== undefined) {
	      parsed.error = parsed.error || parseError;
	      malformedAuthorityOrPort = true;
	    }

	    if (parsed.host) {
	      const ipv4result = isIPv4(parsed.host);
	      if (ipv4result === false) {
	        const ipv6result = normalizeIPv6(parsed.host);
	        parsed.host = ipv6result.host.toLowerCase();
	        isIP = ipv6result.isIPV6;
	      } else {
	        isIP = true;
	      }
	    }
	    if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && parsed.query === undefined && !parsed.path) {
	      parsed.reference = 'same-document';
	    } else if (parsed.scheme === undefined) {
	      parsed.reference = 'relative';
	    } else if (parsed.fragment === undefined) {
	      parsed.reference = 'absolute';
	    } else {
	      parsed.reference = 'uri';
	    }

	    // check for reference errors
	    if (options.reference && options.reference !== 'suffix' && options.reference !== parsed.reference) {
	      parsed.error = parsed.error || 'URI is not a ' + options.reference + ' reference.';
	    }

	    // find scheme handler
	    const schemeHandler = getSchemeHandler(options.scheme || parsed.scheme);

	    // check if scheme can't handle IRIs
	    if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
	      // if host component is a domain name
	      if (parsed.host && (options.domainHost || (schemeHandler && schemeHandler.domainHost)) && isIP === false && nonSimpleDomain(parsed.host)) {
	        // convert Unicode IDN -> ASCII IDN
	        try {
	          parsed.host = URL.domainToASCII(parsed.host.toLowerCase());
	        } catch (e) {
	          parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
	        }
	      }
	      // convert IRI -> URI
	    }

	    if (!schemeHandler || (schemeHandler && !schemeHandler.skipNormalize)) {
	      if (uri.indexOf('%') !== -1) {
	        if (parsed.scheme !== undefined) {
	          parsed.scheme = unescape(parsed.scheme);
	        }
	        if (parsed.host !== undefined) {
	          parsed.host = reescapeHostDelimiters(unescape(parsed.host), isIP);
	        }
	      }
	      if (parsed.path) {
	        parsed.path = normalizePathEncoding(parsed.path);
	      }
	      if (parsed.fragment) {
	        try {
	          parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
	        } catch {
	          parsed.error = parsed.error || 'URI malformed';
	        }
	      }
	    }

	    // perform scheme specific parsing
	    if (schemeHandler && schemeHandler.parse) {
	      schemeHandler.parse(parsed, options);
	    }
	  } else {
	    parsed.error = parsed.error || 'URI can not be parsed.';
	  }
	  return { parsed, malformedAuthorityOrPort }
	}

	/**
	 * @param {string} uri
	 * @param {import('./types/index').Options} [opts]
	 * @returns
	 */
	function parse (uri, opts) {
	  return parseWithStatus(uri, opts).parsed
	}

	/**
	 * @param {string} uri
	 * @param {import('./types/index').Options} [opts]
	 * @returns {string}
	 */
	function normalizeString (uri, opts) {
	  return normalizeStringWithStatus(uri, opts).normalized
	}

	/**
	 * @param {string} uri
	 * @param {import('./types/index').Options} [opts]
	 * @returns {{ normalized: string, malformedAuthorityOrPort: boolean }}
	 */
	function normalizeStringWithStatus (uri, opts) {
	  const { parsed, malformedAuthorityOrPort } = parseWithStatus(uri, opts);
	  return {
	    normalized: malformedAuthorityOrPort ? uri : serialize(parsed, opts),
	    malformedAuthorityOrPort
	  }
	}

	/**
	 * @param {import ('./types/index').URIComponent|string} uri
	 * @param {import('./types/index').Options} [opts]
	 * @returns {string|undefined}
	 */
	function normalizeComparableURI (uri, opts) {
	  if (typeof uri === 'string') {
	    const { normalized, malformedAuthorityOrPort } = normalizeStringWithStatus(uri, opts);
	    return malformedAuthorityOrPort ? undefined : normalized
	  }

	  if (typeof uri === 'object') {
	    return serialize(uri, opts)
	  }
	}

	const fastUri$1 = {
	  SCHEMES,
	  normalize,
	  resolve,
	  resolveComponent,
	  equal,
	  serialize,
	  parse
	};

	fastUri.exports = fastUri$1;
	fastUri.exports.default = fastUri$1;
	fastUri.exports.fastUri = fastUri$1;
	return fastUri.exports;
}

var hasRequiredUri;

function requireUri () {
	if (hasRequiredUri) return uri;
	hasRequiredUri = 1;
	Object.defineProperty(uri, "__esModule", { value: true });
	const uri$1 = requireFastUri();
	uri$1.code = 'require("ajv/dist/runtime/uri").default';
	uri.default = uri$1;
	
	return uri;
}

var hasRequiredCore$1;

function requireCore$1 () {
	if (hasRequiredCore$1) return core$1;
	hasRequiredCore$1 = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;
		var validate_1 = /*@__PURE__*/ requireValidate();
		Object.defineProperty(exports, "KeywordCxt", { enumerable: true, get: function () { return validate_1.KeywordCxt; } });
		var codegen_1 = /*@__PURE__*/ requireCodegen();
		Object.defineProperty(exports, "_", { enumerable: true, get: function () { return codegen_1._; } });
		Object.defineProperty(exports, "str", { enumerable: true, get: function () { return codegen_1.str; } });
		Object.defineProperty(exports, "stringify", { enumerable: true, get: function () { return codegen_1.stringify; } });
		Object.defineProperty(exports, "nil", { enumerable: true, get: function () { return codegen_1.nil; } });
		Object.defineProperty(exports, "Name", { enumerable: true, get: function () { return codegen_1.Name; } });
		Object.defineProperty(exports, "CodeGen", { enumerable: true, get: function () { return codegen_1.CodeGen; } });
		const validation_error_1 = /*@__PURE__*/ requireValidation_error();
		const ref_error_1 = /*@__PURE__*/ requireRef_error();
		const rules_1 = /*@__PURE__*/ requireRules();
		const compile_1 = /*@__PURE__*/ requireCompile();
		const codegen_2 = /*@__PURE__*/ requireCodegen();
		const resolve_1 = /*@__PURE__*/ requireResolve();
		const dataType_1 = /*@__PURE__*/ requireDataType();
		const util_1 = /*@__PURE__*/ requireUtil();
		const $dataRefSchema = require$$9;
		const uri_1 = /*@__PURE__*/ requireUri();
		const defaultRegExp = (str, flags) => new RegExp(str, flags);
		defaultRegExp.code = "new RegExp";
		const META_IGNORE_OPTIONS = ["removeAdditional", "useDefaults", "coerceTypes"];
		const EXT_SCOPE_NAMES = new Set([
		    "validate",
		    "serialize",
		    "parse",
		    "wrapper",
		    "root",
		    "schema",
		    "keyword",
		    "pattern",
		    "formats",
		    "validate$data",
		    "func",
		    "obj",
		    "Error",
		]);
		const removedOptions = {
		    errorDataPath: "",
		    format: "`validateFormats: false` can be used instead.",
		    nullable: '"nullable" keyword is supported by default.',
		    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
		    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
		    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
		    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
		    sourceCode: "Use option `code: {source: true}`",
		    strictDefaults: "It is default now, see option `strict`.",
		    strictKeywords: "It is default now, see option `strict`.",
		    uniqueItems: '"uniqueItems" keyword is always validated.',
		    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
		    cache: "Map is used as cache, schema object as key.",
		    serialize: "Map is used as cache, schema object as key.",
		    ajvErrors: "It is default now.",
		};
		const deprecatedOptions = {
		    ignoreKeywordsWithRef: "",
		    jsPropertySyntax: "",
		    unicode: '"minLength"/"maxLength" account for unicode characters by default.',
		};
		const MAX_EXPRESSION = 200;
		// eslint-disable-next-line complexity
		function requiredOptions(o) {
		    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
		    const s = o.strict;
		    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
		    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
		    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : defaultRegExp;
		    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : uri_1.default;
		    return {
		        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
		        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
		        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
		        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
		        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
		        code: o.code ? { ...o.code, optimize, regExp } : { optimize, regExp },
		        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : MAX_EXPRESSION,
		        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : MAX_EXPRESSION,
		        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
		        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
		        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
		        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
		        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
		        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
		        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
		        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
		        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
		        uriResolver: uriResolver,
		    };
		}
		class Ajv {
		    constructor(opts = {}) {
		        this.schemas = {};
		        this.refs = {};
		        this.formats = Object.create(null);
		        this._compilations = new Set();
		        this._loading = {};
		        this._cache = new Map();
		        opts = this.opts = { ...opts, ...requiredOptions(opts) };
		        const { es5, lines } = this.opts.code;
		        this.scope = new codegen_2.ValueScope({ scope: {}, prefixes: EXT_SCOPE_NAMES, es5, lines });
		        this.logger = getLogger(opts.logger);
		        const formatOpt = opts.validateFormats;
		        opts.validateFormats = false;
		        this.RULES = (0, rules_1.getRules)();
		        checkOptions.call(this, removedOptions, opts, "NOT SUPPORTED");
		        checkOptions.call(this, deprecatedOptions, opts, "DEPRECATED", "warn");
		        this._metaOpts = getMetaSchemaOptions.call(this);
		        if (opts.formats)
		            addInitialFormats.call(this);
		        this._addVocabularies();
		        this._addDefaultMetaSchema();
		        if (opts.keywords)
		            addInitialKeywords.call(this, opts.keywords);
		        if (typeof opts.meta == "object")
		            this.addMetaSchema(opts.meta);
		        addInitialSchemas.call(this);
		        opts.validateFormats = formatOpt;
		    }
		    _addVocabularies() {
		        this.addKeyword("$async");
		    }
		    _addDefaultMetaSchema() {
		        const { $data, meta, schemaId } = this.opts;
		        let _dataRefSchema = $dataRefSchema;
		        if (schemaId === "id") {
		            _dataRefSchema = { ...$dataRefSchema };
		            _dataRefSchema.id = _dataRefSchema.$id;
		            delete _dataRefSchema.$id;
		        }
		        if (meta && $data)
		            this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
		    }
		    defaultMeta() {
		        const { meta, schemaId } = this.opts;
		        return (this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined);
		    }
		    validate(schemaKeyRef, // key, ref or schema object
		    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
		    data // to be validated
		    ) {
		        let v;
		        if (typeof schemaKeyRef == "string") {
		            v = this.getSchema(schemaKeyRef);
		            if (!v)
		                throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
		        }
		        else {
		            v = this.compile(schemaKeyRef);
		        }
		        const valid = v(data);
		        if (!("$async" in v))
		            this.errors = v.errors;
		        return valid;
		    }
		    compile(schema, _meta) {
		        const sch = this._addSchema(schema, _meta);
		        return (sch.validate || this._compileSchemaEnv(sch));
		    }
		    compileAsync(schema, meta) {
		        if (typeof this.opts.loadSchema != "function") {
		            throw new Error("options.loadSchema should be a function");
		        }
		        const { loadSchema } = this.opts;
		        return runCompileAsync.call(this, schema, meta);
		        async function runCompileAsync(_schema, _meta) {
		            await loadMetaSchema.call(this, _schema.$schema);
		            const sch = this._addSchema(_schema, _meta);
		            return sch.validate || _compileAsync.call(this, sch);
		        }
		        async function loadMetaSchema($ref) {
		            if ($ref && !this.getSchema($ref)) {
		                await runCompileAsync.call(this, { $ref }, true);
		            }
		        }
		        async function _compileAsync(sch) {
		            try {
		                return this._compileSchemaEnv(sch);
		            }
		            catch (e) {
		                if (!(e instanceof ref_error_1.default))
		                    throw e;
		                checkLoaded.call(this, e);
		                await loadMissingSchema.call(this, e.missingSchema);
		                return _compileAsync.call(this, sch);
		            }
		        }
		        function checkLoaded({ missingSchema: ref, missingRef }) {
		            if (this.refs[ref]) {
		                throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
		            }
		        }
		        async function loadMissingSchema(ref) {
		            const _schema = await _loadSchema.call(this, ref);
		            if (!this.refs[ref])
		                await loadMetaSchema.call(this, _schema.$schema);
		            if (!this.refs[ref])
		                this.addSchema(_schema, ref, meta);
		        }
		        async function _loadSchema(ref) {
		            const p = this._loading[ref];
		            if (p)
		                return p;
		            try {
		                return await (this._loading[ref] = loadSchema(ref));
		            }
		            finally {
		                delete this._loading[ref];
		            }
		        }
		    }
		    // Adds schema to the instance
		    addSchema(schema, // If array is passed, `key` will be ignored
		    key, // Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
		    _meta, // true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
		    _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
		    ) {
		        if (Array.isArray(schema)) {
		            for (const sch of schema)
		                this.addSchema(sch, undefined, _meta, _validateSchema);
		            return this;
		        }
		        let id;
		        if (typeof schema === "object") {
		            const { schemaId } = this.opts;
		            id = schema[schemaId];
		            if (id !== undefined && typeof id != "string") {
		                throw new Error(`schema ${schemaId} must be string`);
		            }
		        }
		        key = (0, resolve_1.normalizeId)(key || id);
		        this._checkUnique(key);
		        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
		        return this;
		    }
		    // Add schema that will be used to validate other schemas
		    // options in META_IGNORE_OPTIONS are alway set to false
		    addMetaSchema(schema, key, // schema key
		    _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
		    ) {
		        this.addSchema(schema, key, true, _validateSchema);
		        return this;
		    }
		    //  Validate schema against its meta-schema
		    validateSchema(schema, throwOrLogError) {
		        if (typeof schema == "boolean")
		            return true;
		        let $schema;
		        $schema = schema.$schema;
		        if ($schema !== undefined && typeof $schema != "string") {
		            throw new Error("$schema must be a string");
		        }
		        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
		        if (!$schema) {
		            this.logger.warn("meta-schema not available");
		            this.errors = null;
		            return true;
		        }
		        const valid = this.validate($schema, schema);
		        if (!valid && throwOrLogError) {
		            const message = "schema is invalid: " + this.errorsText();
		            if (this.opts.validateSchema === "log")
		                this.logger.error(message);
		            else
		                throw new Error(message);
		        }
		        return valid;
		    }
		    // Get compiled schema by `key` or `ref`.
		    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
		    getSchema(keyRef) {
		        let sch;
		        while (typeof (sch = getSchEnv.call(this, keyRef)) == "string")
		            keyRef = sch;
		        if (sch === undefined) {
		            const { schemaId } = this.opts;
		            const root = new compile_1.SchemaEnv({ schema: {}, schemaId });
		            sch = compile_1.resolveSchema.call(this, root, keyRef);
		            if (!sch)
		                return;
		            this.refs[keyRef] = sch;
		        }
		        return (sch.validate || this._compileSchemaEnv(sch));
		    }
		    // Remove cached schema(s).
		    // If no parameter is passed all schemas but meta-schemas are removed.
		    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
		    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
		    removeSchema(schemaKeyRef) {
		        if (schemaKeyRef instanceof RegExp) {
		            this._removeAllSchemas(this.schemas, schemaKeyRef);
		            this._removeAllSchemas(this.refs, schemaKeyRef);
		            return this;
		        }
		        switch (typeof schemaKeyRef) {
		            case "undefined":
		                this._removeAllSchemas(this.schemas);
		                this._removeAllSchemas(this.refs);
		                this._cache.clear();
		                return this;
		            case "string": {
		                const sch = getSchEnv.call(this, schemaKeyRef);
		                if (typeof sch == "object")
		                    this._cache.delete(sch.schema);
		                delete this.schemas[schemaKeyRef];
		                delete this.refs[schemaKeyRef];
		                return this;
		            }
		            case "object": {
		                const cacheKey = schemaKeyRef;
		                this._cache.delete(cacheKey);
		                let id = schemaKeyRef[this.opts.schemaId];
		                if (id) {
		                    id = (0, resolve_1.normalizeId)(id);
		                    delete this.schemas[id];
		                    delete this.refs[id];
		                }
		                return this;
		            }
		            default:
		                throw new Error("ajv.removeSchema: invalid parameter");
		        }
		    }
		    // add "vocabulary" - a collection of keywords
		    addVocabulary(definitions) {
		        for (const def of definitions)
		            this.addKeyword(def);
		        return this;
		    }
		    addKeyword(kwdOrDef, def // deprecated
		    ) {
		        let keyword;
		        if (typeof kwdOrDef == "string") {
		            keyword = kwdOrDef;
		            if (typeof def == "object") {
		                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
		                def.keyword = keyword;
		            }
		        }
		        else if (typeof kwdOrDef == "object" && def === undefined) {
		            def = kwdOrDef;
		            keyword = def.keyword;
		            if (Array.isArray(keyword) && !keyword.length) {
		                throw new Error("addKeywords: keyword must be string or non-empty array");
		            }
		        }
		        else {
		            throw new Error("invalid addKeywords parameters");
		        }
		        checkKeyword.call(this, keyword, def);
		        if (!def) {
		            (0, util_1.eachItem)(keyword, (kwd) => addRule.call(this, kwd));
		            return this;
		        }
		        keywordMetaschema.call(this, def);
		        const definition = {
		            ...def,
		            type: (0, dataType_1.getJSONTypes)(def.type),
		            schemaType: (0, dataType_1.getJSONTypes)(def.schemaType),
		        };
		        (0, util_1.eachItem)(keyword, definition.type.length === 0
		            ? (k) => addRule.call(this, k, definition)
		            : (k) => definition.type.forEach((t) => addRule.call(this, k, definition, t)));
		        return this;
		    }
		    getKeyword(keyword) {
		        const rule = this.RULES.all[keyword];
		        return typeof rule == "object" ? rule.definition : !!rule;
		    }
		    // Remove keyword
		    removeKeyword(keyword) {
		        // TODO return type should be Ajv
		        const { RULES } = this;
		        delete RULES.keywords[keyword];
		        delete RULES.all[keyword];
		        for (const group of RULES.rules) {
		            const i = group.rules.findIndex((rule) => rule.keyword === keyword);
		            if (i >= 0)
		                group.rules.splice(i, 1);
		        }
		        return this;
		    }
		    // Add format
		    addFormat(name, format) {
		        if (typeof format == "string")
		            format = new RegExp(format);
		        this.formats[name] = format;
		        return this;
		    }
		    errorsText(errors = this.errors, // optional array of validation errors
		    { separator = ", ", dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
		    ) {
		        if (!errors || errors.length === 0)
		            return "No errors";
		        return errors
		            .map((e) => `${dataVar}${e.instancePath} ${e.message}`)
		            .reduce((text, msg) => text + separator + msg);
		    }
		    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
		        const rules = this.RULES.all;
		        metaSchema = JSON.parse(JSON.stringify(metaSchema));
		        for (const jsonPointer of keywordsJsonPointers) {
		            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
		            let keywords = metaSchema;
		            for (const seg of segments)
		                keywords = keywords[seg];
		            for (const key in rules) {
		                const rule = rules[key];
		                if (typeof rule != "object")
		                    continue;
		                const { $data } = rule.definition;
		                const schema = keywords[key];
		                if ($data && schema)
		                    keywords[key] = schemaOrData(schema);
		            }
		        }
		        return metaSchema;
		    }
		    _removeAllSchemas(schemas, regex) {
		        for (const keyRef in schemas) {
		            const sch = schemas[keyRef];
		            if (!regex || regex.test(keyRef)) {
		                if (typeof sch == "string") {
		                    delete schemas[keyRef];
		                }
		                else if (sch && !sch.meta) {
		                    this._cache.delete(sch.schema);
		                    delete schemas[keyRef];
		                }
		            }
		        }
		    }
		    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
		        let id;
		        const { schemaId } = this.opts;
		        if (typeof schema == "object") {
		            id = schema[schemaId];
		        }
		        else {
		            if (this.opts.jtd)
		                throw new Error("schema must be object");
		            else if (typeof schema != "boolean")
		                throw new Error("schema must be object or boolean");
		        }
		        let sch = this._cache.get(schema);
		        if (sch !== undefined)
		            return sch;
		        baseId = (0, resolve_1.normalizeId)(id || baseId);
		        const localRefs = resolve_1.getSchemaRefs.call(this, schema, baseId);
		        sch = new compile_1.SchemaEnv({ schema, schemaId, meta, baseId, localRefs });
		        this._cache.set(sch.schema, sch);
		        if (addSchema && !baseId.startsWith("#")) {
		            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
		            if (baseId)
		                this._checkUnique(baseId);
		            this.refs[baseId] = sch;
		        }
		        if (validateSchema)
		            this.validateSchema(schema, true);
		        return sch;
		    }
		    _checkUnique(id) {
		        if (this.schemas[id] || this.refs[id]) {
		            throw new Error(`schema with key or id "${id}" already exists`);
		        }
		    }
		    _compileSchemaEnv(sch) {
		        if (sch.meta)
		            this._compileMetaSchema(sch);
		        else
		            compile_1.compileSchema.call(this, sch);
		        /* istanbul ignore if */
		        if (!sch.validate)
		            throw new Error("ajv implementation error");
		        return sch.validate;
		    }
		    _compileMetaSchema(sch) {
		        const currentOpts = this.opts;
		        this.opts = this._metaOpts;
		        try {
		            compile_1.compileSchema.call(this, sch);
		        }
		        finally {
		            this.opts = currentOpts;
		        }
		    }
		}
		Ajv.ValidationError = validation_error_1.default;
		Ajv.MissingRefError = ref_error_1.default;
		exports.default = Ajv;
		function checkOptions(checkOpts, options, msg, log = "error") {
		    for (const key in checkOpts) {
		        const opt = key;
		        if (opt in options)
		            this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
		    }
		}
		function getSchEnv(keyRef) {
		    keyRef = (0, resolve_1.normalizeId)(keyRef); // TODO tests fail without this line
		    return this.schemas[keyRef] || this.refs[keyRef];
		}
		function addInitialSchemas() {
		    const optsSchemas = this.opts.schemas;
		    if (!optsSchemas)
		        return;
		    if (Array.isArray(optsSchemas))
		        this.addSchema(optsSchemas);
		    else
		        for (const key in optsSchemas)
		            this.addSchema(optsSchemas[key], key);
		}
		function addInitialFormats() {
		    for (const name in this.opts.formats) {
		        const format = this.opts.formats[name];
		        if (format)
		            this.addFormat(name, format);
		    }
		}
		function addInitialKeywords(defs) {
		    if (Array.isArray(defs)) {
		        this.addVocabulary(defs);
		        return;
		    }
		    this.logger.warn("keywords option as map is deprecated, pass array");
		    for (const keyword in defs) {
		        const def = defs[keyword];
		        if (!def.keyword)
		            def.keyword = keyword;
		        this.addKeyword(def);
		    }
		}
		function getMetaSchemaOptions() {
		    const metaOpts = { ...this.opts };
		    for (const opt of META_IGNORE_OPTIONS)
		        delete metaOpts[opt];
		    return metaOpts;
		}
		const noLogs = { log() { }, warn() { }, error() { } };
		function getLogger(logger) {
		    if (logger === false)
		        return noLogs;
		    if (logger === undefined)
		        return console;
		    if (logger.log && logger.warn && logger.error)
		        return logger;
		    throw new Error("logger must implement log, warn and error methods");
		}
		const KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
		function checkKeyword(keyword, def) {
		    const { RULES } = this;
		    (0, util_1.eachItem)(keyword, (kwd) => {
		        if (RULES.keywords[kwd])
		            throw new Error(`Keyword ${kwd} is already defined`);
		        if (!KEYWORD_NAME.test(kwd))
		            throw new Error(`Keyword ${kwd} has invalid name`);
		    });
		    if (!def)
		        return;
		    if (def.$data && !("code" in def || "validate" in def)) {
		        throw new Error('$data keyword must have "code" or "validate" function');
		    }
		}
		function addRule(keyword, definition, dataType) {
		    var _a;
		    const post = definition === null || definition === void 0 ? void 0 : definition.post;
		    if (dataType && post)
		        throw new Error('keyword with "post" flag cannot have "type"');
		    const { RULES } = this;
		    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t }) => t === dataType);
		    if (!ruleGroup) {
		        ruleGroup = { type: dataType, rules: [] };
		        RULES.rules.push(ruleGroup);
		    }
		    RULES.keywords[keyword] = true;
		    if (!definition)
		        return;
		    const rule = {
		        keyword,
		        definition: {
		            ...definition,
		            type: (0, dataType_1.getJSONTypes)(definition.type),
		            schemaType: (0, dataType_1.getJSONTypes)(definition.schemaType),
		        },
		    };
		    if (definition.before)
		        addBeforeRule.call(this, ruleGroup, rule, definition.before);
		    else
		        ruleGroup.rules.push(rule);
		    RULES.all[keyword] = rule;
		    (_a = definition.implements) === null || _a === void 0 ? void 0 : _a.forEach((kwd) => this.addKeyword(kwd));
		}
		function addBeforeRule(ruleGroup, rule, before) {
		    const i = ruleGroup.rules.findIndex((_rule) => _rule.keyword === before);
		    if (i >= 0) {
		        ruleGroup.rules.splice(i, 0, rule);
		    }
		    else {
		        ruleGroup.rules.push(rule);
		        this.logger.warn(`rule ${before} is not defined`);
		    }
		}
		function keywordMetaschema(def) {
		    let { metaSchema } = def;
		    if (metaSchema === undefined)
		        return;
		    if (def.$data && this.opts.$data)
		        metaSchema = schemaOrData(metaSchema);
		    def.validateSchema = this.compile(metaSchema, true);
		}
		const $dataRef = {
		    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#",
		};
		function schemaOrData(schema) {
		    return { anyOf: [schema, $dataRef] };
		}
		
	} (core$1));
	return core$1;
}

var draft7 = {};

var core = {};

var id = {};

var hasRequiredId;

function requireId () {
	if (hasRequiredId) return id;
	hasRequiredId = 1;
	Object.defineProperty(id, "__esModule", { value: true });
	const def = {
	    keyword: "id",
	    code() {
	        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
	    },
	};
	id.default = def;
	
	return id;
}

var ref = {};

var hasRequiredRef;

function requireRef () {
	if (hasRequiredRef) return ref;
	hasRequiredRef = 1;
	Object.defineProperty(ref, "__esModule", { value: true });
	ref.callRef = ref.getValidate = void 0;
	const ref_error_1 = /*@__PURE__*/ requireRef_error();
	const code_1 = /*@__PURE__*/ requireCode();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const names_1 = /*@__PURE__*/ requireNames();
	const compile_1 = /*@__PURE__*/ requireCompile();
	const util_1 = /*@__PURE__*/ requireUtil();
	const def = {
	    keyword: "$ref",
	    schemaType: "string",
	    code(cxt) {
	        const { gen, schema: $ref, it } = cxt;
	        const { baseId, schemaEnv: env, validateName, opts, self } = it;
	        const { root } = env;
	        if (($ref === "#" || $ref === "#/") && baseId === root.baseId)
	            return callRootRef();
	        const schOrEnv = compile_1.resolveRef.call(self, root, baseId, $ref);
	        if (schOrEnv === undefined)
	            throw new ref_error_1.default(it.opts.uriResolver, baseId, $ref);
	        if (schOrEnv instanceof compile_1.SchemaEnv)
	            return callValidate(schOrEnv);
	        return inlineRefSchema(schOrEnv);
	        function callRootRef() {
	            if (env === root)
	                return callRef(cxt, validateName, env, env.$async);
	            const rootName = gen.scopeValue("root", { ref: root });
	            return callRef(cxt, (0, codegen_1._) `${rootName}.validate`, root, root.$async);
	        }
	        function callValidate(sch) {
	            const v = getValidate(cxt, sch);
	            callRef(cxt, v, sch, sch.$async);
	        }
	        function inlineRefSchema(sch) {
	            const schName = gen.scopeValue("schema", opts.code.source === true ? { ref: sch, code: (0, codegen_1.stringify)(sch) } : { ref: sch });
	            const valid = gen.name("valid");
	            const schCxt = cxt.subschema({
	                schema: sch,
	                dataTypes: [],
	                schemaPath: codegen_1.nil,
	                topSchemaRef: schName,
	                errSchemaPath: $ref,
	            }, valid);
	            cxt.mergeEvaluated(schCxt);
	            cxt.ok(valid);
	        }
	    },
	};
	function getValidate(cxt, sch) {
	    const { gen } = cxt;
	    return sch.validate
	        ? gen.scopeValue("validate", { ref: sch.validate })
	        : (0, codegen_1._) `${gen.scopeValue("wrapper", { ref: sch })}.validate`;
	}
	ref.getValidate = getValidate;
	function callRef(cxt, v, sch, $async) {
	    const { gen, it } = cxt;
	    const { allErrors, schemaEnv: env, opts } = it;
	    const passCxt = opts.passContext ? names_1.default.this : codegen_1.nil;
	    if ($async)
	        callAsyncRef();
	    else
	        callSyncRef();
	    function callAsyncRef() {
	        if (!env.$async)
	            throw new Error("async schema referenced by sync schema");
	        const valid = gen.let("valid");
	        gen.try(() => {
	            gen.code((0, codegen_1._) `await ${(0, code_1.callValidateCode)(cxt, v, passCxt)}`);
	            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
	            if (!allErrors)
	                gen.assign(valid, true);
	        }, (e) => {
	            gen.if((0, codegen_1._) `!(${e} instanceof ${it.ValidationError})`, () => gen.throw(e));
	            addErrorsFrom(e);
	            if (!allErrors)
	                gen.assign(valid, false);
	        });
	        cxt.ok(valid);
	    }
	    function callSyncRef() {
	        cxt.result((0, code_1.callValidateCode)(cxt, v, passCxt), () => addEvaluatedFrom(v), () => addErrorsFrom(v));
	    }
	    function addErrorsFrom(source) {
	        const errs = (0, codegen_1._) `${source}.errors`;
	        gen.assign(names_1.default.vErrors, (0, codegen_1._) `${names_1.default.vErrors} === null ? ${errs} : ${names_1.default.vErrors}.concat(${errs})`); // TODO tagged
	        gen.assign(names_1.default.errors, (0, codegen_1._) `${names_1.default.vErrors}.length`);
	    }
	    function addEvaluatedFrom(source) {
	        var _a;
	        if (!it.opts.unevaluated)
	            return;
	        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
	        // TODO refactor
	        if (it.props !== true) {
	            if (schEvaluated && !schEvaluated.dynamicProps) {
	                if (schEvaluated.props !== undefined) {
	                    it.props = util_1.mergeEvaluated.props(gen, schEvaluated.props, it.props);
	                }
	            }
	            else {
	                const props = gen.var("props", (0, codegen_1._) `${source}.evaluated.props`);
	                it.props = util_1.mergeEvaluated.props(gen, props, it.props, codegen_1.Name);
	            }
	        }
	        if (it.items !== true) {
	            if (schEvaluated && !schEvaluated.dynamicItems) {
	                if (schEvaluated.items !== undefined) {
	                    it.items = util_1.mergeEvaluated.items(gen, schEvaluated.items, it.items);
	                }
	            }
	            else {
	                const items = gen.var("items", (0, codegen_1._) `${source}.evaluated.items`);
	                it.items = util_1.mergeEvaluated.items(gen, items, it.items, codegen_1.Name);
	            }
	        }
	    }
	}
	ref.callRef = callRef;
	ref.default = def;
	
	return ref;
}

var hasRequiredCore;

function requireCore () {
	if (hasRequiredCore) return core;
	hasRequiredCore = 1;
	Object.defineProperty(core, "__esModule", { value: true });
	const id_1 = /*@__PURE__*/ requireId();
	const ref_1 = /*@__PURE__*/ requireRef();
	const core$1 = [
	    "$schema",
	    "$id",
	    "$defs",
	    "$vocabulary",
	    { keyword: "$comment" },
	    "definitions",
	    id_1.default,
	    ref_1.default,
	];
	core.default = core$1;
	
	return core;
}

var validation = {};

var limitNumber = {};

var hasRequiredLimitNumber;

function requireLimitNumber () {
	if (hasRequiredLimitNumber) return limitNumber;
	hasRequiredLimitNumber = 1;
	Object.defineProperty(limitNumber, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const ops = codegen_1.operators;
	const KWDs = {
	    maximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
	    minimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
	    exclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
	    exclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE },
	};
	const error = {
	    message: ({ keyword, schemaCode }) => (0, codegen_1.str) `must be ${KWDs[keyword].okStr} ${schemaCode}`,
	    params: ({ keyword, schemaCode }) => (0, codegen_1._) `{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`,
	};
	const def = {
	    keyword: Object.keys(KWDs),
	    type: "number",
	    schemaType: "number",
	    $data: true,
	    error,
	    code(cxt) {
	        const { keyword, data, schemaCode } = cxt;
	        cxt.fail$data((0, codegen_1._) `${data} ${KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
	    },
	};
	limitNumber.default = def;
	
	return limitNumber;
}

var multipleOf = {};

var hasRequiredMultipleOf;

function requireMultipleOf () {
	if (hasRequiredMultipleOf) return multipleOf;
	hasRequiredMultipleOf = 1;
	Object.defineProperty(multipleOf, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const error = {
	    message: ({ schemaCode }) => (0, codegen_1.str) `must be multiple of ${schemaCode}`,
	    params: ({ schemaCode }) => (0, codegen_1._) `{multipleOf: ${schemaCode}}`,
	};
	const def = {
	    keyword: "multipleOf",
	    type: "number",
	    schemaType: "number",
	    $data: true,
	    error,
	    code(cxt) {
	        const { gen, data, schemaCode, it } = cxt;
	        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
	        const prec = it.opts.multipleOfPrecision;
	        const res = gen.let("res");
	        const invalid = prec
	            ? (0, codegen_1._) `Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}`
	            : (0, codegen_1._) `${res} !== parseInt(${res})`;
	        cxt.fail$data((0, codegen_1._) `(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
	    },
	};
	multipleOf.default = def;
	
	return multipleOf;
}

var limitLength = {};

var ucs2length = {};

var hasRequiredUcs2length;

function requireUcs2length () {
	if (hasRequiredUcs2length) return ucs2length;
	hasRequiredUcs2length = 1;
	Object.defineProperty(ucs2length, "__esModule", { value: true });
	// https://mathiasbynens.be/notes/javascript-encoding
	// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
	function ucs2length$1(str) {
	    const len = str.length;
	    let length = 0;
	    let pos = 0;
	    let value;
	    while (pos < len) {
	        length++;
	        value = str.charCodeAt(pos++);
	        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
	            // high surrogate, and there is a next character
	            value = str.charCodeAt(pos);
	            if ((value & 0xfc00) === 0xdc00)
	                pos++; // low surrogate
	        }
	    }
	    return length;
	}
	ucs2length.default = ucs2length$1;
	ucs2length$1.code = 'require("ajv/dist/runtime/ucs2length").default';
	
	return ucs2length;
}

var hasRequiredLimitLength;

function requireLimitLength () {
	if (hasRequiredLimitLength) return limitLength;
	hasRequiredLimitLength = 1;
	Object.defineProperty(limitLength, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const ucs2length_1 = /*@__PURE__*/ requireUcs2length();
	const error = {
	    message({ keyword, schemaCode }) {
	        const comp = keyword === "maxLength" ? "more" : "fewer";
	        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} characters`;
	    },
	    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
	};
	const def = {
	    keyword: ["maxLength", "minLength"],
	    type: "string",
	    schemaType: "number",
	    $data: true,
	    error,
	    code(cxt) {
	        const { keyword, data, schemaCode, it } = cxt;
	        const op = keyword === "maxLength" ? codegen_1.operators.GT : codegen_1.operators.LT;
	        const len = it.opts.unicode === false ? (0, codegen_1._) `${data}.length` : (0, codegen_1._) `${(0, util_1.useFunc)(cxt.gen, ucs2length_1.default)}(${data})`;
	        cxt.fail$data((0, codegen_1._) `${len} ${op} ${schemaCode}`);
	    },
	};
	limitLength.default = def;
	
	return limitLength;
}

var pattern = {};

var hasRequiredPattern;

function requirePattern () {
	if (hasRequiredPattern) return pattern;
	hasRequiredPattern = 1;
	Object.defineProperty(pattern, "__esModule", { value: true });
	const code_1 = /*@__PURE__*/ requireCode();
	const util_1 = /*@__PURE__*/ requireUtil();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const error = {
	    message: ({ schemaCode }) => (0, codegen_1.str) `must match pattern "${schemaCode}"`,
	    params: ({ schemaCode }) => (0, codegen_1._) `{pattern: ${schemaCode}}`,
	};
	const def = {
	    keyword: "pattern",
	    type: "string",
	    schemaType: "string",
	    $data: true,
	    error,
	    code(cxt) {
	        const { gen, data, $data, schema, schemaCode, it } = cxt;
	        const u = it.opts.unicodeRegExp ? "u" : "";
	        if ($data) {
	            const { regExp } = it.opts.code;
	            const regExpCode = regExp.code === "new RegExp" ? (0, codegen_1._) `new RegExp` : (0, util_1.useFunc)(gen, regExp);
	            const valid = gen.let("valid");
	            gen.try(() => gen.assign(valid, (0, codegen_1._) `${regExpCode}(${schemaCode}, ${u}).test(${data})`), () => gen.assign(valid, false));
	            cxt.fail$data((0, codegen_1._) `!${valid}`);
	        }
	        else {
	            const regExp = (0, code_1.usePattern)(cxt, schema);
	            cxt.fail$data((0, codegen_1._) `!${regExp}.test(${data})`);
	        }
	    },
	};
	pattern.default = def;
	
	return pattern;
}

var limitProperties = {};

var hasRequiredLimitProperties;

function requireLimitProperties () {
	if (hasRequiredLimitProperties) return limitProperties;
	hasRequiredLimitProperties = 1;
	Object.defineProperty(limitProperties, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const error = {
	    message({ keyword, schemaCode }) {
	        const comp = keyword === "maxProperties" ? "more" : "fewer";
	        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} properties`;
	    },
	    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
	};
	const def = {
	    keyword: ["maxProperties", "minProperties"],
	    type: "object",
	    schemaType: "number",
	    $data: true,
	    error,
	    code(cxt) {
	        const { keyword, data, schemaCode } = cxt;
	        const op = keyword === "maxProperties" ? codegen_1.operators.GT : codegen_1.operators.LT;
	        cxt.fail$data((0, codegen_1._) `Object.keys(${data}).length ${op} ${schemaCode}`);
	    },
	};
	limitProperties.default = def;
	
	return limitProperties;
}

var required = {};

var hasRequiredRequired;

function requireRequired () {
	if (hasRequiredRequired) return required;
	hasRequiredRequired = 1;
	Object.defineProperty(required, "__esModule", { value: true });
	const code_1 = /*@__PURE__*/ requireCode();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: ({ params: { missingProperty } }) => (0, codegen_1.str) `must have required property '${missingProperty}'`,
	    params: ({ params: { missingProperty } }) => (0, codegen_1._) `{missingProperty: ${missingProperty}}`,
	};
	const def = {
	    keyword: "required",
	    type: "object",
	    schemaType: "array",
	    $data: true,
	    error,
	    code(cxt) {
	        const { gen, schema, schemaCode, data, $data, it } = cxt;
	        const { opts } = it;
	        if (!$data && schema.length === 0)
	            return;
	        const useLoop = schema.length >= opts.loopRequired;
	        if (it.allErrors)
	            allErrorsMode();
	        else
	            exitOnErrorMode();
	        if (opts.strictRequired) {
	            const props = cxt.parentSchema.properties;
	            const { definedProperties } = cxt.it;
	            for (const requiredKey of schema) {
	                if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
	                    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
	                    const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
	                    (0, util_1.checkStrictMode)(it, msg, it.opts.strictRequired);
	                }
	            }
	        }
	        function allErrorsMode() {
	            if (useLoop || $data) {
	                cxt.block$data(codegen_1.nil, loopAllRequired);
	            }
	            else {
	                for (const prop of schema) {
	                    (0, code_1.checkReportMissingProp)(cxt, prop);
	                }
	            }
	        }
	        function exitOnErrorMode() {
	            const missing = gen.let("missing");
	            if (useLoop || $data) {
	                const valid = gen.let("valid", true);
	                cxt.block$data(valid, () => loopUntilMissing(missing, valid));
	                cxt.ok(valid);
	            }
	            else {
	                gen.if((0, code_1.checkMissingProp)(cxt, schema, missing));
	                (0, code_1.reportMissingProp)(cxt, missing);
	                gen.else();
	            }
	        }
	        function loopAllRequired() {
	            gen.forOf("prop", schemaCode, (prop) => {
	                cxt.setParams({ missingProperty: prop });
	                gen.if((0, code_1.noPropertyInData)(gen, data, prop, opts.ownProperties), () => cxt.error());
	            });
	        }
	        function loopUntilMissing(missing, valid) {
	            cxt.setParams({ missingProperty: missing });
	            gen.forOf(missing, schemaCode, () => {
	                gen.assign(valid, (0, code_1.propertyInData)(gen, data, missing, opts.ownProperties));
	                gen.if((0, codegen_1.not)(valid), () => {
	                    cxt.error();
	                    gen.break();
	                });
	            }, codegen_1.nil);
	        }
	    },
	};
	required.default = def;
	
	return required;
}

var limitItems = {};

var hasRequiredLimitItems;

function requireLimitItems () {
	if (hasRequiredLimitItems) return limitItems;
	hasRequiredLimitItems = 1;
	Object.defineProperty(limitItems, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const error = {
	    message({ keyword, schemaCode }) {
	        const comp = keyword === "maxItems" ? "more" : "fewer";
	        return (0, codegen_1.str) `must NOT have ${comp} than ${schemaCode} items`;
	    },
	    params: ({ schemaCode }) => (0, codegen_1._) `{limit: ${schemaCode}}`,
	};
	const def = {
	    keyword: ["maxItems", "minItems"],
	    type: "array",
	    schemaType: "number",
	    $data: true,
	    error,
	    code(cxt) {
	        const { keyword, data, schemaCode } = cxt;
	        const op = keyword === "maxItems" ? codegen_1.operators.GT : codegen_1.operators.LT;
	        cxt.fail$data((0, codegen_1._) `${data}.length ${op} ${schemaCode}`);
	    },
	};
	limitItems.default = def;
	
	return limitItems;
}

var uniqueItems = {};

var equal = {};

var hasRequiredEqual;

function requireEqual () {
	if (hasRequiredEqual) return equal;
	hasRequiredEqual = 1;
	Object.defineProperty(equal, "__esModule", { value: true });
	// https://github.com/ajv-validator/ajv/issues/889
	const equal$1 = requireFastDeepEqual();
	equal$1.code = 'require("ajv/dist/runtime/equal").default';
	equal.default = equal$1;
	
	return equal;
}

var hasRequiredUniqueItems;

function requireUniqueItems () {
	if (hasRequiredUniqueItems) return uniqueItems;
	hasRequiredUniqueItems = 1;
	Object.defineProperty(uniqueItems, "__esModule", { value: true });
	const dataType_1 = /*@__PURE__*/ requireDataType();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const equal_1 = /*@__PURE__*/ requireEqual();
	const error = {
	    message: ({ params: { i, j } }) => (0, codegen_1.str) `must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
	    params: ({ params: { i, j } }) => (0, codegen_1._) `{i: ${i}, j: ${j}}`,
	};
	const def = {
	    keyword: "uniqueItems",
	    type: "array",
	    schemaType: "boolean",
	    $data: true,
	    error,
	    code(cxt) {
	        const { gen, data, $data, schema, parentSchema, schemaCode, it } = cxt;
	        if (!$data && !schema)
	            return;
	        const valid = gen.let("valid");
	        const itemTypes = parentSchema.items ? (0, dataType_1.getSchemaTypes)(parentSchema.items) : [];
	        cxt.block$data(valid, validateUniqueItems, (0, codegen_1._) `${schemaCode} === false`);
	        cxt.ok(valid);
	        function validateUniqueItems() {
	            const i = gen.let("i", (0, codegen_1._) `${data}.length`);
	            const j = gen.let("j");
	            cxt.setParams({ i, j });
	            gen.assign(valid, true);
	            gen.if((0, codegen_1._) `${i} > 1`, () => (canOptimize() ? loopN : loopN2)(i, j));
	        }
	        function canOptimize() {
	            return itemTypes.length > 0 && !itemTypes.some((t) => t === "object" || t === "array");
	        }
	        function loopN(i, j) {
	            const item = gen.name("item");
	            const wrongType = (0, dataType_1.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, dataType_1.DataType.Wrong);
	            const indices = gen.const("indices", (0, codegen_1._) `{}`);
	            gen.for((0, codegen_1._) `;${i}--;`, () => {
	                gen.let(item, (0, codegen_1._) `${data}[${i}]`);
	                gen.if(wrongType, (0, codegen_1._) `continue`);
	                if (itemTypes.length > 1)
	                    gen.if((0, codegen_1._) `typeof ${item} == "string"`, (0, codegen_1._) `${item} += "_"`);
	                gen
	                    .if((0, codegen_1._) `typeof ${indices}[${item}] == "number"`, () => {
	                    gen.assign(j, (0, codegen_1._) `${indices}[${item}]`);
	                    cxt.error();
	                    gen.assign(valid, false).break();
	                })
	                    .code((0, codegen_1._) `${indices}[${item}] = ${i}`);
	            });
	        }
	        function loopN2(i, j) {
	            const eql = (0, util_1.useFunc)(gen, equal_1.default);
	            const outer = gen.name("outer");
	            gen.label(outer).for((0, codegen_1._) `;${i}--;`, () => gen.for((0, codegen_1._) `${j} = ${i}; ${j}--;`, () => gen.if((0, codegen_1._) `${eql}(${data}[${i}], ${data}[${j}])`, () => {
	                cxt.error();
	                gen.assign(valid, false).break(outer);
	            })));
	        }
	    },
	};
	uniqueItems.default = def;
	
	return uniqueItems;
}

var _const = {};

var hasRequired_const;

function require_const () {
	if (hasRequired_const) return _const;
	hasRequired_const = 1;
	Object.defineProperty(_const, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const equal_1 = /*@__PURE__*/ requireEqual();
	const error = {
	    message: "must be equal to constant",
	    params: ({ schemaCode }) => (0, codegen_1._) `{allowedValue: ${schemaCode}}`,
	};
	const def = {
	    keyword: "const",
	    $data: true,
	    error,
	    code(cxt) {
	        const { gen, data, $data, schemaCode, schema } = cxt;
	        if ($data || (schema && typeof schema == "object")) {
	            cxt.fail$data((0, codegen_1._) `!${(0, util_1.useFunc)(gen, equal_1.default)}(${data}, ${schemaCode})`);
	        }
	        else {
	            cxt.fail((0, codegen_1._) `${schema} !== ${data}`);
	        }
	    },
	};
	_const.default = def;
	
	return _const;
}

var _enum = {};

var hasRequired_enum;

function require_enum () {
	if (hasRequired_enum) return _enum;
	hasRequired_enum = 1;
	Object.defineProperty(_enum, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const equal_1 = /*@__PURE__*/ requireEqual();
	const error = {
	    message: "must be equal to one of the allowed values",
	    params: ({ schemaCode }) => (0, codegen_1._) `{allowedValues: ${schemaCode}}`,
	};
	const def = {
	    keyword: "enum",
	    schemaType: "array",
	    $data: true,
	    error,
	    code(cxt) {
	        const { gen, data, $data, schema, schemaCode, it } = cxt;
	        if (!$data && schema.length === 0)
	            throw new Error("enum must have non-empty array");
	        const useLoop = schema.length >= it.opts.loopEnum;
	        let eql;
	        const getEql = () => (eql !== null && eql !== void 0 ? eql : (eql = (0, util_1.useFunc)(gen, equal_1.default)));
	        let valid;
	        if (useLoop || $data) {
	            valid = gen.let("valid");
	            cxt.block$data(valid, loopEnum);
	        }
	        else {
	            /* istanbul ignore if */
	            if (!Array.isArray(schema))
	                throw new Error("ajv implementation error");
	            const vSchema = gen.const("vSchema", schemaCode);
	            valid = (0, codegen_1.or)(...schema.map((_x, i) => equalCode(vSchema, i)));
	        }
	        cxt.pass(valid);
	        function loopEnum() {
	            gen.assign(valid, false);
	            gen.forOf("v", schemaCode, (v) => gen.if((0, codegen_1._) `${getEql()}(${data}, ${v})`, () => gen.assign(valid, true).break()));
	        }
	        function equalCode(vSchema, i) {
	            const sch = schema[i];
	            return typeof sch === "object" && sch !== null
	                ? (0, codegen_1._) `${getEql()}(${data}, ${vSchema}[${i}])`
	                : (0, codegen_1._) `${data} === ${sch}`;
	        }
	    },
	};
	_enum.default = def;
	
	return _enum;
}

var hasRequiredValidation;

function requireValidation () {
	if (hasRequiredValidation) return validation;
	hasRequiredValidation = 1;
	Object.defineProperty(validation, "__esModule", { value: true });
	const limitNumber_1 = /*@__PURE__*/ requireLimitNumber();
	const multipleOf_1 = /*@__PURE__*/ requireMultipleOf();
	const limitLength_1 = /*@__PURE__*/ requireLimitLength();
	const pattern_1 = /*@__PURE__*/ requirePattern();
	const limitProperties_1 = /*@__PURE__*/ requireLimitProperties();
	const required_1 = /*@__PURE__*/ requireRequired();
	const limitItems_1 = /*@__PURE__*/ requireLimitItems();
	const uniqueItems_1 = /*@__PURE__*/ requireUniqueItems();
	const const_1 = /*@__PURE__*/ require_const();
	const enum_1 = /*@__PURE__*/ require_enum();
	const validation$1 = [
	    // number
	    limitNumber_1.default,
	    multipleOf_1.default,
	    // string
	    limitLength_1.default,
	    pattern_1.default,
	    // object
	    limitProperties_1.default,
	    required_1.default,
	    // array
	    limitItems_1.default,
	    uniqueItems_1.default,
	    // any
	    { keyword: "type", schemaType: ["string", "array"] },
	    { keyword: "nullable", schemaType: "boolean" },
	    const_1.default,
	    enum_1.default,
	];
	validation.default = validation$1;
	
	return validation;
}

var applicator = {};

var additionalItems = {};

var hasRequiredAdditionalItems;

function requireAdditionalItems () {
	if (hasRequiredAdditionalItems) return additionalItems;
	hasRequiredAdditionalItems = 1;
	Object.defineProperty(additionalItems, "__esModule", { value: true });
	additionalItems.validateAdditionalItems = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: ({ params: { len } }) => (0, codegen_1.str) `must NOT have more than ${len} items`,
	    params: ({ params: { len } }) => (0, codegen_1._) `{limit: ${len}}`,
	};
	const def = {
	    keyword: "additionalItems",
	    type: "array",
	    schemaType: ["boolean", "object"],
	    before: "uniqueItems",
	    error,
	    code(cxt) {
	        const { parentSchema, it } = cxt;
	        const { items } = parentSchema;
	        if (!Array.isArray(items)) {
	            (0, util_1.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
	            return;
	        }
	        validateAdditionalItems(cxt, items);
	    },
	};
	function validateAdditionalItems(cxt, items) {
	    const { gen, schema, data, keyword, it } = cxt;
	    it.items = true;
	    const len = gen.const("len", (0, codegen_1._) `${data}.length`);
	    if (schema === false) {
	        cxt.setParams({ len: items.length });
	        cxt.pass((0, codegen_1._) `${len} <= ${items.length}`);
	    }
	    else if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
	        const valid = gen.var("valid", (0, codegen_1._) `${len} <= ${items.length}`); // TODO var
	        gen.if((0, codegen_1.not)(valid), () => validateItems(valid));
	        cxt.ok(valid);
	    }
	    function validateItems(valid) {
	        gen.forRange("i", items.length, len, (i) => {
	            cxt.subschema({ keyword, dataProp: i, dataPropType: util_1.Type.Num }, valid);
	            if (!it.allErrors)
	                gen.if((0, codegen_1.not)(valid), () => gen.break());
	        });
	    }
	}
	additionalItems.validateAdditionalItems = validateAdditionalItems;
	additionalItems.default = def;
	
	return additionalItems;
}

var prefixItems = {};

var items = {};

var hasRequiredItems;

function requireItems () {
	if (hasRequiredItems) return items;
	hasRequiredItems = 1;
	Object.defineProperty(items, "__esModule", { value: true });
	items.validateTuple = void 0;
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const code_1 = /*@__PURE__*/ requireCode();
	const def = {
	    keyword: "items",
	    type: "array",
	    schemaType: ["object", "array", "boolean"],
	    before: "uniqueItems",
	    code(cxt) {
	        const { schema, it } = cxt;
	        if (Array.isArray(schema))
	            return validateTuple(cxt, "additionalItems", schema);
	        it.items = true;
	        if ((0, util_1.alwaysValidSchema)(it, schema))
	            return;
	        cxt.ok((0, code_1.validateArray)(cxt));
	    },
	};
	function validateTuple(cxt, extraItems, schArr = cxt.schema) {
	    const { gen, parentSchema, data, keyword, it } = cxt;
	    checkStrictTuple(parentSchema);
	    if (it.opts.unevaluated && schArr.length && it.items !== true) {
	        it.items = util_1.mergeEvaluated.items(gen, schArr.length, it.items);
	    }
	    const valid = gen.name("valid");
	    const len = gen.const("len", (0, codegen_1._) `${data}.length`);
	    schArr.forEach((sch, i) => {
	        if ((0, util_1.alwaysValidSchema)(it, sch))
	            return;
	        gen.if((0, codegen_1._) `${len} > ${i}`, () => cxt.subschema({
	            keyword,
	            schemaProp: i,
	            dataProp: i,
	        }, valid));
	        cxt.ok(valid);
	    });
	    function checkStrictTuple(sch) {
	        const { opts, errSchemaPath } = it;
	        const l = schArr.length;
	        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
	        if (opts.strictTuples && !fullTuple) {
	            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
	            (0, util_1.checkStrictMode)(it, msg, opts.strictTuples);
	        }
	    }
	}
	items.validateTuple = validateTuple;
	items.default = def;
	
	return items;
}

var hasRequiredPrefixItems;

function requirePrefixItems () {
	if (hasRequiredPrefixItems) return prefixItems;
	hasRequiredPrefixItems = 1;
	Object.defineProperty(prefixItems, "__esModule", { value: true });
	const items_1 = /*@__PURE__*/ requireItems();
	const def = {
	    keyword: "prefixItems",
	    type: "array",
	    schemaType: ["array"],
	    before: "uniqueItems",
	    code: (cxt) => (0, items_1.validateTuple)(cxt, "items"),
	};
	prefixItems.default = def;
	
	return prefixItems;
}

var items2020 = {};

var hasRequiredItems2020;

function requireItems2020 () {
	if (hasRequiredItems2020) return items2020;
	hasRequiredItems2020 = 1;
	Object.defineProperty(items2020, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const code_1 = /*@__PURE__*/ requireCode();
	const additionalItems_1 = /*@__PURE__*/ requireAdditionalItems();
	const error = {
	    message: ({ params: { len } }) => (0, codegen_1.str) `must NOT have more than ${len} items`,
	    params: ({ params: { len } }) => (0, codegen_1._) `{limit: ${len}}`,
	};
	const def = {
	    keyword: "items",
	    type: "array",
	    schemaType: ["object", "boolean"],
	    before: "uniqueItems",
	    error,
	    code(cxt) {
	        const { schema, parentSchema, it } = cxt;
	        const { prefixItems } = parentSchema;
	        it.items = true;
	        if ((0, util_1.alwaysValidSchema)(it, schema))
	            return;
	        if (prefixItems)
	            (0, additionalItems_1.validateAdditionalItems)(cxt, prefixItems);
	        else
	            cxt.ok((0, code_1.validateArray)(cxt));
	    },
	};
	items2020.default = def;
	
	return items2020;
}

var contains = {};

var hasRequiredContains;

function requireContains () {
	if (hasRequiredContains) return contains;
	hasRequiredContains = 1;
	Object.defineProperty(contains, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: ({ params: { min, max } }) => max === undefined
	        ? (0, codegen_1.str) `must contain at least ${min} valid item(s)`
	        : (0, codegen_1.str) `must contain at least ${min} and no more than ${max} valid item(s)`,
	    params: ({ params: { min, max } }) => max === undefined ? (0, codegen_1._) `{minContains: ${min}}` : (0, codegen_1._) `{minContains: ${min}, maxContains: ${max}}`,
	};
	const def = {
	    keyword: "contains",
	    type: "array",
	    schemaType: ["object", "boolean"],
	    before: "uniqueItems",
	    trackErrors: true,
	    error,
	    code(cxt) {
	        const { gen, schema, parentSchema, data, it } = cxt;
	        let min;
	        let max;
	        const { minContains, maxContains } = parentSchema;
	        if (it.opts.next) {
	            min = minContains === undefined ? 1 : minContains;
	            max = maxContains;
	        }
	        else {
	            min = 1;
	        }
	        const len = gen.const("len", (0, codegen_1._) `${data}.length`);
	        cxt.setParams({ min, max });
	        if (max === undefined && min === 0) {
	            (0, util_1.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
	            return;
	        }
	        if (max !== undefined && min > max) {
	            (0, util_1.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
	            cxt.fail();
	            return;
	        }
	        if ((0, util_1.alwaysValidSchema)(it, schema)) {
	            let cond = (0, codegen_1._) `${len} >= ${min}`;
	            if (max !== undefined)
	                cond = (0, codegen_1._) `${cond} && ${len} <= ${max}`;
	            cxt.pass(cond);
	            return;
	        }
	        it.items = true;
	        const valid = gen.name("valid");
	        if (max === undefined && min === 1) {
	            validateItems(valid, () => gen.if(valid, () => gen.break()));
	        }
	        else if (min === 0) {
	            gen.let(valid, true);
	            if (max !== undefined)
	                gen.if((0, codegen_1._) `${data}.length > 0`, validateItemsWithCount);
	        }
	        else {
	            gen.let(valid, false);
	            validateItemsWithCount();
	        }
	        cxt.result(valid, () => cxt.reset());
	        function validateItemsWithCount() {
	            const schValid = gen.name("_valid");
	            const count = gen.let("count", 0);
	            validateItems(schValid, () => gen.if(schValid, () => checkLimits(count)));
	        }
	        function validateItems(_valid, block) {
	            gen.forRange("i", 0, len, (i) => {
	                cxt.subschema({
	                    keyword: "contains",
	                    dataProp: i,
	                    dataPropType: util_1.Type.Num,
	                    compositeRule: true,
	                }, _valid);
	                block();
	            });
	        }
	        function checkLimits(count) {
	            gen.code((0, codegen_1._) `${count}++`);
	            if (max === undefined) {
	                gen.if((0, codegen_1._) `${count} >= ${min}`, () => gen.assign(valid, true).break());
	            }
	            else {
	                gen.if((0, codegen_1._) `${count} > ${max}`, () => gen.assign(valid, false).break());
	                if (min === 1)
	                    gen.assign(valid, true);
	                else
	                    gen.if((0, codegen_1._) `${count} >= ${min}`, () => gen.assign(valid, true));
	            }
	        }
	    },
	};
	contains.default = def;
	
	return contains;
}

var dependencies = {};

var hasRequiredDependencies;

function requireDependencies () {
	if (hasRequiredDependencies) return dependencies;
	hasRequiredDependencies = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.validateSchemaDeps = exports.validatePropertyDeps = exports.error = void 0;
		const codegen_1 = /*@__PURE__*/ requireCodegen();
		const util_1 = /*@__PURE__*/ requireUtil();
		const code_1 = /*@__PURE__*/ requireCode();
		exports.error = {
		    message: ({ params: { property, depsCount, deps } }) => {
		        const property_ies = depsCount === 1 ? "property" : "properties";
		        return (0, codegen_1.str) `must have ${property_ies} ${deps} when property ${property} is present`;
		    },
		    params: ({ params: { property, depsCount, deps, missingProperty } }) => (0, codegen_1._) `{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`, // TODO change to reference
		};
		const def = {
		    keyword: "dependencies",
		    type: "object",
		    schemaType: "object",
		    error: exports.error,
		    code(cxt) {
		        const [propDeps, schDeps] = splitDependencies(cxt);
		        validatePropertyDeps(cxt, propDeps);
		        validateSchemaDeps(cxt, schDeps);
		    },
		};
		function splitDependencies({ schema }) {
		    const propertyDeps = {};
		    const schemaDeps = {};
		    for (const key in schema) {
		        if (key === "__proto__")
		            continue;
		        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
		        deps[key] = schema[key];
		    }
		    return [propertyDeps, schemaDeps];
		}
		function validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
		    const { gen, data, it } = cxt;
		    if (Object.keys(propertyDeps).length === 0)
		        return;
		    const missing = gen.let("missing");
		    for (const prop in propertyDeps) {
		        const deps = propertyDeps[prop];
		        if (deps.length === 0)
		            continue;
		        const hasProperty = (0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties);
		        cxt.setParams({
		            property: prop,
		            depsCount: deps.length,
		            deps: deps.join(", "),
		        });
		        if (it.allErrors) {
		            gen.if(hasProperty, () => {
		                for (const depProp of deps) {
		                    (0, code_1.checkReportMissingProp)(cxt, depProp);
		                }
		            });
		        }
		        else {
		            gen.if((0, codegen_1._) `${hasProperty} && (${(0, code_1.checkMissingProp)(cxt, deps, missing)})`);
		            (0, code_1.reportMissingProp)(cxt, missing);
		            gen.else();
		        }
		    }
		}
		exports.validatePropertyDeps = validatePropertyDeps;
		function validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
		    const { gen, data, keyword, it } = cxt;
		    const valid = gen.name("valid");
		    for (const prop in schemaDeps) {
		        if ((0, util_1.alwaysValidSchema)(it, schemaDeps[prop]))
		            continue;
		        gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties), () => {
		            const schCxt = cxt.subschema({ keyword, schemaProp: prop }, valid);
		            cxt.mergeValidEvaluated(schCxt, valid);
		        }, () => gen.var(valid, true) // TODO var
		        );
		        cxt.ok(valid);
		    }
		}
		exports.validateSchemaDeps = validateSchemaDeps;
		exports.default = def;
		
	} (dependencies));
	return dependencies;
}

var propertyNames = {};

var hasRequiredPropertyNames;

function requirePropertyNames () {
	if (hasRequiredPropertyNames) return propertyNames;
	hasRequiredPropertyNames = 1;
	Object.defineProperty(propertyNames, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: "property name must be valid",
	    params: ({ params }) => (0, codegen_1._) `{propertyName: ${params.propertyName}}`,
	};
	const def = {
	    keyword: "propertyNames",
	    type: "object",
	    schemaType: ["object", "boolean"],
	    error,
	    code(cxt) {
	        const { gen, schema, data, it } = cxt;
	        if ((0, util_1.alwaysValidSchema)(it, schema))
	            return;
	        const valid = gen.name("valid");
	        gen.forIn("key", data, (key) => {
	            cxt.setParams({ propertyName: key });
	            cxt.subschema({
	                keyword: "propertyNames",
	                data: key,
	                dataTypes: ["string"],
	                propertyName: key,
	                compositeRule: true,
	            }, valid);
	            gen.if((0, codegen_1.not)(valid), () => {
	                cxt.error(true);
	                if (!it.allErrors)
	                    gen.break();
	            });
	        });
	        cxt.ok(valid);
	    },
	};
	propertyNames.default = def;
	
	return propertyNames;
}

var additionalProperties = {};

var hasRequiredAdditionalProperties;

function requireAdditionalProperties () {
	if (hasRequiredAdditionalProperties) return additionalProperties;
	hasRequiredAdditionalProperties = 1;
	Object.defineProperty(additionalProperties, "__esModule", { value: true });
	const code_1 = /*@__PURE__*/ requireCode();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const names_1 = /*@__PURE__*/ requireNames();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: "must NOT have additional properties",
	    params: ({ params }) => (0, codegen_1._) `{additionalProperty: ${params.additionalProperty}}`,
	};
	const def = {
	    keyword: "additionalProperties",
	    type: ["object"],
	    schemaType: ["boolean", "object"],
	    allowUndefined: true,
	    trackErrors: true,
	    error,
	    code(cxt) {
	        const { gen, schema, parentSchema, data, errsCount, it } = cxt;
	        /* istanbul ignore if */
	        if (!errsCount)
	            throw new Error("ajv implementation error");
	        const { allErrors, opts } = it;
	        it.props = true;
	        if (opts.removeAdditional !== "all" && (0, util_1.alwaysValidSchema)(it, schema))
	            return;
	        const props = (0, code_1.allSchemaProperties)(parentSchema.properties);
	        const patProps = (0, code_1.allSchemaProperties)(parentSchema.patternProperties);
	        checkAdditionalProperties();
	        cxt.ok((0, codegen_1._) `${errsCount} === ${names_1.default.errors}`);
	        function checkAdditionalProperties() {
	            gen.forIn("key", data, (key) => {
	                if (!props.length && !patProps.length)
	                    additionalPropertyCode(key);
	                else
	                    gen.if(isAdditional(key), () => additionalPropertyCode(key));
	            });
	        }
	        function isAdditional(key) {
	            let definedProp;
	            if (props.length > 8) {
	                // TODO maybe an option instead of hard-coded 8?
	                const propsSchema = (0, util_1.schemaRefOrVal)(it, parentSchema.properties, "properties");
	                definedProp = (0, code_1.isOwnProperty)(gen, propsSchema, key);
	            }
	            else if (props.length) {
	                definedProp = (0, codegen_1.or)(...props.map((p) => (0, codegen_1._) `${key} === ${p}`));
	            }
	            else {
	                definedProp = codegen_1.nil;
	            }
	            if (patProps.length) {
	                definedProp = (0, codegen_1.or)(definedProp, ...patProps.map((p) => (0, codegen_1._) `${(0, code_1.usePattern)(cxt, p)}.test(${key})`));
	            }
	            return (0, codegen_1.not)(definedProp);
	        }
	        function deleteAdditional(key) {
	            gen.code((0, codegen_1._) `delete ${data}[${key}]`);
	        }
	        function additionalPropertyCode(key) {
	            if (opts.removeAdditional === "all" || (opts.removeAdditional && schema === false)) {
	                deleteAdditional(key);
	                return;
	            }
	            if (schema === false) {
	                cxt.setParams({ additionalProperty: key });
	                cxt.error();
	                if (!allErrors)
	                    gen.break();
	                return;
	            }
	            if (typeof schema == "object" && !(0, util_1.alwaysValidSchema)(it, schema)) {
	                const valid = gen.name("valid");
	                if (opts.removeAdditional === "failing") {
	                    applyAdditionalSchema(key, valid, false);
	                    gen.if((0, codegen_1.not)(valid), () => {
	                        cxt.reset();
	                        deleteAdditional(key);
	                    });
	                }
	                else {
	                    applyAdditionalSchema(key, valid);
	                    if (!allErrors)
	                        gen.if((0, codegen_1.not)(valid), () => gen.break());
	                }
	            }
	        }
	        function applyAdditionalSchema(key, valid, errors) {
	            const subschema = {
	                keyword: "additionalProperties",
	                dataProp: key,
	                dataPropType: util_1.Type.Str,
	            };
	            if (errors === false) {
	                Object.assign(subschema, {
	                    compositeRule: true,
	                    createErrors: false,
	                    allErrors: false,
	                });
	            }
	            cxt.subschema(subschema, valid);
	        }
	    },
	};
	additionalProperties.default = def;
	
	return additionalProperties;
}

var properties$1 = {};

var hasRequiredProperties;

function requireProperties () {
	if (hasRequiredProperties) return properties$1;
	hasRequiredProperties = 1;
	Object.defineProperty(properties$1, "__esModule", { value: true });
	const validate_1 = /*@__PURE__*/ requireValidate();
	const code_1 = /*@__PURE__*/ requireCode();
	const util_1 = /*@__PURE__*/ requireUtil();
	const additionalProperties_1 = /*@__PURE__*/ requireAdditionalProperties();
	const def = {
	    keyword: "properties",
	    type: "object",
	    schemaType: "object",
	    code(cxt) {
	        const { gen, schema, parentSchema, data, it } = cxt;
	        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) {
	            additionalProperties_1.default.code(new validate_1.KeywordCxt(it, additionalProperties_1.default, "additionalProperties"));
	        }
	        const allProps = (0, code_1.allSchemaProperties)(schema);
	        for (const prop of allProps) {
	            it.definedProperties.add(prop);
	        }
	        if (it.opts.unevaluated && allProps.length && it.props !== true) {
	            it.props = util_1.mergeEvaluated.props(gen, (0, util_1.toHash)(allProps), it.props);
	        }
	        const properties = allProps.filter((p) => !(0, util_1.alwaysValidSchema)(it, schema[p]));
	        if (properties.length === 0)
	            return;
	        const valid = gen.name("valid");
	        for (const prop of properties) {
	            if (hasDefault(prop)) {
	                applyPropertySchema(prop);
	            }
	            else {
	                gen.if((0, code_1.propertyInData)(gen, data, prop, it.opts.ownProperties));
	                applyPropertySchema(prop);
	                if (!it.allErrors)
	                    gen.else().var(valid, true);
	                gen.endIf();
	            }
	            cxt.it.definedProperties.add(prop);
	            cxt.ok(valid);
	        }
	        function hasDefault(prop) {
	            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
	        }
	        function applyPropertySchema(prop) {
	            cxt.subschema({
	                keyword: "properties",
	                schemaProp: prop,
	                dataProp: prop,
	            }, valid);
	        }
	    },
	};
	properties$1.default = def;
	
	return properties$1;
}

var patternProperties = {};

var hasRequiredPatternProperties;

function requirePatternProperties () {
	if (hasRequiredPatternProperties) return patternProperties;
	hasRequiredPatternProperties = 1;
	Object.defineProperty(patternProperties, "__esModule", { value: true });
	const code_1 = /*@__PURE__*/ requireCode();
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const util_2 = /*@__PURE__*/ requireUtil();
	const def = {
	    keyword: "patternProperties",
	    type: "object",
	    schemaType: "object",
	    code(cxt) {
	        const { gen, schema, data, parentSchema, it } = cxt;
	        const { opts } = it;
	        const patterns = (0, code_1.allSchemaProperties)(schema);
	        const alwaysValidPatterns = patterns.filter((p) => (0, util_1.alwaysValidSchema)(it, schema[p]));
	        if (patterns.length === 0 ||
	            (alwaysValidPatterns.length === patterns.length &&
	                (!it.opts.unevaluated || it.props === true))) {
	            return;
	        }
	        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
	        const valid = gen.name("valid");
	        if (it.props !== true && !(it.props instanceof codegen_1.Name)) {
	            it.props = (0, util_2.evaluatedPropsToName)(gen, it.props);
	        }
	        const { props } = it;
	        validatePatternProperties();
	        function validatePatternProperties() {
	            for (const pat of patterns) {
	                if (checkProperties)
	                    checkMatchingProperties(pat);
	                if (it.allErrors) {
	                    validateProperties(pat);
	                }
	                else {
	                    gen.var(valid, true); // TODO var
	                    validateProperties(pat);
	                    gen.if(valid);
	                }
	            }
	        }
	        function checkMatchingProperties(pat) {
	            for (const prop in checkProperties) {
	                if (new RegExp(pat).test(prop)) {
	                    (0, util_1.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
	                }
	            }
	        }
	        function validateProperties(pat) {
	            gen.forIn("key", data, (key) => {
	                gen.if((0, codegen_1._) `${(0, code_1.usePattern)(cxt, pat)}.test(${key})`, () => {
	                    const alwaysValid = alwaysValidPatterns.includes(pat);
	                    if (!alwaysValid) {
	                        cxt.subschema({
	                            keyword: "patternProperties",
	                            schemaProp: pat,
	                            dataProp: key,
	                            dataPropType: util_2.Type.Str,
	                        }, valid);
	                    }
	                    if (it.opts.unevaluated && props !== true) {
	                        gen.assign((0, codegen_1._) `${props}[${key}]`, true);
	                    }
	                    else if (!alwaysValid && !it.allErrors) {
	                        // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
	                        // or if all properties were evaluated (props === true)
	                        gen.if((0, codegen_1.not)(valid), () => gen.break());
	                    }
	                });
	            });
	        }
	    },
	};
	patternProperties.default = def;
	
	return patternProperties;
}

var not = {};

var hasRequiredNot;

function requireNot () {
	if (hasRequiredNot) return not;
	hasRequiredNot = 1;
	Object.defineProperty(not, "__esModule", { value: true });
	const util_1 = /*@__PURE__*/ requireUtil();
	const def = {
	    keyword: "not",
	    schemaType: ["object", "boolean"],
	    trackErrors: true,
	    code(cxt) {
	        const { gen, schema, it } = cxt;
	        if ((0, util_1.alwaysValidSchema)(it, schema)) {
	            cxt.fail();
	            return;
	        }
	        const valid = gen.name("valid");
	        cxt.subschema({
	            keyword: "not",
	            compositeRule: true,
	            createErrors: false,
	            allErrors: false,
	        }, valid);
	        cxt.failResult(valid, () => cxt.reset(), () => cxt.error());
	    },
	    error: { message: "must NOT be valid" },
	};
	not.default = def;
	
	return not;
}

var anyOf = {};

var hasRequiredAnyOf;

function requireAnyOf () {
	if (hasRequiredAnyOf) return anyOf;
	hasRequiredAnyOf = 1;
	Object.defineProperty(anyOf, "__esModule", { value: true });
	const code_1 = /*@__PURE__*/ requireCode();
	const def = {
	    keyword: "anyOf",
	    schemaType: "array",
	    trackErrors: true,
	    code: code_1.validateUnion,
	    error: { message: "must match a schema in anyOf" },
	};
	anyOf.default = def;
	
	return anyOf;
}

var oneOf = {};

var hasRequiredOneOf;

function requireOneOf () {
	if (hasRequiredOneOf) return oneOf;
	hasRequiredOneOf = 1;
	Object.defineProperty(oneOf, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: "must match exactly one schema in oneOf",
	    params: ({ params }) => (0, codegen_1._) `{passingSchemas: ${params.passing}}`,
	};
	const def = {
	    keyword: "oneOf",
	    schemaType: "array",
	    trackErrors: true,
	    error,
	    code(cxt) {
	        const { gen, schema, parentSchema, it } = cxt;
	        /* istanbul ignore if */
	        if (!Array.isArray(schema))
	            throw new Error("ajv implementation error");
	        if (it.opts.discriminator && parentSchema.discriminator)
	            return;
	        const schArr = schema;
	        const valid = gen.let("valid", false);
	        const passing = gen.let("passing", null);
	        const schValid = gen.name("_valid");
	        cxt.setParams({ passing });
	        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
	        gen.block(validateOneOf);
	        cxt.result(valid, () => cxt.reset(), () => cxt.error(true));
	        function validateOneOf() {
	            schArr.forEach((sch, i) => {
	                let schCxt;
	                if ((0, util_1.alwaysValidSchema)(it, sch)) {
	                    gen.var(schValid, true);
	                }
	                else {
	                    schCxt = cxt.subschema({
	                        keyword: "oneOf",
	                        schemaProp: i,
	                        compositeRule: true,
	                    }, schValid);
	                }
	                if (i > 0) {
	                    gen
	                        .if((0, codegen_1._) `${schValid} && ${valid}`)
	                        .assign(valid, false)
	                        .assign(passing, (0, codegen_1._) `[${passing}, ${i}]`)
	                        .else();
	                }
	                gen.if(schValid, () => {
	                    gen.assign(valid, true);
	                    gen.assign(passing, i);
	                    if (schCxt)
	                        cxt.mergeEvaluated(schCxt, codegen_1.Name);
	                });
	            });
	        }
	    },
	};
	oneOf.default = def;
	
	return oneOf;
}

var allOf = {};

var hasRequiredAllOf;

function requireAllOf () {
	if (hasRequiredAllOf) return allOf;
	hasRequiredAllOf = 1;
	Object.defineProperty(allOf, "__esModule", { value: true });
	const util_1 = /*@__PURE__*/ requireUtil();
	const def = {
	    keyword: "allOf",
	    schemaType: "array",
	    code(cxt) {
	        const { gen, schema, it } = cxt;
	        /* istanbul ignore if */
	        if (!Array.isArray(schema))
	            throw new Error("ajv implementation error");
	        const valid = gen.name("valid");
	        schema.forEach((sch, i) => {
	            if ((0, util_1.alwaysValidSchema)(it, sch))
	                return;
	            const schCxt = cxt.subschema({ keyword: "allOf", schemaProp: i }, valid);
	            cxt.ok(valid);
	            cxt.mergeEvaluated(schCxt);
	        });
	    },
	};
	allOf.default = def;
	
	return allOf;
}

var _if = {};

var hasRequired_if;

function require_if () {
	if (hasRequired_if) return _if;
	hasRequired_if = 1;
	Object.defineProperty(_if, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: ({ params }) => (0, codegen_1.str) `must match "${params.ifClause}" schema`,
	    params: ({ params }) => (0, codegen_1._) `{failingKeyword: ${params.ifClause}}`,
	};
	const def = {
	    keyword: "if",
	    schemaType: ["object", "boolean"],
	    trackErrors: true,
	    error,
	    code(cxt) {
	        const { gen, parentSchema, it } = cxt;
	        if (parentSchema.then === undefined && parentSchema.else === undefined) {
	            (0, util_1.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
	        }
	        const hasThen = hasSchema(it, "then");
	        const hasElse = hasSchema(it, "else");
	        if (!hasThen && !hasElse)
	            return;
	        const valid = gen.let("valid", true);
	        const schValid = gen.name("_valid");
	        validateIf();
	        cxt.reset();
	        if (hasThen && hasElse) {
	            const ifClause = gen.let("ifClause");
	            cxt.setParams({ ifClause });
	            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
	        }
	        else if (hasThen) {
	            gen.if(schValid, validateClause("then"));
	        }
	        else {
	            gen.if((0, codegen_1.not)(schValid), validateClause("else"));
	        }
	        cxt.pass(valid, () => cxt.error(true));
	        function validateIf() {
	            const schCxt = cxt.subschema({
	                keyword: "if",
	                compositeRule: true,
	                createErrors: false,
	                allErrors: false,
	            }, schValid);
	            cxt.mergeEvaluated(schCxt);
	        }
	        function validateClause(keyword, ifClause) {
	            return () => {
	                const schCxt = cxt.subschema({ keyword }, schValid);
	                gen.assign(valid, schValid);
	                cxt.mergeValidEvaluated(schCxt, valid);
	                if (ifClause)
	                    gen.assign(ifClause, (0, codegen_1._) `${keyword}`);
	                else
	                    cxt.setParams({ ifClause: keyword });
	            };
	        }
	    },
	};
	function hasSchema(it, keyword) {
	    const schema = it.schema[keyword];
	    return schema !== undefined && !(0, util_1.alwaysValidSchema)(it, schema);
	}
	_if.default = def;
	
	return _if;
}

var thenElse = {};

var hasRequiredThenElse;

function requireThenElse () {
	if (hasRequiredThenElse) return thenElse;
	hasRequiredThenElse = 1;
	Object.defineProperty(thenElse, "__esModule", { value: true });
	const util_1 = /*@__PURE__*/ requireUtil();
	const def = {
	    keyword: ["then", "else"],
	    schemaType: ["object", "boolean"],
	    code({ keyword, parentSchema, it }) {
	        if (parentSchema.if === undefined)
	            (0, util_1.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
	    },
	};
	thenElse.default = def;
	
	return thenElse;
}

var hasRequiredApplicator;

function requireApplicator () {
	if (hasRequiredApplicator) return applicator;
	hasRequiredApplicator = 1;
	Object.defineProperty(applicator, "__esModule", { value: true });
	const additionalItems_1 = /*@__PURE__*/ requireAdditionalItems();
	const prefixItems_1 = /*@__PURE__*/ requirePrefixItems();
	const items_1 = /*@__PURE__*/ requireItems();
	const items2020_1 = /*@__PURE__*/ requireItems2020();
	const contains_1 = /*@__PURE__*/ requireContains();
	const dependencies_1 = /*@__PURE__*/ requireDependencies();
	const propertyNames_1 = /*@__PURE__*/ requirePropertyNames();
	const additionalProperties_1 = /*@__PURE__*/ requireAdditionalProperties();
	const properties_1 = /*@__PURE__*/ requireProperties();
	const patternProperties_1 = /*@__PURE__*/ requirePatternProperties();
	const not_1 = /*@__PURE__*/ requireNot();
	const anyOf_1 = /*@__PURE__*/ requireAnyOf();
	const oneOf_1 = /*@__PURE__*/ requireOneOf();
	const allOf_1 = /*@__PURE__*/ requireAllOf();
	const if_1 = /*@__PURE__*/ require_if();
	const thenElse_1 = /*@__PURE__*/ requireThenElse();
	function getApplicator(draft2020 = false) {
	    const applicator = [
	        // any
	        not_1.default,
	        anyOf_1.default,
	        oneOf_1.default,
	        allOf_1.default,
	        if_1.default,
	        thenElse_1.default,
	        // object
	        propertyNames_1.default,
	        additionalProperties_1.default,
	        dependencies_1.default,
	        properties_1.default,
	        patternProperties_1.default,
	    ];
	    // array
	    if (draft2020)
	        applicator.push(prefixItems_1.default, items2020_1.default);
	    else
	        applicator.push(additionalItems_1.default, items_1.default);
	    applicator.push(contains_1.default);
	    return applicator;
	}
	applicator.default = getApplicator;
	
	return applicator;
}

var format$1 = {};

var format = {};

var hasRequiredFormat$1;

function requireFormat$1 () {
	if (hasRequiredFormat$1) return format;
	hasRequiredFormat$1 = 1;
	Object.defineProperty(format, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const error = {
	    message: ({ schemaCode }) => (0, codegen_1.str) `must match format "${schemaCode}"`,
	    params: ({ schemaCode }) => (0, codegen_1._) `{format: ${schemaCode}}`,
	};
	const def = {
	    keyword: "format",
	    type: ["number", "string"],
	    schemaType: "string",
	    $data: true,
	    error,
	    code(cxt, ruleType) {
	        const { gen, data, $data, schema, schemaCode, it } = cxt;
	        const { opts, errSchemaPath, schemaEnv, self } = it;
	        if (!opts.validateFormats)
	            return;
	        if ($data)
	            validate$DataFormat();
	        else
	            validateFormat();
	        function validate$DataFormat() {
	            const fmts = gen.scopeValue("formats", {
	                ref: self.formats,
	                code: opts.code.formats,
	            });
	            const fDef = gen.const("fDef", (0, codegen_1._) `${fmts}[${schemaCode}]`);
	            const fType = gen.let("fType");
	            const format = gen.let("format");
	            // TODO simplify
	            gen.if((0, codegen_1._) `typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, () => gen.assign(fType, (0, codegen_1._) `${fDef}.type || "string"`).assign(format, (0, codegen_1._) `${fDef}.validate`), () => gen.assign(fType, (0, codegen_1._) `"string"`).assign(format, fDef));
	            cxt.fail$data((0, codegen_1.or)(unknownFmt(), invalidFmt()));
	            function unknownFmt() {
	                if (opts.strictSchema === false)
	                    return codegen_1.nil;
	                return (0, codegen_1._) `${schemaCode} && !${format}`;
	            }
	            function invalidFmt() {
	                const callFormat = schemaEnv.$async
	                    ? (0, codegen_1._) `(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))`
	                    : (0, codegen_1._) `${format}(${data})`;
	                const validData = (0, codegen_1._) `(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
	                return (0, codegen_1._) `${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
	            }
	        }
	        function validateFormat() {
	            const formatDef = self.formats[schema];
	            if (!formatDef) {
	                unknownFormat();
	                return;
	            }
	            if (formatDef === true)
	                return;
	            const [fmtType, format, fmtRef] = getFormat(formatDef);
	            if (fmtType === ruleType)
	                cxt.pass(validCondition());
	            function unknownFormat() {
	                if (opts.strictSchema === false) {
	                    self.logger.warn(unknownMsg());
	                    return;
	                }
	                throw new Error(unknownMsg());
	                function unknownMsg() {
	                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
	                }
	            }
	            function getFormat(fmtDef) {
	                const code = fmtDef instanceof RegExp
	                    ? (0, codegen_1.regexpCode)(fmtDef)
	                    : opts.code.formats
	                        ? (0, codegen_1._) `${opts.code.formats}${(0, codegen_1.getProperty)(schema)}`
	                        : undefined;
	                const fmt = gen.scopeValue("formats", { key: schema, ref: fmtDef, code });
	                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) {
	                    return [fmtDef.type || "string", fmtDef.validate, (0, codegen_1._) `${fmt}.validate`];
	                }
	                return ["string", fmtDef, fmt];
	            }
	            function validCondition() {
	                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
	                    if (!schemaEnv.$async)
	                        throw new Error("async format in sync schema");
	                    return (0, codegen_1._) `await ${fmtRef}(${data})`;
	                }
	                return typeof format == "function" ? (0, codegen_1._) `${fmtRef}(${data})` : (0, codegen_1._) `${fmtRef}.test(${data})`;
	            }
	        }
	    },
	};
	format.default = def;
	
	return format;
}

var hasRequiredFormat;

function requireFormat () {
	if (hasRequiredFormat) return format$1;
	hasRequiredFormat = 1;
	Object.defineProperty(format$1, "__esModule", { value: true });
	const format_1 = /*@__PURE__*/ requireFormat$1();
	const format = [format_1.default];
	format$1.default = format;
	
	return format$1;
}

var metadata = {};

var hasRequiredMetadata;

function requireMetadata () {
	if (hasRequiredMetadata) return metadata;
	hasRequiredMetadata = 1;
	Object.defineProperty(metadata, "__esModule", { value: true });
	metadata.contentVocabulary = metadata.metadataVocabulary = void 0;
	metadata.metadataVocabulary = [
	    "title",
	    "description",
	    "default",
	    "deprecated",
	    "readOnly",
	    "writeOnly",
	    "examples",
	];
	metadata.contentVocabulary = [
	    "contentMediaType",
	    "contentEncoding",
	    "contentSchema",
	];
	
	return metadata;
}

var hasRequiredDraft7;

function requireDraft7 () {
	if (hasRequiredDraft7) return draft7;
	hasRequiredDraft7 = 1;
	Object.defineProperty(draft7, "__esModule", { value: true });
	const core_1 = /*@__PURE__*/ requireCore();
	const validation_1 = /*@__PURE__*/ requireValidation();
	const applicator_1 = /*@__PURE__*/ requireApplicator();
	const format_1 = /*@__PURE__*/ requireFormat();
	const metadata_1 = /*@__PURE__*/ requireMetadata();
	const draft7Vocabularies = [
	    core_1.default,
	    validation_1.default,
	    (0, applicator_1.default)(),
	    format_1.default,
	    metadata_1.metadataVocabulary,
	    metadata_1.contentVocabulary,
	];
	draft7.default = draft7Vocabularies;
	
	return draft7;
}

var discriminator = {};

var types = {};

var hasRequiredTypes;

function requireTypes () {
	if (hasRequiredTypes) return types;
	hasRequiredTypes = 1;
	Object.defineProperty(types, "__esModule", { value: true });
	types.DiscrError = void 0;
	var DiscrError;
	(function (DiscrError) {
	    DiscrError["Tag"] = "tag";
	    DiscrError["Mapping"] = "mapping";
	})(DiscrError || (types.DiscrError = DiscrError = {}));
	
	return types;
}

var hasRequiredDiscriminator;

function requireDiscriminator () {
	if (hasRequiredDiscriminator) return discriminator;
	hasRequiredDiscriminator = 1;
	Object.defineProperty(discriminator, "__esModule", { value: true });
	const codegen_1 = /*@__PURE__*/ requireCodegen();
	const types_1 = /*@__PURE__*/ requireTypes();
	const compile_1 = /*@__PURE__*/ requireCompile();
	const ref_error_1 = /*@__PURE__*/ requireRef_error();
	const util_1 = /*@__PURE__*/ requireUtil();
	const error = {
	    message: ({ params: { discrError, tagName } }) => discrError === types_1.DiscrError.Tag
	        ? `tag "${tagName}" must be string`
	        : `value of tag "${tagName}" must be in oneOf`,
	    params: ({ params: { discrError, tag, tagName } }) => (0, codegen_1._) `{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`,
	};
	const def = {
	    keyword: "discriminator",
	    type: "object",
	    schemaType: "object",
	    error,
	    code(cxt) {
	        const { gen, data, schema, parentSchema, it } = cxt;
	        const { oneOf } = parentSchema;
	        if (!it.opts.discriminator) {
	            throw new Error("discriminator: requires discriminator option");
	        }
	        const tagName = schema.propertyName;
	        if (typeof tagName != "string")
	            throw new Error("discriminator: requires propertyName");
	        if (schema.mapping)
	            throw new Error("discriminator: mapping is not supported");
	        if (!oneOf)
	            throw new Error("discriminator: requires oneOf keyword");
	        const valid = gen.let("valid", false);
	        const tag = gen.const("tag", (0, codegen_1._) `${data}${(0, codegen_1.getProperty)(tagName)}`);
	        gen.if((0, codegen_1._) `typeof ${tag} == "string"`, () => validateMapping(), () => cxt.error(false, { discrError: types_1.DiscrError.Tag, tag, tagName }));
	        cxt.ok(valid);
	        function validateMapping() {
	            const mapping = getMapping();
	            gen.if(false);
	            for (const tagValue in mapping) {
	                gen.elseIf((0, codegen_1._) `${tag} === ${tagValue}`);
	                gen.assign(valid, applyTagSchema(mapping[tagValue]));
	            }
	            gen.else();
	            cxt.error(false, { discrError: types_1.DiscrError.Mapping, tag, tagName });
	            gen.endIf();
	        }
	        function applyTagSchema(schemaProp) {
	            const _valid = gen.name("valid");
	            const schCxt = cxt.subschema({ keyword: "oneOf", schemaProp }, _valid);
	            cxt.mergeEvaluated(schCxt, codegen_1.Name);
	            return _valid;
	        }
	        function getMapping() {
	            var _a;
	            const oneOfMapping = {};
	            const topRequired = hasRequired(parentSchema);
	            let tagRequired = true;
	            for (let i = 0; i < oneOf.length; i++) {
	                let sch = oneOf[i];
	                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, util_1.schemaHasRulesButRef)(sch, it.self.RULES)) {
	                    const ref = sch.$ref;
	                    sch = compile_1.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
	                    if (sch instanceof compile_1.SchemaEnv)
	                        sch = sch.schema;
	                    if (sch === undefined)
	                        throw new ref_error_1.default(it.opts.uriResolver, it.baseId, ref);
	                }
	                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
	                if (typeof propSch != "object") {
	                    throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
	                }
	                tagRequired = tagRequired && (topRequired || hasRequired(sch));
	                addMappings(propSch, i);
	            }
	            if (!tagRequired)
	                throw new Error(`discriminator: "${tagName}" must be required`);
	            return oneOfMapping;
	            function hasRequired({ required }) {
	                return Array.isArray(required) && required.includes(tagName);
	            }
	            function addMappings(sch, i) {
	                if (sch.const) {
	                    addMapping(sch.const, i);
	                }
	                else if (sch.enum) {
	                    for (const tagValue of sch.enum) {
	                        addMapping(tagValue, i);
	                    }
	                }
	                else {
	                    throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
	                }
	            }
	            function addMapping(tagValue, i) {
	                if (typeof tagValue != "string" || tagValue in oneOfMapping) {
	                    throw new Error(`discriminator: "${tagName}" values must be unique strings`);
	                }
	                oneOfMapping[tagValue] = i;
	            }
	        }
	    },
	};
	discriminator.default = def;
	
	return discriminator;
}

var $schema = "http://json-schema.org/draft-07/schema#";
var $id = "http://json-schema.org/draft-07/schema#";
var title = "Core schema meta-schema";
var definitions = {
	schemaArray: {
		type: "array",
		minItems: 1,
		items: {
			$ref: "#"
		}
	},
	nonNegativeInteger: {
		type: "integer",
		minimum: 0
	},
	nonNegativeIntegerDefault0: {
		allOf: [
			{
				$ref: "#/definitions/nonNegativeInteger"
			},
			{
				"default": 0
			}
		]
	},
	simpleTypes: {
		"enum": [
			"array",
			"boolean",
			"integer",
			"null",
			"number",
			"object",
			"string"
		]
	},
	stringArray: {
		type: "array",
		items: {
			type: "string"
		},
		uniqueItems: true,
		"default": [
		]
	}
};
var type = [
	"object",
	"boolean"
];
var properties = {
	$id: {
		type: "string",
		format: "uri-reference"
	},
	$schema: {
		type: "string",
		format: "uri"
	},
	$ref: {
		type: "string",
		format: "uri-reference"
	},
	$comment: {
		type: "string"
	},
	title: {
		type: "string"
	},
	description: {
		type: "string"
	},
	"default": true,
	readOnly: {
		type: "boolean",
		"default": false
	},
	examples: {
		type: "array",
		items: true
	},
	multipleOf: {
		type: "number",
		exclusiveMinimum: 0
	},
	maximum: {
		type: "number"
	},
	exclusiveMaximum: {
		type: "number"
	},
	minimum: {
		type: "number"
	},
	exclusiveMinimum: {
		type: "number"
	},
	maxLength: {
		$ref: "#/definitions/nonNegativeInteger"
	},
	minLength: {
		$ref: "#/definitions/nonNegativeIntegerDefault0"
	},
	pattern: {
		type: "string",
		format: "regex"
	},
	additionalItems: {
		$ref: "#"
	},
	items: {
		anyOf: [
			{
				$ref: "#"
			},
			{
				$ref: "#/definitions/schemaArray"
			}
		],
		"default": true
	},
	maxItems: {
		$ref: "#/definitions/nonNegativeInteger"
	},
	minItems: {
		$ref: "#/definitions/nonNegativeIntegerDefault0"
	},
	uniqueItems: {
		type: "boolean",
		"default": false
	},
	contains: {
		$ref: "#"
	},
	maxProperties: {
		$ref: "#/definitions/nonNegativeInteger"
	},
	minProperties: {
		$ref: "#/definitions/nonNegativeIntegerDefault0"
	},
	required: {
		$ref: "#/definitions/stringArray"
	},
	additionalProperties: {
		$ref: "#"
	},
	definitions: {
		type: "object",
		additionalProperties: {
			$ref: "#"
		},
		"default": {
		}
	},
	properties: {
		type: "object",
		additionalProperties: {
			$ref: "#"
		},
		"default": {
		}
	},
	patternProperties: {
		type: "object",
		additionalProperties: {
			$ref: "#"
		},
		propertyNames: {
			format: "regex"
		},
		"default": {
		}
	},
	dependencies: {
		type: "object",
		additionalProperties: {
			anyOf: [
				{
					$ref: "#"
				},
				{
					$ref: "#/definitions/stringArray"
				}
			]
		}
	},
	propertyNames: {
		$ref: "#"
	},
	"const": true,
	"enum": {
		type: "array",
		items: true,
		minItems: 1,
		uniqueItems: true
	},
	type: {
		anyOf: [
			{
				$ref: "#/definitions/simpleTypes"
			},
			{
				type: "array",
				items: {
					$ref: "#/definitions/simpleTypes"
				},
				minItems: 1,
				uniqueItems: true
			}
		]
	},
	format: {
		type: "string"
	},
	contentMediaType: {
		type: "string"
	},
	contentEncoding: {
		type: "string"
	},
	"if": {
		$ref: "#"
	},
	then: {
		$ref: "#"
	},
	"else": {
		$ref: "#"
	},
	allOf: {
		$ref: "#/definitions/schemaArray"
	},
	anyOf: {
		$ref: "#/definitions/schemaArray"
	},
	oneOf: {
		$ref: "#/definitions/schemaArray"
	},
	not: {
		$ref: "#"
	}
};
var require$$3 = {
	$schema: $schema,
	$id: $id,
	title: title,
	definitions: definitions,
	type: type,
	properties: properties,
	"default": true
};

ajv.exports;

var hasRequiredAjv;

function requireAjv () {
	if (hasRequiredAjv) return ajv.exports;
	hasRequiredAjv = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;
		const core_1 = /*@__PURE__*/ requireCore$1();
		const draft7_1 = /*@__PURE__*/ requireDraft7();
		const discriminator_1 = /*@__PURE__*/ requireDiscriminator();
		const draft7MetaSchema = require$$3;
		const META_SUPPORT_DATA = ["/properties"];
		const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
		class Ajv extends core_1.default {
		    _addVocabularies() {
		        super._addVocabularies();
		        draft7_1.default.forEach((v) => this.addVocabulary(v));
		        if (this.opts.discriminator)
		            this.addKeyword(discriminator_1.default);
		    }
		    _addDefaultMetaSchema() {
		        super._addDefaultMetaSchema();
		        if (!this.opts.meta)
		            return;
		        const metaSchema = this.opts.$data
		            ? this.$dataMetaSchema(draft7MetaSchema, META_SUPPORT_DATA)
		            : draft7MetaSchema;
		        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
		        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
		    }
		    defaultMeta() {
		        return (this.opts.defaultMeta =
		            super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined));
		    }
		}
		exports.Ajv = Ajv;
		module.exports = exports = Ajv;
		module.exports.Ajv = Ajv;
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.default = Ajv;
		var validate_1 = /*@__PURE__*/ requireValidate();
		Object.defineProperty(exports, "KeywordCxt", { enumerable: true, get: function () { return validate_1.KeywordCxt; } });
		var codegen_1 = /*@__PURE__*/ requireCodegen();
		Object.defineProperty(exports, "_", { enumerable: true, get: function () { return codegen_1._; } });
		Object.defineProperty(exports, "str", { enumerable: true, get: function () { return codegen_1.str; } });
		Object.defineProperty(exports, "stringify", { enumerable: true, get: function () { return codegen_1.stringify; } });
		Object.defineProperty(exports, "nil", { enumerable: true, get: function () { return codegen_1.nil; } });
		Object.defineProperty(exports, "Name", { enumerable: true, get: function () { return codegen_1.Name; } });
		Object.defineProperty(exports, "CodeGen", { enumerable: true, get: function () { return codegen_1.CodeGen; } });
		var validation_error_1 = /*@__PURE__*/ requireValidation_error();
		Object.defineProperty(exports, "ValidationError", { enumerable: true, get: function () { return validation_error_1.default; } });
		var ref_error_1 = /*@__PURE__*/ requireRef_error();
		Object.defineProperty(exports, "MissingRefError", { enumerable: true, get: function () { return ref_error_1.default; } });
		
	} (ajv, ajv.exports));
	return ajv.exports;
}

var ajvExports = /*@__PURE__*/ requireAjv();
var Ajv = /*@__PURE__*/getDefaultExportFromCjs(ajvExports);

var dist = {exports: {}};

var formats = {};

var hasRequiredFormats;

function requireFormats () {
	if (hasRequiredFormats) return formats;
	hasRequiredFormats = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.formatNames = exports.fastFormats = exports.fullFormats = void 0;
		function fmtDef(validate, compare) {
		    return { validate, compare };
		}
		exports.fullFormats = {
		    // date: http://tools.ietf.org/html/rfc3339#section-5.6
		    date: fmtDef(date, compareDate),
		    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
		    time: fmtDef(time, compareTime),
		    "date-time": fmtDef(date_time, compareDateTime),
		    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
		    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
		    uri,
		    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
		    // uri-template: https://tools.ietf.org/html/rfc6570
		    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
		    // For the source: https://gist.github.com/dperini/729294
		    // For test cases: https://mathiasbynens.be/demo/url-regex
		    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
		    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
		    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
		    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
		    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
		    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
		    regex,
		    // uuid: http://tools.ietf.org/html/rfc4122
		    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
		    // JSON-pointer: https://tools.ietf.org/html/rfc6901
		    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
		    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
		    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
		    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
		    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
		    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
		    // byte: https://github.com/miguelmota/is-base64
		    byte,
		    // signed 32 bit integer
		    int32: { type: "number", validate: validateInt32 },
		    // signed 64 bit integer
		    int64: { type: "number", validate: validateInt64 },
		    // C-type float
		    float: { type: "number", validate: validateNumber },
		    // C-type double
		    double: { type: "number", validate: validateNumber },
		    // hint to the UI to hide input strings
		    password: true,
		    // unchecked string payload
		    binary: true,
		};
		exports.fastFormats = {
		    ...exports.fullFormats,
		    date: fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, compareDate),
		    time: fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, compareTime),
		    "date-time": fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, compareDateTime),
		    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
		    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
		    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
		    // email (sources from jsen validator):
		    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
		    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
		    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
		};
		exports.formatNames = Object.keys(exports.fullFormats);
		function isLeapYear(year) {
		    // https://tools.ietf.org/html/rfc3339#appendix-C
		    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
		}
		const DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
		const DAYS = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		function date(str) {
		    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
		    const matches = DATE.exec(str);
		    if (!matches)
		        return false;
		    const year = +matches[1];
		    const month = +matches[2];
		    const day = +matches[3];
		    return (month >= 1 &&
		        month <= 12 &&
		        day >= 1 &&
		        day <= (month === 2 && isLeapYear(year) ? 29 : DAYS[month]));
		}
		function compareDate(d1, d2) {
		    if (!(d1 && d2))
		        return undefined;
		    if (d1 > d2)
		        return 1;
		    if (d1 < d2)
		        return -1;
		    return 0;
		}
		const TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
		function time(str, withTimeZone) {
		    const matches = TIME.exec(str);
		    if (!matches)
		        return false;
		    const hour = +matches[1];
		    const minute = +matches[2];
		    const second = +matches[3];
		    const timeZone = matches[5];
		    return (((hour <= 23 && minute <= 59 && second <= 59) ||
		        (hour === 23 && minute === 59 && second === 60)) &&
		        (!withTimeZone || timeZone !== ""));
		}
		function compareTime(t1, t2) {
		    if (!(t1 && t2))
		        return undefined;
		    const a1 = TIME.exec(t1);
		    const a2 = TIME.exec(t2);
		    if (!(a1 && a2))
		        return undefined;
		    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
		    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
		    if (t1 > t2)
		        return 1;
		    if (t1 < t2)
		        return -1;
		    return 0;
		}
		const DATE_TIME_SEPARATOR = /t|\s/i;
		function date_time(str) {
		    // http://tools.ietf.org/html/rfc3339#section-5.6
		    const dateTime = str.split(DATE_TIME_SEPARATOR);
		    return dateTime.length === 2 && date(dateTime[0]) && time(dateTime[1], true);
		}
		function compareDateTime(dt1, dt2) {
		    if (!(dt1 && dt2))
		        return undefined;
		    const [d1, t1] = dt1.split(DATE_TIME_SEPARATOR);
		    const [d2, t2] = dt2.split(DATE_TIME_SEPARATOR);
		    const res = compareDate(d1, d2);
		    if (res === undefined)
		        return undefined;
		    return res || compareTime(t1, t2);
		}
		const NOT_URI_FRAGMENT = /\/|:/;
		const URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
		function uri(str) {
		    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
		    return NOT_URI_FRAGMENT.test(str) && URI.test(str);
		}
		const BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
		function byte(str) {
		    BYTE.lastIndex = 0;
		    return BYTE.test(str);
		}
		const MIN_INT32 = -(2 ** 31);
		const MAX_INT32 = 2 ** 31 - 1;
		function validateInt32(value) {
		    return Number.isInteger(value) && value <= MAX_INT32 && value >= MIN_INT32;
		}
		function validateInt64(value) {
		    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
		    return Number.isInteger(value);
		}
		function validateNumber() {
		    return true;
		}
		const Z_ANCHOR = /[^\\]\\Z/;
		function regex(str) {
		    if (Z_ANCHOR.test(str))
		        return false;
		    try {
		        new RegExp(str);
		        return true;
		    }
		    catch (e) {
		        return false;
		    }
		}
		
	} (formats));
	return formats;
}

var limit = {};

var hasRequiredLimit;

function requireLimit () {
	if (hasRequiredLimit) return limit;
	hasRequiredLimit = 1;
	(function (exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.formatLimitDefinition = void 0;
		const ajv_1 = /*@__PURE__*/ requireAjv();
		const codegen_1 = /*@__PURE__*/ requireCodegen();
		const ops = codegen_1.operators;
		const KWDs = {
		    formatMaximum: { okStr: "<=", ok: ops.LTE, fail: ops.GT },
		    formatMinimum: { okStr: ">=", ok: ops.GTE, fail: ops.LT },
		    formatExclusiveMaximum: { okStr: "<", ok: ops.LT, fail: ops.GTE },
		    formatExclusiveMinimum: { okStr: ">", ok: ops.GT, fail: ops.LTE },
		};
		const error = {
		    message: ({ keyword, schemaCode }) => codegen_1.str `should be ${KWDs[keyword].okStr} ${schemaCode}`,
		    params: ({ keyword, schemaCode }) => codegen_1._ `{comparison: ${KWDs[keyword].okStr}, limit: ${schemaCode}}`,
		};
		exports.formatLimitDefinition = {
		    keyword: Object.keys(KWDs),
		    type: "string",
		    schemaType: "string",
		    $data: true,
		    error,
		    code(cxt) {
		        const { gen, data, schemaCode, keyword, it } = cxt;
		        const { opts, self } = it;
		        if (!opts.validateFormats)
		            return;
		        const fCxt = new ajv_1.KeywordCxt(it, self.RULES.all.format.definition, "format");
		        if (fCxt.$data)
		            validate$DataFormat();
		        else
		            validateFormat();
		        function validate$DataFormat() {
		            const fmts = gen.scopeValue("formats", {
		                ref: self.formats,
		                code: opts.code.formats,
		            });
		            const fmt = gen.const("fmt", codegen_1._ `${fmts}[${fCxt.schemaCode}]`);
		            cxt.fail$data(codegen_1.or(codegen_1._ `typeof ${fmt} != "object"`, codegen_1._ `${fmt} instanceof RegExp`, codegen_1._ `typeof ${fmt}.compare != "function"`, compareCode(fmt)));
		        }
		        function validateFormat() {
		            const format = fCxt.schema;
		            const fmtDef = self.formats[format];
		            if (!fmtDef || fmtDef === true)
		                return;
		            if (typeof fmtDef != "object" ||
		                fmtDef instanceof RegExp ||
		                typeof fmtDef.compare != "function") {
		                throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
		            }
		            const fmt = gen.scopeValue("formats", {
		                key: format,
		                ref: fmtDef,
		                code: opts.code.formats ? codegen_1._ `${opts.code.formats}${codegen_1.getProperty(format)}` : undefined,
		            });
		            cxt.fail$data(compareCode(fmt));
		        }
		        function compareCode(fmt) {
		            return codegen_1._ `${fmt}.compare(${data}, ${schemaCode}) ${KWDs[keyword].fail} 0`;
		        }
		    },
		    dependencies: ["format"],
		};
		const formatLimitPlugin = (ajv) => {
		    ajv.addKeyword(exports.formatLimitDefinition);
		    return ajv;
		};
		exports.default = formatLimitPlugin;
		
	} (limit));
	return limit;
}

dist.exports;

var hasRequiredDist;

function requireDist () {
	if (hasRequiredDist) return dist.exports;
	hasRequiredDist = 1;
	(function (module, exports) {
		Object.defineProperty(exports, "__esModule", { value: true });
		const formats_1 = requireFormats();
		const limit_1 = requireLimit();
		const codegen_1 = /*@__PURE__*/ requireCodegen();
		const fullName = new codegen_1.Name("fullFormats");
		const fastName = new codegen_1.Name("fastFormats");
		const formatsPlugin = (ajv, opts = { keywords: true }) => {
		    if (Array.isArray(opts)) {
		        addFormats(ajv, opts, formats_1.fullFormats, fullName);
		        return ajv;
		    }
		    const [formats, exportName] = opts.mode === "fast" ? [formats_1.fastFormats, fastName] : [formats_1.fullFormats, fullName];
		    const list = opts.formats || formats_1.formatNames;
		    addFormats(ajv, list, formats, exportName);
		    if (opts.keywords)
		        limit_1.default(ajv);
		    return ajv;
		};
		formatsPlugin.get = (name, mode = "full") => {
		    const formats = mode === "fast" ? formats_1.fastFormats : formats_1.fullFormats;
		    const f = formats[name];
		    if (!f)
		        throw new Error(`Unknown format "${name}"`);
		    return f;
		};
		function addFormats(ajv, list, fs, exportName) {
		    var _a;
		    var _b;
		    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : (_b.formats = codegen_1._ `require("ajv-formats/dist/formats").${exportName}`);
		    for (const f of list)
		        ajv.addFormat(f, fs[f]);
		}
		module.exports = exports = formatsPlugin;
		Object.defineProperty(exports, "__esModule", { value: true });
		exports.default = formatsPlugin;
		
	} (dist, dist.exports));
	return dist.exports;
}

var distExports = requireDist();
var addFormats = /*@__PURE__*/getDefaultExportFromCjs(distExports);

/**
 * Schema matching LinkBundle interface from src/LinkBundle.ts
 */
var LinkBundleSchema = {
    $id: "https://hrk.de/schemas/v1/common/link-bundle.json",
    type: "object",
    title: "Link Bundle",
    description: "A hyperlink with metadata",
    properties: {
        id: {
            type: "integer",
            description: "Unique link identifier (optional for backward compatibility)",
        },
        link: {
            type: "string",
            description: "URL target",
        },
        target: {
            type: "string",
            enum: ["blank", "self"],
            description: "Link target behavior",
        },
        language: {
            $ref: "https://hrk.de/schemas/v1/common/app-locale.json",
            description: "Language code (AppLocale)",
        },
        linkType: {
            $ref: "https://hrk.de/schemas/v1/common/link-type.json",
            description: "Link type classification (LinkType enum)",
        },
        description: {
            type: "string",
            description: "Optional link description",
        },
        title: {
            type: "string",
            description: "Optional link title",
        },
        descriptionEditable: {
            type: "boolean",
            description: "Deprecated: links are always editable",
        },
        status: {
            $ref: "https://hrk.de/schemas/v1/common/link-status.json",
            description: "Link status",
        },
        visualization: {
            $ref: "https://hrk.de/schemas/v1/common/link-visualization.json",
            description: "Link visualization style",
        },
        buttonIcon: {
            oneOf: [
                { $ref: "https://hrk.de/schemas/v1/common/frontend-icon-key.json" },
                { $ref: "https://hrk.de/schemas/v1/hrk-types/icon-name.json" },
            ],
            description: "Icon key for button visualization (supports both HUW and HSK icon sets)",
        },
        colorSchema: {
            $ref: "https://hrk.de/schemas/v1/hrk-types/color.json",
            description: "Optional color scheme for buttons (HSK-specific)",
        },
    },
    required: ["link", "target", "language", "linkType"],
    additionalProperties: false,
};

var GeoLocationSchema = {
    $id: "https://hrk.de/schemas/v1/common/geo-location.json",
    type: "object",
    title: "Geo Location",
    description: "A physical location with coordinates",
    properties: {
        name: {
            type: "string",
            description: "Location name (city/region)",
        },
        postCode: {
            type: "string",
            pattern: "^[0-9]{5}$",
            description: "German postal code (5 digits)",
        },
        geoLocation: {
            type: "array",
            description: "Coordinates as [latitude, longitude]",
            items: { type: "number" },
            minItems: 2,
            maxItems: 2,
        },
        federalState: {
            type: "string",
            description: "German federal state (Bundesland)",
        },
        isHeadquarters: {
            type: "boolean",
            description: "Whether this is the main location",
        },
        headquartersFederalState: {
            type: "string",
            description: "Federal state of the headquarters location (used for dynamic module filtering)",
        },
        headquartersLocationName: {
            type: "string",
            description: "City name of the headquarters location (used for dynamic module filtering)",
        },
    },
    required: ["geoLocation"],
    additionalProperties: false,
};

var AddressSchema = {
    $id: "https://hrk.de/schemas/v1/common/address.json",
    type: "object",
    title: "Address",
    description: "Postal address structure",
    properties: {
        street: {
            type: "string",
            description: "Street name and number",
        },
        zipCode: {
            type: "string",
            pattern: "^[0-9]{5}$",
            description: "German postal code (5 digits)",
        },
        place: {
            type: "string",
            description: "City or town name",
        },
    },
    required: ["zipCode", "place"],
    additionalProperties: false,
};

var ContactSchema = {
    $id: "https://hrk.de/schemas/v1/common/contact.json",
    type: "object",
    title: "Contact",
    description: "Contact person or office details",
    properties: {
        name: {
            type: "string",
            description: "Contact name",
        },
        email: {
            type: "string",
            format: "email",
            description: "Email address",
        },
        phone: {
            type: "string",
            description: "Phone number",
        },
        role: {
            type: "string",
            description: "Position/role title",
        },
        contactOffice: {
            type: "string",
            description: "Office name",
        },
        isContactOffice: {
            type: "boolean",
            description: "Whether this is an office contact",
        },
        address: {
            $ref: "https://hrk.de/schemas/v1/common/address.json",
        },
        website: {
            $ref: "https://hrk.de/schemas/v1/common/link-bundle.json",
        },
    },
    additionalProperties: false,
};

var PeriodSchema = {
    $id: "https://hrk.de/schemas/v1/common/period.json",
    type: "object",
    title: "Period",
    description: "Time period with from/to dates",
    properties: {
        from: {
            type: "string",
            format: "date-time",
            description: "ISO 8601 datetime",
        },
        to: {
            anyOf: [
                { type: "string", format: "date-time" },
                { type: "string", maxLength: 0 },
            ],
            description: "ISO 8601 datetime or empty string",
        },
    },
    required: ["to"],
    additionalProperties: false,
};
var PeriodWithRemarksSchema = {
    $id: "https://hrk.de/schemas/v1/common/period-with-remarks.json",
    type: "object",
    title: "Period with Remarks",
    description: "Period with additional remarks field",
    properties: {
        remarks: {
            type: "string",
            description: "Additional information about the period",
        },
        period: {
            $ref: "https://hrk.de/schemas/v1/common/period.json",
        },
    },
    additionalProperties: false,
};
var PeriodWithRemarksAndTitleSchema = {
    $id: "https://hrk.de/schemas/v1/common/period-with-remarks-and-title.json",
    type: "object",
    title: "Period with Remarks and Title",
    description: "Period with title and remarks",
    properties: {
        title: {
            type: "string",
            description: "Period title",
        },
        remarks: {
            type: "string",
            description: "Additional information",
        },
        period: {
            $ref: "https://hrk.de/schemas/v1/common/period.json",
        },
    },
    required: ["title"],
    additionalProperties: false,
};

/**
 * Schema matching Experience interface from src/WeiterbildungsAngebotExport.ts
 * Praktische Erfahrung
 */
var ExperienceSchema = {
    $id: "https://hrk.de/schemas/v1/common/experience.json",
    type: "object",
    title: "Experience",
    description: "Required practical experience (Praktische Erfahrung)",
    properties: {
        type: {
            type: "string",
            description: 'Type of experience (e.g., "Berufserfahrung")',
        },
        amount: {
            type: "number",
            minimum: 0,
            description: "Duration amount",
        },
        unit: {
            type: "string",
            description: 'Duration unit (e.g., "Jahre", "Monate")',
        },
        area: {
            type: "string",
            description: "Field/area of experience",
        },
    },
    required: ["type"],
    additionalProperties: false,
};

/**
 * Schema matching Cooperation interface from src/WeiterbildungsAngebotExport.ts
 * Bildungsträger-Kooperation
 */
var CooperationSchema = {
    $id: "https://hrk.de/schemas/v1/common/cooperation.json",
    type: "object",
    title: "Cooperation",
    description: "Cooperation with educational institution (Bildungsträger-Kooperation)",
    properties: {
        begin: {
            type: "string",
            description: "Start date of cooperation (ISO date-time string)",
        },
        end: {
            type: "string",
            description: "End date of cooperation (ISO date-time string)",
        },
        company: {
            type: "object",
            description: "Cooperating institution",
            properties: {
                name: {
                    type: "string",
                    description: "Institution name",
                },
                zipCode: {
                    type: "string",
                    description: "Postal code",
                },
                place: {
                    type: "string",
                    description: "City/town",
                },
                predefined: {
                    type: "boolean",
                    description: "Whether this is a predefined institution",
                },
            },
            required: ["name"],
            additionalProperties: false,
        },
    },
    required: ["company"],
    additionalProperties: false,
};

/**
 * Schema matching RangeWithUnit interface from src/WeiterbildungsAngebotExport.ts
 * Used for "angebotsdauer" and "zeitaufwand" aka "workload"
 */
var RangeWithUnitSchema = {
    $id: "https://hrk.de/schemas/v1/common/range-with-unit.json",
    type: "object",
    title: "Range with Unit",
    description: "A numerical range with a unit of measurement (used for duration and workload)",
    properties: {
        from: {
            type: "number",
            description: "Start/minimum value",
        },
        to: {
            type: "number",
            description: "End/maximum value",
        },
        unit: {
            type: "string",
            description: 'Unit of measurement (e.g., "Stunden", "Wochen", "Tage")',
        },
    },
    required: ["unit"],
    additionalProperties: false,
};

/**
 * Schema matching MediaBundle interface from src/MediaBundle.ts
 */
var MediaBundleSchema = {
    $id: "https://hrk.de/schemas/v1/common/media-bundle.json",
    type: "object",
    title: "Media Bundle",
    description: "Media asset (image or video) with metadata",
    properties: {
        fileName: {
            type: "string",
            description: "File name",
        },
        src: {
            type: "string",
            description: "Optimized source URL for frontend usage",
        },
        thumbnailSrc: {
            type: "string",
            description: "Thumbnail source URL",
        },
        originalSizeSrc: {
            type: "string",
            description: "Unprocessed original source URL",
        },
        caption: {
            type: "string",
            description: "Image/video caption",
        },
        description: {
            type: "string",
            description: "Media description",
        },
        videoSrc: {
            type: "string",
            description: "Video URL or YouTube video ID",
        },
        pixxioFileId: {
            type: "string",
            description: "Pixxio file identifier",
        },
        previewImagePixxioFileId: {
            type: "string",
            description: "Pixxio preview image identifier",
        },
        playVideoOnHover: {
            type: "boolean",
            description: "Whether to play video on hover",
        },
        type: {
            $ref: "https://hrk.de/schemas/v1/common/media-bundle-type.json",
            description: "Media type",
        },
        objectFit: {
            type: "string",
            enum: ["cover", "contain", "fill", "none", "scale-down"],
            description: "Object fit type",
        },
        imageCropConfig: {
            type: "object",
            description: "Image cropping configuration",
            properties: {
                offsetX: {
                    type: "number",
                    description: "Horizontal offset",
                },
                offsetY: {
                    type: "number",
                    description: "Vertical offset",
                },
                height: {
                    type: "number",
                    description: "Crop height",
                },
                width: {
                    type: "number",
                    description: "Crop width",
                },
            },
            required: ["offsetX", "offsetY", "height", "width"],
            additionalProperties: false,
        },
    },
    additionalProperties: false,
};

/**
 * Schema matching Testimonial interface from src/Testimonial.ts
 */
var TestimonialSchema = {
    $id: "https://hrk.de/schemas/v1/common/testimonial.json",
    type: "object",
    title: "Testimonial",
    description: "Base testimonial with quote fields",
    properties: {
        quoteText: {
            type: "string",
            description: "Testimonial quote text",
        },
        quoteAuthor: {
            type: "string",
            description: "Name of the person giving the testimonial",
        },
        quoteRole: {
            type: "string",
            description: "Role/position of the author",
        },
    },
};

var WACoreSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/core.json",
    type: "object",
    title: "Weiterbildungsangebot Core Fields",
    description: "Core fields for Weiterbildungsangebot export",
    properties: {
        id: {
            type: "string",
            description: "Weiterbildungsangebot ID as string",
        },
        title: {
            type: "string",
            description: "Offer title (Angebotsbezeichnung)",
        },
        type: {
            type: "string",
            description: "Offer type (AngebotsTyp)",
        },
        degree: {
            type: "string",
            description: "Degree/certificate type (Abschlussart)",
        },
        ects: {
            type: ["number", "null"],
            minimum: 0,
            description: "ECTS credits or null",
        },
        mandatoryFinalThesis: {
            type: "boolean",
            description: "Whether final thesis is mandatory",
        },
        mandatorySubsetOfCourses: {
            type: "boolean",
            description: "Whether subset of courses is mandatory",
        },
        universityId: {
            type: "integer",
            description: "Hochschule database ID",
        },
        universityName: {
            type: "string",
            minLength: 1,
            description: "University full name",
        },
        universityShortName: {
            type: "string",
            minLength: 1,
            description: "University short name",
        },
        universityAddressName: {
            type: "string",
            description: "University address name",
        },
        universityLogoUrl: {
            type: "string",
            format: "uri-reference",
            description: "Relative path to university logo",
        },
        universityWebsite: {
            $ref: "https://hrk.de/schemas/v1/common/link-bundle.json",
        },
        universityType: {
            type: "string",
            description: "Type of institution",
        },
        association: {
            type: "string",
            description: "Institution association type",
        },
        locations: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/geo-location.json" },
            description: "Physical locations",
        },
        postCode: {
            type: "string",
            pattern: "^[0-9]{5}$",
            description: "Primary postal code",
        },
        federalState: {
            type: "string",
            description: "Primary federal state",
        },
        pageSlug: {
            type: "string",
            pattern: "^/(weiterbildungsangebote|en/continuing-education)/",
            description: "URL path",
        },
        pageLanguage: {
            type: "string",
            enum: ["de", "en"],
            description: "Page language code",
        },
        language: {
            type: "string",
            description: "Teaching language",
        },
        offerStart: {
            type: "integer",
            description: "Offer start as Unix timestamp (ms)",
        },
        offerStartFlexible: {
            type: ["boolean", "null"],
            description: "Whether start date is flexible",
        },
        riasecShortCodes: {
            type: "array",
            items: {
                type: "string",
                pattern: "^[RIASEC]{3}$",
            },
            description: "Holland codes for career matching",
        },
        knowledgeAreaGroupRelations: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    group: {
                        type: "object",
                        properties: {
                            id: { type: "string" },
                            name: { type: "string" },
                        },
                        required: ["id", "name"],
                        additionalProperties: false,
                    },
                    area: {
                        type: "object",
                        properties: {
                            id: { type: "string" },
                            name: { type: "string" },
                        },
                        required: ["id", "name"],
                        additionalProperties: false,
                    },
                },
                required: ["group", "area"],
                additionalProperties: false,
            },
            description: "Knowledge area classifications",
        },
        keyTopics: {
            type: "array",
            items: { type: "string" },
            description: "Key subject areas (Schwerpunkte)",
        },
    },
    required: [
        "id",
        "title",
        "type",
        "degree",
        "universityName",
        "universityShortName",
        "universityAddressName",
        "pageSlug",
        "pageLanguage",
        "language",
        "offerStart",
        "offerStartFlexible",
        "riasecShortCodes",
        "postCode",
        "federalState",
        "universityType",
        "association",
        "knowledgeAreaGroupRelations",
        "keyTopics",
    ],
};

var WACostSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/cost.json",
    type: "object",
    title: "Cost",
    description: "Course cost breakdown",
    properties: {
        totalCostNumber: {
            type: "number",
            minimum: 0,
            description: "Total cost in EUR (mandatory for search index)",
        },
        partialCostNumber: {
            type: "number",
            minimum: 0,
            description: "Partial payment amount",
        },
        partialCostCount: {
            type: "integer",
            minimum: 1,
            description: "Number of partial payments",
        },
        partialCostPeriod: {
            type: "string",
            description: "Period for partial payments",
        },
        remarks: {
            type: "string",
            description: "Additional cost information",
        },
        remarksTooltip: {
            type: "string",
            description: "Tooltip text for cost remarks",
        },
        link: {
            $ref: "https://hrk.de/schemas/v1/common/link-bundle.json",
        },
    },
    required: ["totalCostNumber"],
    additionalProperties: false,
};

var WAEventFormatSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/event-format.json",
    type: "object",
    title: "Event Format",
    description: "Teaching format and structure",
    properties: {
        formatNames: {
            type: "array",
            items: { type: "string" },
            minItems: 0,
            description: "Format names",
        },
        timeFlexibility: {
            type: "integer",
            minimum: 0,
            maximum: 100,
            description: "Time flexibility percentage",
        },
        spatialFlexibility: {
            type: "integer",
            minimum: 0,
            maximum: 100,
            description: "Location flexibility percentage",
        },
        sessions: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    format: {
                        type: "string",
                        description: "Session format",
                    },
                    asynchronous: {
                        type: "boolean",
                        description: "Whether asynchronous sessions are offered",
                    },
                    synchronous: {
                        type: "boolean",
                        description: "Whether synchronous sessions are offered",
                    },
                    presence: {
                        type: "boolean",
                        description: "Whether in-person presence is required",
                    },
                },
                required: ["format"],
                additionalProperties: false,
            },
            description: "Session formats",
        },
        remarks: {
            type: "string",
            description: "Additional format information",
        },
        targetGroup: {
            type: "string",
            description: "Target audience description",
        },
        duration: {
            $ref: "https://hrk.de/schemas/v1/common/range-with-unit.json",
        },
        workload: {
            $ref: "https://hrk.de/schemas/v1/common/range-with-unit.json",
        },
    },
    required: ["formatNames", "sessions"],
    additionalProperties: false,
};

var WADatesSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/dates.json",
    type: "object",
    title: "Course Dates",
    description: "Date and deadline information for Weiterbildungsangebot",
    properties: {
        offerPeriod: {
            $ref: "https://hrk.de/schemas/v1/common/period-with-remarks.json",
        },
        registrationPeriod: {
            $ref: "https://hrk.de/schemas/v1/common/period-with-remarks.json",
        },
        secondaryRegistrationPeriods: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/period-with-remarks.json" },
            description: "Additional registration periods",
        },
    },
    required: ["offerPeriod", "registrationPeriod", "secondaryRegistrationPeriods"],
    additionalProperties: false,
};

var SemesterSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/semester.json",
    type: "object",
    title: "Semester",
    description: "Semester information for Studiengang",
    properties: {
        semester: {
            type: "string",
            description: "Semester designation",
        },
        lecturePeriod: {
            $ref: "https://hrk.de/schemas/v1/common/period-with-remarks-and-title.json",
        },
        applicationDates: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/period-with-remarks-and-title.json" },
            description: "Application deadlines",
        },
    },
    required: ["semester", "lecturePeriod"],
    additionalProperties: false,
};
var WAStudyDatesSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/study-dates.json",
    type: "object",
    title: "Study Dates",
    description: "Date and semester information for Studiengang",
    properties: {
        admissionSemester: {
            type: "string",
            description: "Admission semester",
        },
        semesters: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/semester.json" },
            description: "Semester schedule with lecture periods",
        },
    },
    required: ["admissionSemester", "semesters"],
    additionalProperties: false,
};

/**
 * Schema matching Requirements interface from src/WeiterbildungsAngebotExport.ts
 * Zulassungsvoraussetzungen
 */
var WARequirementsSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/requirements.json",
    type: "object",
    title: "Requirements",
    description: "Admission and qualification requirements (Zulassungsvoraussetzungen)",
    properties: {
        admissionRequirementType: {
            type: "string",
            description: "Type of admission requirement",
        },
        admissionRequirementDescription: {
            type: "string",
            description: "Introductory text for admission requirements (einleitender Satz Zulassungsvoraussetzungen)",
        },
        semesterSkipAllowed: {
            type: "boolean",
            description: "Whether skipping to higher semester is allowed (einstufunginhoeheressemestermoeglich)",
        },
        universityQualification: {
            type: "array",
            items: { type: "string" },
            description: "School-based university entrance qualifications (schulische Hochschulzugangsberechtigung)",
        },
        professionalUniversityQualification: {
            type: "array",
            items: { type: "string" },
            description: "Professional university entrance qualifications (berufliche Hochschulzugangsberechtigung)",
        },
        acceptedGraduations: {
            type: "array",
            items: { type: "string" },
            description: "Accepted graduation types",
        },
        similarGraduationsAllowed: {
            type: "boolean",
            description: "Whether similar graduations are accepted (auchfuergleichwertigeabschluesse)",
        },
        experience: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/experience.json" },
            description: "Required practical experience",
        },
        remarks: {
            type: "string",
            description: "Additional remarks on requirements",
        },
    },
    required: ["admissionRequirementType", "admissionRequirementDescription", "experience"],
    additionalProperties: false,
};

/**
 * Schema matching Accreditation interface from src/WeiterbildungsAngebotExport.ts
 * Anerkennung (von Leistungen)
 */
var WAAccreditationSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/accreditation.json",
    type: "object",
    title: "Accreditation",
    description: "Recognition information (Anerkennung von Leistungen)",
    properties: {
        contacts: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/contact.json" },
            description: "Contact persons for accreditation inquiries",
        },
        website: {
            $ref: "https://hrk.de/schemas/v1/common/link-bundle.json",
        },
        skipSemester: {
            type: "boolean",
            description: "Deprecated: moved to Allowance#classificationTestForHigherSemesterPossible (einstufungspruefunginhoeheressemestermoeglich)",
        },
    },
    required: ["contacts", "skipSemester"],
    additionalProperties: false,
};

/**
 * Schema matching Allowance interface from src/WeiterbildungsAngebotExport.ts
 * Anrechnung (von Leistungen)
 */
var WAAllowanceSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/allowance.json",
    type: "object",
    title: "Allowance",
    description: "Credit and recognition information (Anrechnung von Leistungen)",
    properties: {
        allowanceType: {
            type: "string",
            description: "Type of credit allowance",
        },
        contacts: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/contact.json" },
            description: "Contact persons for allowance inquiries",
        },
        individualAllowanceWebsite: {
            $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot-export.json#/$defs/LinkBundle",
        },
        schoolEntranceQualification: {
            type: "array",
            items: { type: "string" },
            description: "Accepted school entrance qualifications",
        },
        experience: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/experience.json" },
            description: "Required practical experience for allowance",
        },
        maximalAccreditedECTS: {
            type: "number",
            description: "Maximum ECTS that can be credited",
        },
        educationalCooperation: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/cooperation.json" },
            description: "Educational cooperation partnerships (Bildungsträger-Kooperation)",
        },
        flatrateCreditingWebsite: {
            $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot-export.json#/$defs/LinkBundle",
        },
        classificationTestForHigherSemesterPossible: {
            type: "boolean",
            description: "Whether classification test for higher semester is possible (einstufungspruefunginhoeheressemestermoeglich)",
        },
    },
    required: ["allowanceType", "contacts", "schoolEntranceQualification", "experience", "educationalCooperation"],
    additionalProperties: false,
};

/**
 * Schema matching ProgramContext interface from src/WeiterbildungsAngebotExport.ts
 */
var WAProgramContextSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/program-context.json",
    type: "object",
    title: "Program Context",
    description: "Program structure and context information",
    properties: {
        name: {
            type: "string",
            description: "Name of the program context type (Name der Programmkontext-Ausprägung)",
        },
        cumulativeOffer: {
            type: "boolean",
            description: "Whether this is a cumulative offer",
        },
        courses: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    id: {
                        type: "number",
                        description: "Course ID",
                    },
                    name: {
                        type: "string",
                        description: "Course name",
                    },
                    slug: {
                        type: "string",
                        description: "Course slug/path",
                    },
                    explanation: {
                        type: "string",
                        description: "Course explanation",
                    },
                },
                required: ["id", "name", "slug"],
                additionalProperties: false,
            },
            description: "Associated courses (can be cumulating OR cumulated entries depending on ProgramContext)",
        },
    },
    required: ["name", "cumulativeOffer"],
    additionalProperties: false,
};

/**
 * Schema matching QualityAssurance interface from src/WeiterbildungsAngebotExport.ts
 */
var WAQualitySchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/quality.json",
    type: "object",
    title: "Quality Assurance",
    description: "Quality assurance measures",
    properties: {
        qualityTypes: {
            type: "array",
            items: { type: "string" },
            description: 'List of quality assurance types (e.g., "hochschulinterne Verfahren", "Programmakkreditiert")',
        },
    },
    required: ["qualityTypes"],
    additionalProperties: false,
};

/**
 * Schema matching Certificate interface from src/WeiterbildungsAngebotExport.ts
 */
var WACertificateSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/certificate.json",
    type: "object",
    title: "Certificate",
    description: "Certificate information",
    properties: {
        name: {
            type: "string",
            description: "Certificate name",
        },
        organisationName: {
            type: "string",
            description: "Issuing organization name",
        },
        verified: {
            type: "boolean",
            description: "Whether the certificate is verified",
        },
    },
    additionalProperties: false,
};

/**
 * Schema matching TestimonialWithLink interface from src/Testimonial.ts
 */
var WATestimonialSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/testimonial.json",
    type: "object",
    title: "Testimonial With Link",
    description: "University testimonial with optional media and links",
    allOf: [{ $ref: "https://hrk.de/schemas/v1/common/testimonial.json" }],
    properties: {
        picture: {
            $ref: "https://hrk.de/schemas/v1/common/media-bundle.json",
        },
        link1: {
            $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot-export.json#/$defs/LinkBundle",
        },
        link2: {
            $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot-export.json#/$defs/LinkBundle",
        },
    },
};

var WACooperatingUniversitySchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot/cooperating-university.json",
    type: "object",
    title: "Cooperating University",
    description: "Cooperating university with localized name and location names",
    properties: {
        universityName: {
            type: "string",
            description: "Localized university name",
        },
        locations: {
            type: "array",
            items: { type: "string" },
            description: "Localized short names of the cooperating university locations",
        },
    },
    required: ["universityName", "locations"],
    additionalProperties: false,
};

var WeiterbildungsAngebotExportSchema = {
    $id: "https://hrk.de/schemas/v1/weiterbildungsangebot-export.json",
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "Weiterbildungsangebot Export",
    description: "Complete export structure for Weiterbildungsangebot and Studiengang entities",
    type: "object",
    $defs: {
        LinkBundle: { $ref: "https://hrk.de/schemas/v1/common/link-bundle.json" },
        GeoLocation: { $ref: "https://hrk.de/schemas/v1/common/geo-location.json" },
        Address: { $ref: "https://hrk.de/schemas/v1/common/address.json" },
        Contact: { $ref: "https://hrk.de/schemas/v1/common/contact.json" },
        Period: { $ref: "https://hrk.de/schemas/v1/common/period.json" },
        PeriodWithRemarks: { $ref: "https://hrk.de/schemas/v1/common/period-with-remarks.json" },
        PeriodWithRemarksAndTitle: { $ref: "https://hrk.de/schemas/v1/common/period-with-remarks-and-title.json" },
        Experience: { $ref: "https://hrk.de/schemas/v1/common/experience.json" },
        Cooperation: { $ref: "https://hrk.de/schemas/v1/common/cooperation.json" },
        RangeWithUnit: { $ref: "https://hrk.de/schemas/v1/common/range-with-unit.json" },
        MediaBundle: { $ref: "https://hrk.de/schemas/v1/common/media-bundle.json" },
        Testimonial: { $ref: "https://hrk.de/schemas/v1/common/testimonial.json" },
        TestimonialWithLink: { $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/testimonial.json" },
    },
    allOf: [
        { $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/core.json" },
        {
            properties: {
                cost: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/cost.json",
                },
                eventFormat: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/event-format.json",
                },
                requirements: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/requirements.json",
                },
                learningResult: {
                    type: "string",
                    description: "Learning outcomes description",
                },
                programContext: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/program-context.json",
                },
                accreditation: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/accreditation.json",
                },
                allowance: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/allowance.json",
                },
                qualityAssurance: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/quality.json",
                },
                certificates: {
                    type: "array",
                    items: { $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/certificate.json" },
                    description: "Available certificates",
                },
                funding: {
                    type: "array",
                    items: { type: "string" },
                    description: "Funding options",
                },
                trainingCenter: {
                    type: "array",
                    items: { $ref: "https://hrk.de/schemas/v1/common/contact.json" },
                    description: "Training center contacts",
                },
                contacts: {
                    type: "array",
                    items: { $ref: "https://hrk.de/schemas/v1/common/contact.json" },
                    description: "Contact persons",
                },
                contactsList4PDF: {
                    type: "array",
                    items: { $ref: "https://hrk.de/schemas/v1/common/contact.json" },
                    description: "Contacts for PDF export",
                },
                courseWebsite: {
                    $ref: "#/$defs/LinkBundle",
                },
                universityTestimonial: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/testimonial.json",
                },
                cooperatingUniversities: {
                    type: "array",
                    items: { $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/cooperating-university.json" },
                    description: "Cooperating universities",
                },
            },
            required: [
                "cost",
                "eventFormat",
                "requirements",
                "learningResult",
                "programContext",
                "qualityAssurance",
                "funding",
                "cooperatingUniversities",
            ],
        },
    ],
    oneOf: [
        {
            properties: {
                dates: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/dates.json",
                },
            },
            required: ["dates"],
        },
        {
            properties: {
                studyDates: {
                    $ref: "https://hrk.de/schemas/v1/weiterbildungsangebot/study-dates.json",
                },
            },
            required: ["studyDates"],
        },
    ],
};

var AppLocaleSchema = {
    $id: "https://hrk.de/schemas/v1/common/app-locale.json",
    title: "AppLocale",
    description: "Application language code",
    type: "string",
    enum: ["de", "en"],
};

var LinkTypeSchema = {
    $id: "https://hrk.de/schemas/v1/common/link-type.json",
    title: "LinkType",
    description: "Link type classification",
    type: "string",
    enum: [
        "internal",
        "college",
        "furtherEducationOffers",
        "external",
        "file",
        "video",
        "knowledgeGroup",
        "knowledgeArea",
        "university",
        "degreeProgramme",
        "doctoralStudy",
        "studyArea",
        "subjectGroup",
    ],
};

var LinkStatusSchema = {
    $id: "https://hrk.de/schemas/v1/common/link-status.json",
    title: "LinkStatus",
    description: "Link availability status",
    type: "string",
    enum: ["available", "unavailable", "redirect", "homepage", "unknown"],
};

var LinkVisualizationSchema = {
    $id: "https://hrk.de/schemas/v1/common/link-visualization.json",
    title: "LinkVisualization",
    description: "Link visualization style",
    type: "string",
    enum: ["link", "button", "buttonFilled"],
};

var MediaBundleTypeSchema = {
    $id: "https://hrk.de/schemas/v1/common/media-bundle-type.json",
    title: "MediaBundleType",
    description: "Media asset type classification",
    type: "string",
    enum: ["pixxio_image", "pixxio_video", "vimeo_video", "youtube_video"],
};

var FrontendIconType;
(function (FrontendIconType) {
    FrontendIconType["ansichtKacheln"] = "1_ANSICHT_ZU_KACHEL";
    FrontendIconType["ansichtTabelle"] = "2_ANSICHT_ZU_TABELLE";
    FrontendIconType["ansprechpartner"] = "3_ANSPRECHPARTNER";
    FrontendIconType["zoomIn"] = "4_ZOOM_IN";
    FrontendIconType["zoomOut"] = "5_ZOOM_OUT";
    FrontendIconType["vollbild"] = "6_VOLLBILD";
    FrontendIconType["nichtVollbild"] = "7_NICHT_VOLLBILD";
    FrontendIconType["download"] = "8_DOWNLOAD";
    FrontendIconType["burgerMenu"] = "9_BURGERMENU";
    FrontendIconType["dropdown"] = "10_DROP_DOWN";
    FrontendIconType["dropUp"] = "11_DROP_UP";
    FrontendIconType["email"] = "12_EMAIL";
    FrontendIconType["info"] = "14_INFO";
    FrontendIconType["favoritInaktiv"] = "15_FAVORIT_INACTIVE";
    FrontendIconType["favoritAktiv"] = "16_FAVORIT_ACTIVE";
    FrontendIconType["hochschule"] = "17_HOCHSCHULE";
    FrontendIconType["hilfe"] = "18_HILFE";
    FrontendIconType["sozialeMedien"] = "19_SOCIALMEDIA";
    FrontendIconType["merken"] = "20_MERKEN";
    FrontendIconType["merkliste"] = "21_MERKLISTE";
    FrontendIconType["schliessen"] = "22_SCHLIESSEN";
    FrontendIconType["entfernen"] = "23_ENTFERNEN";
    FrontendIconType["pfeilLinks"] = "24_PFEIL_LINKS";
    FrontendIconType["pfeilOben"] = "25_PFEIL_OBEN";
    FrontendIconType["pfeilRechts"] = "26_PFEIL_RECHTS";
    FrontendIconType["pfeilUnten"] = "27_PFEIL_UNTEN";
    FrontendIconType["play"] = "28_PLAY";
    FrontendIconType["postAnschrift"] = "29_POSTANSCHRIFT";
    FrontendIconType["teilen"] = "30_TEILEN";
    FrontendIconType["sprache"] = "31_SPRACHE";
    FrontendIconType["startSeite"] = "32_STARTSEITE";
    FrontendIconType["suchen"] = "33_SUCHEN";
    FrontendIconType["telefon"] = "34_TELEFON";
    FrontendIconType["termin"] = "35_TERMIN";
    FrontendIconType["website"] = "36_WEBSITE";
    FrontendIconType["weiterbildung"] = "37_WEITERBILDUNG";
    FrontendIconType["zumAnfang"] = "38_ZUM_ANFANG";
    FrontendIconType["blaetternZurueck"] = "39_BLAETTERN_ZURUECK";
    FrontendIconType["blaetternVor"] = "40_BLAETTERN_VOR";
    FrontendIconType["zuruecksetzen"] = "41_ZURUECKSETZEN";
    FrontendIconType["code"] = "42_CODE";
    FrontendIconType["sortieren"] = "43_SORTIEREN";
    FrontendIconType["merklisteOrdner"] = "44_MERKLISTEN_ORDNER";
    FrontendIconType["vergleichen"] = "45_VERGLEICHEN";
    FrontendIconType["kopieren"] = "46_KOPIEREN";
    FrontendIconType["notizHinzufuegen"] = "47_NOTIZ_HINZUFUEGEN";
    FrontendIconType["notizVorhanden"] = "48_NOTITZ_VORHANDEN";
    FrontendIconType["piktoInstitution"] = "49_PIKTO_INSTITUTION";
    FrontendIconType["piktoInstitution1"] = "50_PIKTO_INSTITUTION1";
    FrontendIconType["piktoWeiterbildung"] = "51_PIKTO_WEITERBILDUNG";
    FrontendIconType["piktoWeiterbildung1"] = "52_PIKTO_WEITERBILDUNG1";
    FrontendIconType["bauwesen"] = "53_BAUWESEN";
    FrontendIconType["digitalisierung"] = "54_DIGITALISIERUNG_INFORMATIK";
    FrontendIconType["gesellschaft"] = "55_GESELLSCHAFT_SOZIALES";
    FrontendIconType["gestaltung"] = "56_GESTALTUNG_KUNST";
    FrontendIconType["gesundheit"] = "57_GESUNDHEIT_PFLEGE";
    FrontendIconType["lehrer"] = "58_LEHRER_WEITERBILDUNG";
    FrontendIconType["mathematik"] = "59_MATHEMATIK_NATURWISS";
    FrontendIconType["softSkills"] = "60_SOFT_SKILLS";
    FrontendIconType["sprachen"] = "61_SPRACHEN";
    FrontendIconType["technik"] = "62_TECHNIK";
    FrontendIconType["verwaltung"] = "62_VERWALTUNG_RECHT";
    FrontendIconType["wirtschaft"] = "63_WIRTSCHAFT_MANAGEMENT";
    FrontendIconType["redaktionelleSeiten"] = "64_REDAKTIONELLE_SEITEN";
})(FrontendIconType || (FrontendIconType = {}));
var FrontEndIcons = Object.keys(FrontendIconType).map(function (k) { return ({
    key: k,
    value: FrontendIconType[k],
}); });

var FrontendIconKeySchema = {
    $id: "https://hrk.de/schemas/v1/common/frontend-icon-key.json",
    title: "FrontendIconKey",
    description: "Frontend icon key (keyof FrontendIconType)",
    type: "string",
    enum: Object.keys(FrontendIconType),
};

var HrkLinkTargets = ["_blank", "_self", "_parent", "_top"];
var HrkAppLocales = ["de", "en"];
var HrkLinkVisualizations = ["textlink", "button"];
var HrkVariants = ["primary", "secondary", "tertiary"];
var HrkColors = {
    "hrk-red": "hrk-red",
    "hrk-petrol": "hrk-petrol",
    "hrk-pastel-blue": "hrk-pastel-blue",
    "hrk-pastel-green": "hrk-pastel-green",
    "hrk-black-gray": "hrk-black-gray",
    "hrk-dark-gray": "hrk-dark-gray",
    "hrk-medium-dark-gray": "hrk-medium-dark-gray",
    "hrk-medium-gray": "hrk-medium-gray",
    "hrk-medium-light-gray": "hrk-medium-light-gray",
    "hrk-light-gray": "hrk-light-gray",
    "hrk-white-gray": "hrk-white-gray",
    "hrk-white": "hrk-white",
    "hrk-error-red": "hrk-error-red",
    "hrk-warning-orange": "hrk-warning-orange",
    "hrk-success-green": "hrk-success-green",
    "hrk-current-color": "hrk-current-color",
};
var HrkBackgroundColors = {
    "hrk-red": HrkColors["hrk-red"],
    "hrk-petrol": HrkColors["hrk-petrol"],
    "hrk-pastel-blue": HrkColors["hrk-pastel-blue"],
    "hrk-pastel-green": HrkColors["hrk-pastel-green"],
    "hrk-white-gray": HrkColors["hrk-white-gray"],
};
var HrkLightBackgroundColors = {
    "hrk-pastel-blue": HrkColors["hrk-pastel-blue"],
    "hrk-pastel-green": HrkColors["hrk-pastel-green"],
    "hrk-white-gray": HrkColors["hrk-white-gray"],
};
var HrkIconNames = [
    "AkademischeRechte",
    "AkademischerTitel",
    "AdministrativVerwaltendeInteressen",
    "Atom",
    "Ausrufezeichen1",
    "Ausrufezeichen2",
    "Award",
    "Balance",
    "Blatt",
    "Book",
    "Bullseye",
    "DokumentSuche",
    "Dokumente",
    "DoubleQuotes",
    "Download",
    "Email",
    "Euro1",
    "Euro2",
    "FallbackIcon",
    "Fragezeichen1",
    "Fragezeichen2",
    "Haken",
    "Handschlag",
    "Helm",
    "Herz",
    "Hochschulen",
    "Hochschulmerkmale",
    "Home",
    "iMac",
    "Information1",
    "Information2",
    "Klemmbrett",
    "Kommentar",
    "Kopie",
    "KreativKulturelleInteressen",
    "Kuchendiagramm",
    "KunstMusik",
    "Labor",
    "Laptop",
    "LaptopGraph",
    "Lesezeichen",
    "Lupe",
    "MapMarker",
    "Medizin",
    "Menschen",
    "Mikroskop",
    "Nachricht",
    "Natur",
    "NotAllowed",
    "Papierkorb",
    "Plakette",
    "Praesentation",
    "Promotionen",
    "Promotionsfach",
    "Promotionswege",
    "Regler",
    "Sanduhr",
    "SchlossGeschlossen",
    "SchlossOffen",
    "SIT",
    "StandortLeitung",
    "Stift",
    "Studiengaenge",
    "Studiengangschulmerkmale",
    "Studienplaetze",
    "Taschenrechner",
    "Tasse",
    "TechnikPraktischeInteressen",
    "Termin",
    "TheoriegeleitetForschendeInteressen",
    "Uhr",
    "Umfrage",
    "User",
    "Verwaltung",
    "Wecker",
    "Weiterbildung",
    "Welt",
    "Wirtschaft",
    "WirtschaftInteresse",
    "Zahnrad",
    "Zertifikate",
    "ZielFahne",
    "Zulassung",
];
var HrkUiIconNames = [
    "Chevron",
    "ChevronDown",
    "ChevronLinks",
    "ChevronRechts",
    "ChevronStopLinks",
    "ChevronStopRechts",
    "ChevronUp",
    "ExternerLink",
    "Print",
    "Bookmark",
    "Share",
    "UI-Globe",
    "UI-Play",
    "UI-Pause",
    "UI-Menu",
    "UI-X",
];
var HrkSocialMediaIconNames = [
    "Facebook",
    "Instagram",
    "YouTube",
    "Xing",
    "LinkedIn",
    "Twitter",
    "TikTok",
];
var HrkPositions = ["top", "bottom", "left", "right", "center"];
var HrkStatusVariants = ["success", "warning", "error", "info"];
var HrkMediaTypes = ["image", "video"];
var HuwLinkTypes = [
    "internal",
    "college",
    "furtherEducationOffers",
    "external",
    "file",
    "knowledgeGroup",
    "knowledgeArea",
];
var HskLinkTypes = [
    "internal",
    "external",
    "file",
    "furtherEducationOffers",
    "university",
    "college",
    "degreeProgramme",
    "doctoralStudy",
    "studyArea",
    "subjectGroup",
];
var HrkLinkTypes = Array.from(new Set(__spreadArray(__spreadArray([], HuwLinkTypes, true), HskLinkTypes, true)));
var HrkModuleTypes = [
    "accordion",
    "anchors",
    "banner-teaser",
    "breadcrumb",
    "divider",
    "download",
    "highlight",
    "menu",
    "multimedia",
    "teaser",
    "testimonial",
];
var HrkHeadingSizes = ["1", "2", "3", "4", "5", "6"];
var HrkHeadingLevels = ["1", "2", "3", "4", "5", "6"];
var HrkDesktopWidth = 1024;
var HrkTabletWidth = 768;
var HrkPhoneWidth = 425;
var HrkSystems = ["hsk", "huw"];

({
    $id: "https://hrk.de/schemas/v1/hrk-types/link-type.json",
    title: "HrkLinkType",
    description: "HSK link type classification",
    type: "string",
    enum: __spreadArray([], HrkLinkTypes, true),
});
({
    $id: "https://hrk.de/schemas/v1/hrk-types/link-target.json",
    title: "HrkLinkTarget",
    description: "Link target behavior",
    type: "string",
    enum: __spreadArray([], HrkLinkTargets, true),
});
({
    $id: "https://hrk.de/schemas/v1/hrk-types/app-locale.json",
    title: "HrkAppLocale",
    description: "Application language code",
    type: "string",
    enum: __spreadArray([], HrkAppLocales, true),
});
({
    $id: "https://hrk.de/schemas/v1/hrk-types/link-visualization.json",
    title: "HrkLinkVisualization",
    description: "Link visualization style",
    type: "string",
    enum: __spreadArray([], HrkLinkVisualizations, true),
});
({
    $id: "https://hrk.de/schemas/v1/hrk-types/variant.json",
    title: "HrkVariant",
    description: "Button variant",
    type: "string",
    enum: __spreadArray([], HrkVariants, true),
});
var HrkColorSchema = {
    $id: "https://hrk.de/schemas/v1/hrk-types/color.json",
    title: "HrkColor",
    description: "Color scheme token",
    type: "string",
    enum: Object.keys(HrkColors),
};
var HrkIconNameSchema = {
    $id: "https://hrk.de/schemas/v1/hrk-types/icon-name.json",
    title: "HrkIconName",
    description: "Icon key for button visualization",
    type: "string",
    enum: __spreadArray([], HrkIconNames, true),
};
({
    $id: "https://hrk.de/schemas/v1/hrk-types/position.json",
    title: "HrkPosition",
    description: "Element position",
    type: "string",
    enum: __spreadArray([], HrkPositions, true),
});

// Lazily initialised so that ajv.compile() does not run at module load time.
// Running compile() at the top level causes ajv's CodeGen class hierarchy to
// be instantiated during webpack module evaluation, which crashes with
// "Cannot read properties of undefined (reading 'reduce')" when the module
// is loaded in more than one webpack context (e.g. via different symlink paths).
var _validate$2;
function getValidator$2() {
    if (!_validate$2) {
        var ajv = new Ajv({
            allErrors: true,
            strict: true,
            coerceTypes: false,
            removeAdditional: false,
        });
        addFormats(ajv);
        ajv.addSchema(AppLocaleSchema);
        ajv.addSchema(LinkTypeSchema);
        ajv.addSchema(LinkStatusSchema);
        ajv.addSchema(LinkVisualizationSchema);
        ajv.addSchema(MediaBundleTypeSchema);
        ajv.addSchema(FrontendIconKeySchema);
        ajv.addSchema(HrkIconNameSchema);
        ajv.addSchema(HrkColorSchema);
        ajv.addSchema(LinkBundleSchema);
        ajv.addSchema(GeoLocationSchema);
        ajv.addSchema(AddressSchema);
        ajv.addSchema(ContactSchema);
        ajv.addSchema(PeriodSchema);
        ajv.addSchema(PeriodWithRemarksSchema);
        ajv.addSchema(PeriodWithRemarksAndTitleSchema);
        ajv.addSchema(ExperienceSchema);
        ajv.addSchema(CooperationSchema);
        ajv.addSchema(RangeWithUnitSchema);
        ajv.addSchema(MediaBundleSchema);
        ajv.addSchema(TestimonialSchema);
        ajv.addSchema(WACoreSchema);
        ajv.addSchema(WACostSchema);
        ajv.addSchema(WAEventFormatSchema);
        ajv.addSchema(WADatesSchema);
        ajv.addSchema(SemesterSchema);
        ajv.addSchema(WAStudyDatesSchema);
        ajv.addSchema(WARequirementsSchema);
        ajv.addSchema(WAAccreditationSchema);
        ajv.addSchema(WAAllowanceSchema);
        ajv.addSchema(WAProgramContextSchema);
        ajv.addSchema(WAQualitySchema);
        ajv.addSchema(WACertificateSchema);
        ajv.addSchema(WATestimonialSchema);
        ajv.addSchema(WACooperatingUniversitySchema);
        _validate$2 = ajv.compile(WeiterbildungsAngebotExportSchema);
    }
    return _validate$2;
}
var validateWeiterbildungsAngebotExport = function (data) { return getValidator$2()(data); };
var ExportSchemaValidationError = /** @class */ (function (_super) {
    __extends(ExportSchemaValidationError, _super);
    function ExportSchemaValidationError(entityType, errors) {
        var _this = this;
        var errorMessages = errors === null || errors === void 0 ? void 0 : errors.map(function (err) { return "".concat(err.instancePath || "/", ": ").concat(err.message); }).join("\n  ");
        _this = _super.call(this, "".concat(entityType, " validation failed:\n  ").concat(errorMessages)) || this;
        _this.entityType = entityType;
        _this.errors = errors;
        _this.name = "ExportSchemaValidationError";
        return _this;
    }
    return ExportSchemaValidationError;
}(Error));
function assertValidWAExport(data) {
    var validate = getValidator$2();
    if (!validate(data)) {
        throw new ExportSchemaValidationError("WeiterbildungsAngebotExport", validate.errors);
    }
}
function isValidWAExport(data) {
    return getValidator$2()(data);
}
function validateWAExport(data) {
    var validate = getValidator$2();
    validate(data);
    return validate.errors || null;
}

var IconSchema = {
    $id: "https://hrk.de/schemas/v1/common/icon.json",
    type: "object",
    title: "Icon",
    description: "Icon with descriptive text",
    properties: {
        description: { type: "string", description: "Icon description / alt text" },
    },
    required: ["description"],
    additionalProperties: false,
};

var ContentSchema = {
    $id: "https://hrk.de/schemas/v1/common/content.json",
    type: "object",
    title: "Content",
    description: "Content block with text, icons, multimedia and social links",
    properties: {
        title: { type: "string" },
        description: { type: "string" },
        icon1: { $ref: "https://hrk.de/schemas/v1/common/icon.json" },
        icon2: { $ref: "https://hrk.de/schemas/v1/common/icon.json" },
        multimedia: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/media-bundle.json" },
        },
        socialNetwork: { $ref: "https://hrk.de/schemas/v1/common/social-network.json" },
        // Important: Different to the existing types, all Content-Types can have a testimonial.
        // see HochschulportraitBlockUebersichtMapper.ts
        testimonial: { $ref: "https://hrk.de/schemas/v1/common/testimonial.json" },
    },
    additionalProperties: false,
};

var GeneralContentSchema = {
    $id: "https://hrk.de/schemas/v1/common/general-content.json",
    title: "General Content",
    description: "Content block with an extended testimonial (including picture and links)",
    allOf: [
        { $ref: "https://hrk.de/schemas/v1/common/content.json" },
        {
            type: "object",
            properties: {
                testimonial: { $ref: "https://hrk.de/schemas/v1/common/testimonial-with-link.json" },
            },
        },
    ],
};

var CoursesContentSchema = {
    $id: "https://hrk.de/schemas/v1/common/courses-content.json",
    title: "Courses Content",
    description: "Content block for study courses section",
    allOf: [{ $ref: "https://hrk.de/schemas/v1/common/content.json" }],
};

var SocialNetworkSchema = {
    $id: "https://hrk.de/schemas/v1/common/social-network.json",
    type: "object",
    title: "Social Network",
    description: "Collection of social media profile links",
    $defs: {
        LinkBundle: { $ref: "https://hrk.de/schemas/v1/common/link-bundle.json" },
    },
    properties: {
        facebookUrl: { $ref: "#/$defs/LinkBundle" },
        twitterUrl: { $ref: "#/$defs/LinkBundle" },
        instagramUrl: { $ref: "#/$defs/LinkBundle" },
        linkedInUrl: { $ref: "#/$defs/LinkBundle" },
        xingUrl: { $ref: "#/$defs/LinkBundle" },
        youtubeUrl: { $ref: "#/$defs/LinkBundle" },
        tiktokUrl: { $ref: "#/$defs/LinkBundle" },
    },
    additionalProperties: false,
};

var TestimonialWithLinkSchema = {
    $id: "https://hrk.de/schemas/v1/common/testimonial-with-link.json",
    title: "Testimonial with Link",
    description: "Testimonial extended with picture and links",
    $defs: {
        LinkBundle: { $ref: "https://hrk.de/schemas/v1/common/link-bundle.json" },
    },
    allOf: [
        { $ref: "https://hrk.de/schemas/v1/common/testimonial.json" },
        {
            type: "object",
            properties: {
                picture: { $ref: "https://hrk.de/schemas/v1/common/media-bundle.json" },
                link1: { $ref: "#/$defs/LinkBundle" },
                link2: { $ref: "#/$defs/LinkBundle" },
            },
        },
    ],
};

var HochschulPortraitExportSchema = {
    $id: "https://hrk.de/schemas/v1/hochschulportrait-export.json",
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "HochschulPortraitExport",
    description: "Schema for the exported Hochschulportrait data structure",
    type: "object",
    $defs: {
        LinkBundle: { $ref: "https://hrk.de/schemas/v1/common/link-bundle.json" },
    },
    properties: {
        id: { type: "string" },
        portraitId: { type: "string" },
        title: { type: "string" },
        logoUrl: { type: "string" },
        type: { type: "string" },
        association: { type: "string" },
        locations: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/geo-location.json" },
        },
        geolocations: {
            type: "array",
            description: "Flat list of [latitude, longitude] coordinate pairs",
            items: {
                type: "array",
                items: { type: "number" },
                minItems: 2,
                maxItems: 2,
            },
        },
        postCodes: {
            type: "array",
            items: { type: "string" },
        },
        pageSlug: { type: "string" },
        shortName: { type: "string" },
        addressName: { type: "string" },
        universityName: { type: "string" },
        universityShortName: { type: "string" },
        universityWebsite: { $ref: "#/$defs/LinkBundle" },
        shortDescription: { type: "string" },
        management: { type: "string" },
        federalState: { type: "string" },
        foundation: { type: "integer" },
        students: { type: "string" },
        phdQualification: { type: "boolean" },
        habilitationQualification: { type: "boolean" },
        headline: { type: "string" },
        subHeadline: { type: "string" },
        general: { $ref: "https://hrk.de/schemas/v1/common/general-content.json" },
        courses: { $ref: "https://hrk.de/schemas/v1/common/courses-content.json" },
        research: { $ref: "https://hrk.de/schemas/v1/common/content.json" },
        international: { $ref: "https://hrk.de/schemas/v1/common/content.json" },
        study: { $ref: "https://hrk.de/schemas/v1/common/content.json" },
        internet: {
            type: "object",
            properties: {
                homePage: { $ref: "#/$defs/LinkBundle" },
                forschungslandKartePage: { $ref: "#/$defs/LinkBundle" },
            },
            additionalProperties: false,
        },
    },
    required: ["id", "type", "association", "pageSlug", "addressName", "management", "federalState", "foundation"],
    additionalProperties: false,
};

// Lazily initialised so that ajv.compile() does not run at module load time.
// Running compile() at the top level causes ajv's CodeGen class hierarchy to
// be instantiated during webpack module evaluation, which crashes with
// "Cannot read properties of undefined (reading 'reduce')" when the module
// is loaded in more than one webpack context (e.g. via different symlink paths).
var _validate$1;
function getValidator$1() {
    if (!_validate$1) {
        var ajv = new Ajv({
            allErrors: true,
            strict: true,
            coerceTypes: false,
            removeAdditional: false,
        });
        addFormats(ajv);
        // Shared schemas (also used by WA)
        ajv.addSchema(AppLocaleSchema);
        ajv.addSchema(LinkTypeSchema);
        ajv.addSchema(LinkStatusSchema);
        ajv.addSchema(LinkVisualizationSchema);
        ajv.addSchema(MediaBundleTypeSchema);
        ajv.addSchema(FrontendIconKeySchema);
        ajv.addSchema(HrkIconNameSchema);
        ajv.addSchema(HrkColorSchema);
        ajv.addSchema(LinkBundleSchema);
        ajv.addSchema(GeoLocationSchema);
        ajv.addSchema(MediaBundleSchema);
        ajv.addSchema(TestimonialSchema);
        // HSP-specific schemas
        ajv.addSchema(IconSchema);
        ajv.addSchema(ContentSchema);
        ajv.addSchema(GeneralContentSchema);
        ajv.addSchema(CoursesContentSchema);
        ajv.addSchema(SocialNetworkSchema);
        ajv.addSchema(TestimonialWithLinkSchema);
        _validate$1 = ajv.compile(HochschulPortraitExportSchema);
    }
    return _validate$1;
}
var validateHochschulPortraitExport = function (data) { return getValidator$1()(data); };
function assertValidHSPExport(data) {
    var validate = getValidator$1();
    if (!validate(data)) {
        throw new ExportSchemaValidationError("HochschulPortraitExport", validate.errors);
    }
}
function isValidHSPExport(data) {
    return getValidator$1()(data);
}
function validateHSPExport(data) {
    var validate = getValidator$1();
    validate(data);
    return validate.errors || null;
}

var FristSchema = {
    $id: "https://hrk.de/schemas/v1/common/frist.json",
    type: "object",
    title: "Frist",
    description: "Application or enrollment deadline",
    properties: {
        bezeichnung: { type: "string", description: "Resolved label based on Zulassungsmodus" },
        zeitraum: { type: "string", description: "String representation of Fristen period" },
        anmerkung: { type: "string", description: "Additional remarks" },
    },
    required: ["bezeichnung"],
    additionalProperties: false,
};

var KontaktstelleSchema = {
    $id: "https://hrk.de/schemas/v1/common/kontaktstelle.json",
    type: "object",
    title: "Kontaktstelle",
    description: "Contact office of a university at a specific location",
    properties: {
        bezeichnung: { type: "string", description: "Organisationseinheit#Bezeichnung" },
        kontaktstellentyp: { type: "string", description: "KontaktstellenTyp#Bezeichnung" },
        hausanschrift: { $ref: "https://hrk.de/schemas/v1/common/hausanschrift.json" },
        postanschrift: { $ref: "https://hrk.de/schemas/v1/common/postanschrift.json" },
        ansprechpersonen: {
            type: "array",
            items: {
                $ref: "https://hrk.de/schemas/v1/common/ansprechperson.json",
            },
        },
        telefon: { type: "string", description: "Phone number" },
        email: { type: "string", description: "Email address" },
        homepage: { type: "string", description: "Website URL" },
    },
    required: ["kontaktstellentyp"],
    additionalProperties: false,
};

var StandortSchema = {
    $id: "https://hrk.de/schemas/v1/common/standort.json",
    type: "object",
    title: "Standort",
    description: "A Studiengang location with coordinates, used for geo search and Bundesland filtering",
    properties: {
        ort: { type: "string", description: "City name" },
        plz: { type: "string", description: "German postal code" },
        bundesland: { type: "string", description: "German federal state (Bundesland)" },
        geoKoordinate: {
            type: "array",
            items: { type: "number" },
            minItems: 2,
            maxItems: 2,
            description: "[latitude, longitude]",
        },
    },
    required: ["ort", "plz", "bundesland", "geoKoordinate"],
    additionalProperties: false,
};

var AdresseSchema = {
    $id: "https://hrk.de/schemas/v1/common/adresse.json",
    type: "object",
    title: "Adresse",
    description: "German postal address (HSK format)",
    properties: {
        StrassePostfach: { type: "string", description: "Strasse or Postfach" },
        PLZ: { type: "string", description: "Postcode" },
        Ort: { type: "string", description: "Localized name of the city/town" },
    },
    required: ["StrassePostfach", "PLZ", "Ort"],
    additionalProperties: false,
};
var HausanschriftSchema = {
    $id: "https://hrk.de/schemas/v1/common/hausanschrift.json",
    type: "object",
    title: "Hausanschrift",
    description: "Primary postal address — Strasse, PLZ and Ort are mandatory",
    properties: {
        adresse: {
            $ref: "https://hrk.de/schemas/v1/common/adresse.json",
        },
    },
    required: ["adresse"],
    additionalProperties: false,
};
var PostanschriftSchema = {
    $id: "https://hrk.de/schemas/v1/common/postanschrift.json",
    type: "object",
    title: "Postanschrift",
    description: "Alternative postal addresses (Postfach / Grossempfaenger)",
    $defs: {
        Adresse: { $ref: "https://hrk.de/schemas/v1/common/adresse.json" },
    },
    properties: {
        postfach: { $ref: "#/$defs/Adresse" },
        grossempfaenger: { $ref: "#/$defs/Adresse" },
    },
    additionalProperties: false,
};

var AnsprechpersonSchema = {
    $id: "https://hrk.de/schemas/v1/common/ansprechperson.json",
    type: "object",
    title: "Ansprechperson",
    description: "Contact person with name, title and contact details",
    properties: {
        bezeichnung: { type: "string", description: "The person's name or function" },
        nameMitTitel: { type: "string", description: "The person's full name including all titles" },
        telefon: { type: "string", description: "Phone number" },
        email: { type: "string", description: "Email address" },
        homepage: { type: "string", description: "Personal or office website URL" },
        zustaendigkeit: { type: "string", description: "Description of the person's responsibilities" },
        rolle: { type: "string", description: "The Person's Rolle at the Kontaktstelle (RollenFunktionsTyp)" },
    },
    required: ["bezeichnung", "nameMitTitel", "email"],
    additionalProperties: false,
};

var SAStudiengangbezeichnungSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/studiengangbezeichnung.json",
    type: "object",
    title: "Studiengangbezeichnung und Logo",
    description: "Module 1: Studiengangbezeichnung und Logo for a Studienangebot",
    properties: {
        title: { type: "string", description: "The official title of this Studienangebot" },
        logoUrl: { $ref: "https://hrk.de/schemas/v1/common/media-bundle.json" },
    },
    additionalProperties: false,
};

var SASteckbriefSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/steckbrief.json",
    type: "object",
    title: "Steckbrief",
    description: "Module 2: Steckbrief for a Studienangebot",
    properties: {
        hochschulname: { type: "string", description: "Hochschule#Name" },
        studienorte: { type: "array", items: { type: "string" }, description: "One entry for each Studienort" },
        kooperierendeDeutscheHochschulen: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    bezeichnung: { type: "string" },
                    link: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
                },
                additionalProperties: false,
            },
        },
        abschluss: { type: "string", description: "Studiengang#Abschluss#Bezeichnung" },
        abschlussgrad: {
            type: "object",
            properties: {
                bezeichnung: { type: "string", description: "Abschlussgrad#Bezeichnung" },
                bezeichnungKurz: { type: "string", description: "Abschlussgrad#BezeichnungKurz" },
            },
            additionalProperties: false,
        },
        zulassungsmodus: { type: "string", description: "Studiengang#Zulassungsmodus#Bezeichnung" },
        frist: {
            allOf: [
                { $ref: "https://hrk.de/schemas/v1/common/frist.json" },
                {
                    type: "object",
                    properties: {
                        zulassungssemesterHinweis: {
                            type: "string",
                            description: "Fallback text for semester mismatch",
                        },
                        hochschulstartLink: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
                    },
                },
            ],
        },
        studienplatzboerse: {
            type: "object",
            description: "Studienplatzbörse-specific data for this Studienangebot",
            properties: {
                fristen: {
                    type: "array",
                    description: "Fristen vom Fristentyp=Studienplatzbörse for Studienanfänger:innen. " +
                        'Usually one entry; for Zulassungsmodus "Keine Zulassungsbeschränkung" ' +
                        "there can be two (Anmeldefrist + Einschreibfrist).",
                    items: {
                        type: "object",
                        properties: {
                            bezeichnung: {
                                type: "string",
                                description: 'Resolved label based on Zulassungsmodus (e.g. "Anmeldefrist", "Frist für Losverfahren")',
                            },
                            zeitraum: {
                                type: "string",
                                description: "Studiengang->Studienplatzbörse#Zeitraum",
                            },
                        },
                        required: ["bezeichnung", "zeitraum"],
                        additionalProperties: false,
                    },
                    minItems: 1,
                    maxItems: 2,
                },
                anmerkung: {
                    type: "string",
                    description: "Studiengang->Studienplatzbörse#Anmerkung (displayed without label)",
                },
            },
            additionalProperties: false,
        },
        studienform: { type: "string", description: "Studiengang#Studienform#Bezeichnung" },
        studienbeginn: { type: "string", description: "Studiengang#Zulassungssemester#Bezeichnung" },
        regelstudienzeit: {
            type: "string",
            description: "Studiengang_Regelstudienzeit#Zeitlänge#Wert und Zeitdauer#Bezeichnung",
        },
        mastertyp: {
            type: "string",
            description: "Studiengang#MasterTyp#Bezeichnung",
        },
        studienfelder: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    bezeichnung: { type: "string", description: "Studiengang#Studienfeld#Bezeichnung" },
                    studienbereich: {
                        type: "object",
                        properties: {
                            bezeichnung: { type: "string", description: "Studiengang#Studienbereich#Bezeichnung" },
                            link: {
                                description: "Optional, to editorial page",
                                allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" }],
                            },
                        },
                        required: ["bezeichnung"],
                        additionalProperties: false,
                    },
                    faechergruppe: {
                        type: "object",
                        properties: {
                            bezeichnung: { type: "string", description: "Studiengang#Fächergruppe#Bezeichnung" },
                            link: {
                                description: "Optional, to editorial page",
                                allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" }],
                            },
                        },
                        required: ["bezeichnung"],
                        additionalProperties: false,
                    },
                },
                required: ["bezeichnung", "studienbereich", "faechergruppe"],
                additionalProperties: false,
            },
        },
    },
    required: [
        "hochschulname",
        "studienorte",
        "abschluss",
        "zulassungsmodus",
        "studienform",
        "studienbeginn",
        "regelstudienzeit",
    ],
    additionalProperties: false,
};

var SASchwerpunkteSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/schwerpunkte.json",
    type: "object",
    title: "Schwerpunkte",
    description: "Module 3: Schwerpunkte for a Studienangebot",
    properties: {
        schwerpunkte: {
            type: "array",
            items: { type: "string" },
            description: "Studiengang#Schwerpunkte",
        },
    },
    additionalProperties: false,
};

var SAWeitereBasisinformationenSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/weitere-basisinformationen.json",
    type: "object",
    title: "Weitere Basisinformationen",
    description: "Module 4: Weitere Basisinformationen for a Studienangebot",
    properties: {
        lehramtsbefaehigung: {
            type: "object",
            properties: {
                ueberschrift: {
                    type: "string",
                    description: 'Varies by Abschlussart (Staatsexamen/Master → "Lehramt für…", Bachelor → "Lehramtsbefähigung über…")',
                },
                lehramtTypen: {
                    type: "array",
                    items: { type: "string" },
                    description: "LehramtTyp#Bezeichnung",
                },
                anmerkung: { type: "string", description: "Lehramtsbefähigung#Anmerkung" },
            },
            required: ["ueberschrift", "lehramtTypen"],
            additionalProperties: false,
        },
        zielgruppen: {
            type: "string",
            description: "(Weiterführender)Studiengang#Zielgruppen — only for weiterführend. " +
                "Rich text (HTML): bold, italic, underline, lists, URLs.",
        },
        unterrichtssprachen: {
            type: "string",
            description: "Studiengang#Hauptunterrichtssprache, Studiengang#Unterrichtssprachen",
        },
        nebenfach: {
            type: "string",
            description: "(Grundständiger)Studiengang#StudiengangEinschränkung",
        },
        anmerkungen: { type: "string", description: "Studiengang#Anmerkungen" },
    },
    additionalProperties: false,
};

var SALinksSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/links.json",
    type: "object",
    title: "Links",
    description: "Module 5: Links for a Studienangebot",
    properties: {
        studiengangWebsite: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
        akkreditierung: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
        cheRanking: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
    },
    additionalProperties: false,
};

var SAZulassungsvoraussetzungenSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/zulassungsvoraussetzungen.json",
    type: "object",
    title: "Zugangs- und Zulassungsvoraussetzungen",
    description: "Module 6: Zugangs- und Zulassungsvoraussetzungen for a Studienangebot",
    properties: {
        zulassungsvoraussetzungstyp: {
            type: "object",
            required: ["bezeichnung", "sg_wf"],
            properties: {
                bezeichnung: {
                    type: "string",
                    description: "Studiengang#Zulassungsvoraussetzungen#Zulassungsvoraussetzungstyp#bezeichnung",
                },
                sg_wf: {
                    type: "boolean",
                    description: "Studiengang#Zulassungsvoraussetzungen#Zulassungsvoraussetzungstyp#sg_wf",
                },
            },
            additionalProperties: false,
        },
        zulassungsmodus: {
            type: "string",
            description: "Studiengang#ZulassungsModuls#Bezeichnung",
        },
        studienbeginn: {
            type: "string",
            description: "Studiengang#Zulassungssemester#Bezeichnung",
        },
        zulassungsvoraussetzungenAnmerkungen: {
            type: "string",
            description: "Studiengang->Zulassungsvoraussetzungen#Anmerkungen",
        },
        zulassungsvoraussetzungenWebsite: {
            description: "Studiengang->Zulassungsvoraussetzungen#Website",
            allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" }],
        },
        sprachkenntnisseEnglisch: {
            type: "object",
            properties: {
                items: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            bezeichnung: {
                                type: "string",
                                description: "Studiengang-> erforderliche Sprachkenntnis#SprachkenntnisTyp#Bezeichnung",
                            },
                            bemerkung: {
                                type: "string",
                                description: "Studiengang -> Erforderliche Sprachkenntnis#Bemerkung",
                            },
                        },
                        required: ["bezeichnung"],
                        additionalProperties: false,
                    },
                },
            },
            required: ["items"],
            additionalProperties: false,
        },
        sprachkenntnisseAndere: {
            type: "object",
            properties: {
                items: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            sprache: { type: "string", description: "Andere Erforderliche Sprachkenntnisse#Sprache" },
                            kurzbezeichnung: {
                                type: "string",
                                description: "Andere Erforderliche Sprachkenntnisse#Kurzbezeichnung",
                            },
                            sprachniveau: {
                                type: "string",
                                description: "Andere Erforderliche Sprachkenntnisse#Sprachniveau",
                            },
                        },
                        required: ["sprache", "kurzbezeichnung"],
                        additionalProperties: false,
                    },
                },
            },
            required: ["items"],
            additionalProperties: false,
        },
        abschlussErstesHochschulstudium: {
            type: "object",
            description: "Only for weiterführend",
            properties: {
                auchFuerGleichwertigeAbschluesse: {
                    type: "boolean",
                    description: "Zulassungsvoraussetzungen#AuchFürGleichwertigeAbschlüsse",
                },
                abschlussarten: {
                    type: "array",
                    items: { type: "string", description: "Abschlussart#Bezeichnung" },
                },
                nichtGelisteterAbschluss: { type: "string" },
                mindestanforderungen: {
                    type: "object",
                    properties: {
                        minNote: {
                            type: "string",
                            description: "(Weiterführender)Studiengang -> Zugangsbedingungengenerell#minNote(1.Abschluss)",
                        },
                        minFachsemester: {
                            type: "string",
                            description: "(Weiterführender)Studiengang ->Zugangsbedingungen generell#minFachsemester(1.Abschluss)",
                        },
                        minRegelstudienzeit: {
                            type: "string",
                            description: "(Weiterführender)Studiengang ->Zugangsbedingungen generell#minRegelstudienzeit(1.Abschluss)",
                        },
                        minECTS: {
                            type: "string",
                            description: "(Weiterführender)Studiengang ->Zugangsbedingungen generell#minECTS(1.Abschluss)",
                        },
                    },
                    additionalProperties: false,
                },
            },
            required: ["auchFuerGleichwertigeAbschluesse", "abschlussarten"],
            additionalProperties: false,
        },
        fachlicheAusrichtungAbschluss: {
            type: "object",
            description: "Only for weiterführend",
            properties: {
                alleFaechergruppen: { type: "boolean" },
                faechergruppen: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            bezeichnung: { type: "string" },
                            link: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
                        },
                        additionalProperties: false,
                    },
                },
                alleStudienbereiche: { type: "boolean" },
                studienbereiche: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            bezeichnung: { type: "string" },
                            link: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
                        },
                        additionalProperties: false,
                    },
                },
            },
            required: ["alleFaechergruppen", "alleStudienbereiche"],
            additionalProperties: false,
        },
        praktischeErfahrungen: {
            type: "array",
            description: "Only for weiterführend",
            items: {
                type: "string",
                description: "Praktische Erfahrung#ErfahrungsTyp, Praktische Erfahrung#Erfahrungsdauer and Praktische Erfahrung#Bereich inserted into a translation",
            },
        },
        weitereZulassungsvoraussetzungen: {
            type: "object",
            description: "Only for weiterführend",
            properties: {
                weitere: {
                    type: "array",
                    items: { type: "string" },
                    description: "Zugangsbedingungen generell#WeitereZulassungsvoraussetzungen#Bezeichnung",
                },
                weitereAndere: {
                    type: "string",
                    description: "Zugangsbedingungen generell#WeitereAndereZulassungsvoraussetzungen",
                },
            },
            required: ["weitere"],
            additionalProperties: false,
        },
    },
    required: ["zulassungsvoraussetzungstyp"],
    additionalProperties: false,
};

var SAFristenSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/fristen.json",
    type: "object",
    title: "Fristen",
    description: "Module 7: Fristen (detail view) for a Studienangebot",
    properties: {
        sindHochschulweiteFristen: {
            type: "boolean",
            description: "Whether hochschulweite Fristen apply as a fallback",
        },
        bezugszeitraeume: {
            type: "array",
            maxItems: 2,
            items: {
                type: "object",
                properties: {
                    bezeichnung: {
                        type: "string",
                        description: "Display label for this Bezugszeitraum",
                    },
                    keineDaten: {
                        type: "boolean",
                        description: "Whether Fristen data is unavailable for this Bezugszeitraum",
                    },
                    vorlesungszeit: {
                        type: "object",
                        properties: {
                            bezeichnung: {
                                type: "string",
                                description: "Label for Vorlesungszeit.",
                            },
                            frist: {
                                $ref: "https://hrk.de/schemas/v1/common/frist.json",
                            },
                        },
                        required: ["bezeichnung"],
                        additionalProperties: false,
                    },
                    fristenTypen: {
                        type: "array",
                        description: "Frist categories within this Bezugszeitraum.",
                        items: {
                            type: "object",
                            properties: {
                                bezeichnung: {
                                    type: "string",
                                    description: "Category label, e.g. 'Deutsche und Bildungsinländer'",
                                },
                                fristen: {
                                    type: "array",
                                    description: "Individual Fristen in this category",
                                    items: { $ref: "https://hrk.de/schemas/v1/common/frist.json" },
                                },
                                alternativerText: {
                                    type: "string",
                                    description: "Fallback text shown when no Fristen are available. May contain HTML (e.g. a link for bundesweite Zulassungsbeschränkung).",
                                },
                            },
                            required: ["bezeichnung", "fristen"],
                            additionalProperties: false,
                        },
                    },
                },
                required: ["bezeichnung", "keineDaten"],
                additionalProperties: false,
            },
        },
    },
    required: ["sindHochschulweiteFristen", "bezugszeitraeume"],
    additionalProperties: false,
};

var SAStudienbeitragSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/studienbeitrag.json",
    type: "object",
    title: "Studienbeitrag",
    description: "Module 8: Studienbeitrag for a Studienangebot",
    properties: {
        gesamtKostenBetrag: { type: "string", description: "Studiengang->Kosten#GesamtKostenBetrag" },
        teilKostenBetrag: { type: "string", description: "Studiengang->Kosten#TeilKostenBetrag" },
        teilKostenDauer: { type: "string", description: "Studiengang->Kosten#TeilKostenDauer" },
        kostenWaehrung: { type: "string", description: "Studiengang#Kosten#KostenWährung" },
        semesterbeitrag: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
        anmerkungen: {
            type: "string",
            description: "Studiengang -> Kosten#Anmerkungen",
        },
        website: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
    },
    required: ["gesamtKostenBetrag"],
    additionalProperties: false,
};

var SAStudierenOhneAbiturSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/studieren-ohne-abitur.json",
    type: "object",
    title: "Studieren ohne Abitur",
    description: "Module 9: Studieren ohne Abitur for a Studienangebot",
    properties: {
        vorhanden: { type: "boolean", description: "Describes whether any data is available" },
        studierenOhneAbiturText: {
            type: "string",
            description: "Introductory text when no data is available (e.g. see vorhanden)",
        },
        studierenOhneAbiturLink: { $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" },
        meisterpruefung: {
            type: "object",
            properties: {
                zugangsbedingungen: {
                    type: "string",
                    description: "Translated introductory text, depends on value Studiengang#Zugangsbedingungen Studieren ohne Abitur#Meisterprüfung",
                },
                zugangsOptionen: {
                    type: "string",
                    description: "Studiengang#Zugangsbedingungen Studieren ohne Abitur#MeisterprüfungZugangsoptionen",
                },
            },
            required: ["zugangsbedingungen"],
            additionalProperties: false,
        },
        berufsausbildung: {
            type: "object",
            properties: {
                mitFachlicherNaehe: {
                    type: "object",
                    properties: {
                        zugangsbedingungen: {
                            type: "string",
                            description: "Translated introductory text, depends on several db values",
                        },
                        bezeichnung: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    bezeichnung: { type: "string", description: "BerufsAusbildungMitFachlicherNähe#Bezeichnung" },
                                },
                                additionalProperties: false,
                            },
                        },
                    },
                    required: ["zugangsbedingungen"],
                    additionalProperties: false,
                },
                ohneFachlicheNaehe: {
                    type: "object",
                    properties: {
                        zugangsbedingungen: {
                            type: "string",
                            description: "Translated introductory text, depends on several db values",
                        },
                        bezeichnung: {
                            type: "array",
                            items: {
                                type: "object",
                                properties: {
                                    bezeichnung: {
                                        type: "string",
                                        description: "BerufsAusbildungOhneFachlicheNähe#Bezeichnung",
                                    },
                                },
                                additionalProperties: false,
                            },
                        },
                    },
                    required: ["zugangsbedingungen"],
                    additionalProperties: false,
                },
            },
            additionalProperties: false,
        },
        anmerkung: {
            type: "string",
            description: "Studiengang#Zugangsbedingungen Studieren ohne Abitur#Anmerkung",
        },
        vorbereitendeKursangebote: {
            type: "string",
            description: "Studiengang#Zugangsbedingungen Studieren ohneAbitur#VorbereitendeKursangeboteAnmerkung",
        },
        website: {
            description: "Studiengang -> Zugansgbedingungen Studieren ohneAbitur#Website#Link#Ziel#URL",
            allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" }],
        },
        kontakt: {
            type: "object",
            properties: {
                standorte: {
                    type: "array",
                    items: {
                        type: "object",
                        properties: {
                            bezeichnung: {
                                type: "string",
                                description: "Studiengang -> Standort#Bezeichnung if available, otherwise Studiengang -> #Standort#BezeichnungKurz",
                            },
                            kontaktstelle: {
                                type: "array",
                                items: { $ref: "https://hrk.de/schemas/v1/common/kontaktstelle.json" },
                            },
                        },
                        required: ["bezeichnung", "kontaktstelle"],
                        additionalProperties: false,
                    },
                },
            },
            required: ["standorte"],
            additionalProperties: false,
        },
    },
    additionalProperties: false,
};

var SAInternationalitaetSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/internationalitaet.json",
    type: "object",
    title: "Internationalität",
    description: "Module 10: Internationalität for a Studienangebot",
    properties: {
        doppelabschluesse: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    staat: {
                        type: "string",
                        description: "Studiengang/internationaler Doppelabschluss -> Partnerhochschule#Staat=BezeichnungKurz",
                    },
                    partnerhochschule: {
                        type: "string",
                        description: "Studiengang/internationaler Doppelabschluss -> Partnerhochschule#Bezeichnung",
                    },
                    abschlussgrad: {
                        type: "string",
                        description: "Studiengang/internationaler Doppelabschluss#InternationalerAbschlussgrad",
                    },
                },
                required: ["staat", "partnerhochschule"],
                additionalProperties: false,
            },
        },
    },
    additionalProperties: false,
};

var SAKontaktSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/kontakt.json",
    type: "object",
    title: "Kontakt",
    description: "Module 11: Kontakt for a Studienangebot",
    properties: {
        standorte: {
            type: "array",
            items: {
                type: "object",
                properties: {
                    bezeichnung: {
                        type: "string",
                        description: "Studiengang -> Standort#Bezeichnung if available, otherwise Studiengang -> #Standort#BezeichnungKurz",
                    },
                    kontaktstelle: {
                        type: "array",
                        items: { $ref: "https://hrk.de/schemas/v1/common/kontaktstelle.json" },
                    },
                },
                required: ["bezeichnung", "kontaktstelle"],
                additionalProperties: false,
            },
        },
    },
    additionalProperties: false,
};

var SAHochschulportraitModulSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/hochschulportrait-modul.json",
    type: "object",
    title: "Hochschulporträt Modul",
    description: "Module 12: Hochschulporträt section within a Studienangebot",
    properties: {
        testimonial: {
            type: "object",
            properties: {
                bild: {
                    description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht] -> Testimonial#Bild",
                    allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/MediaBundle" }],
                },
                zitat: {
                    type: "string",
                    description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht] ->#Testimonial#Zitat",
                },
                zitatgeber: {
                    type: "string",
                    description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht] ->#Testimonial#Zitatgeber",
                },
                rolle: {
                    type: "string",
                    description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht] ->#Testimonial#Rolle",
                },
            },
            additionalProperties: false,
        },
        video: {
            description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht] ->#Testimonial#Bild bzw. Video",
            allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/MediaBundle" }],
        },
        portraitLink: {
            description: "Link zum ausführlichen Portrait",
            allOf: [{ $ref: "https://hrk.de/schemas/v1/studienangebot-export.json#/$defs/LinkBundle" }],
        },
        ueberschrift: {
            type: "string",
            description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht]#Überschrift",
        },
        beschreibung: {
            type: "string",
            description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre [falls nicht vorhanden Übersicht]#Beschreibung",
        },
        iconTeaser: {
            type: "array",
            maxItems: 4,
            items: {
                type: "object",
                properties: {
                    icon: {
                        type: "string",
                        description: "Hochschule#Hochschulporträt#Portrait-Block=Studium und Lehre -> Icon-Teaser 2 und 3 and Hochschule#Hochschulporträt#Portrait-Block=Übersicht -> Icon-Teaser 1 und 2",
                    },
                    text: { type: "string" },
                },
                additionalProperties: false,
            },
        },
    },
    additionalProperties: false,
};

var SAWeiteresInteresseSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/weiteres-interesse.json",
    type: "object",
    title: "Weiteres Interesse",
    description: "Module 13: Das könnte Sie auch interessieren for a Studienangebot",
    properties: {
        items: {
            type: "array",
            maxItems: 3,
            items: {
                type: "object",
                properties: {
                    link: { $ref: "https://hrk.de/schemas/v1/common/link-bundle.json" },
                },
                additionalProperties: false,
            },
        },
    },
    additionalProperties: false,
};

var SAFilterSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot/filter.json",
    type: "object",
    title: "Studienangebot Filter",
    description: "Fields used for search indexing and filtering",
    properties: {
        // Freitextsuche
        angebotsbezeichnung: {
            type: "string",
            description: "Studiengang#Angebotsbezeichnung#Bezeichnung (40% weight in Freitextsuche)",
        },
        schwerpunkte: {
            type: "array",
            items: { type: "string" },
            description: "Studiengang#Schwerpunkte#Bezeichnung (25% weight in Freitextsuche)",
        },
        abschlussArt: {
            type: "string",
            description: "Studiengang#Abschlussart#Bezeichnung (10% weight in Freitextsuche)",
        },
        // Last 25% => Fächergruppe, Studienbereiche, Studienfelder (verschlagwortung from CMS FilterValueConfig)
        // Geführte Suche
        studientyp: {
            type: "string",
            description: "'grundständig' | 'weiterführend'",
        },
        studienform: {
            type: "array",
            items: { type: "string" },
            description: "Studiengang#Studienform#Bezeichnung.",
        },
        faechergruppen: {
            type: "array",
            items: { type: "string" },
            description: "Fächergruppe#Bezeichnung — presence derived bottom-up from studienbereiche",
        },
        studienbereiche: {
            type: "array",
            items: { type: "string" },
            description: "Studienbereich#Bezeichnung — presence derived bottom-up from studienfelder",
        },
        studienfelder: {
            type: "array",
            items: { type: "string" },
            description: "Studienfeld#Bezeichnung",
        },
        // Detail-Suche
        masterTyp: {
            type: "string",
            description: "(Weiterführender)Studiengang#MasterTyp#Bezeichnung",
        },
        zulassungsModus: {
            type: "string",
            description: "Studiengang#Zulassungsmodus#Bezeichnung",
        },
        zulassungsSemester: {
            type: "string",
            description: "Studiengang#Zulassungssemester#Bezeichnung",
        },
        lehramtTypen: {
            type: "array",
            items: { type: "string" },
            description: "LehramtTyp#Bezeichnung",
        },
        hatLehramtsbefaehigung: {
            type: "boolean",
            description: "Studiengang#Lehramtsbefähigung",
        },
        polyvalenteStudienmoeglichkeit: {
            type: "boolean",
            description: "Lehramtsbefähigung#PolyvalenteStudienmöglichkeit",
        },
        hauptunterrichtssprache: {
            type: "string",
            description: "Studiengang#Hauptunterrichtssprache",
        },
        studierenOhneAbiturFilter: {
            type: "array",
            items: { type: "string" },
            description: "Pre-computed array of bezeichnung strings matching the 6 studieren-ohne-abitur filter options. " +
                "Computed in backend-api from the boolean flags on the Studiengang entity.",
        },
        internationalerDoppelabschlussMoeglich: {
            type: "boolean",
            description: "Whether an internationaler Doppelabschluss is available",
        },
        // Hochschule-derived fields (denormalized onto Studienangebot for Typesense)
        hochschulName: {
            type: "string",
            description: "Hochschule#Name",
        },
        hochschulKurzname: {
            type: "string",
            description: "Hochschule#Kurzname",
        },
        hochschulAdressname: {
            type: "string",
            description: "Hochschule#Adressname",
        },
        hochschulTyp: {
            type: "string",
            description: "Hochschule#Hochschultyp#Bezeichnung",
        },
        traegerschaft: {
            type: "string",
            description: "Hochschule#TrägerschaftTyp#Bezeichnung",
        },
        promotionsrecht: {
            type: "boolean",
            description: "Hochschule#Promotionsrecht = Ja",
        },
        promotionsrechtBegrenzt: {
            type: "boolean",
            description: "Hochschule#Promotionsrecht = begrenzt (zeitlich, fachlich begrenztes Promotionsrecht)",
        },
        promotionsrechtVerbund: {
            type: "boolean",
            description: "Hochschule#PromotionsrechtVerbund = Ja",
        },
        // Location / geo
        standorte: {
            type: "array",
            items: { $ref: "https://hrk.de/schemas/v1/common/standort.json" },
        },
        // Studienplatzbörse
        freigabeStudienplatzboerse: {
            type: "boolean",
            description: "Whether the Studienangebot is released for Studienplatzbörse",
        },
    },
    required: [
        "angebotsbezeichnung",
        "abschlussArt",
        "studientyp",
        "studienform",
        "studienfelder",
        "masterTyp",
        "zulassungsModus",
        "zulassungsSemester",
        "lehramtTypen",
        "hatLehramtsbefaehigung",
        "polyvalenteStudienmoeglichkeit",
        "hauptunterrichtssprache",
        "studierenOhneAbiturFilter",
        "internationalerDoppelabschlussMoeglich",
        "hochschulName",
        "hochschulKurzname",
        "hochschulAdressname",
        "hochschulTyp",
        "traegerschaft",
        "promotionsrecht",
        "promotionsrechtBegrenzt",
        "promotionsrechtVerbund",
        "standorte",
        "freigabeStudienplatzboerse",
    ],
    additionalProperties: false,
};

var StudienangebotExportSchema = {
    $id: "https://hrk.de/schemas/v1/studienangebot-export.json",
    $schema: "http://json-schema.org/draft-07/schema#",
    title: "StudienangebotExport",
    description: "Schema for the exported HSK Studienangebot data structure",
    type: "object",
    $defs: {
        LinkBundle: { $ref: "https://hrk.de/schemas/v1/common/link-bundle.json" },
        MediaBundle: { $ref: "https://hrk.de/schemas/v1/common/media-bundle.json" },
        Frist: { $ref: "https://hrk.de/schemas/v1/common/frist.json" },
        Kontaktstelle: { $ref: "https://hrk.de/schemas/v1/common/kontaktstelle.json" },
        Standort: { $ref: "https://hrk.de/schemas/v1/common/standort.json" },
    },
    properties: {
        id: { type: "string" },
        hochschulId: { type: "string" },
        // Modul 1 — Studiengangbezeichnung und Logo
        studiengangbezeichnung: { $ref: "https://hrk.de/schemas/v1/studienangebot/studiengangbezeichnung.json" },
        // Modul 2 — Steckbrief
        steckbrief: { $ref: "https://hrk.de/schemas/v1/studienangebot/steckbrief.json" },
        // Modul 3 — Schwerpunkte
        schwerpunkte: { $ref: "https://hrk.de/schemas/v1/studienangebot/schwerpunkte.json" },
        // Modul 4 — Weitere Basisinformationen
        weitereBasisinformationen: { $ref: "https://hrk.de/schemas/v1/studienangebot/weitere-basisinformationen.json" },
        // Modul 5 — Links
        links: { $ref: "https://hrk.de/schemas/v1/studienangebot/links.json" },
        // Modul 6 — Zugangs- und Zulassungsvoraussetzungen
        zulassungsvoraussetzungen: { $ref: "https://hrk.de/schemas/v1/studienangebot/zulassungsvoraussetzungen.json" },
        // Modul 7 — Fristen
        fristen: { $ref: "https://hrk.de/schemas/v1/studienangebot/fristen.json" },
        // Modul 8 — Studienbeitrag
        studienbeitrag: { $ref: "https://hrk.de/schemas/v1/studienangebot/studienbeitrag.json" },
        // Modul 9 — Studieren ohne Abitur
        studierenOhneAbitur: { $ref: "https://hrk.de/schemas/v1/studienangebot/studieren-ohne-abitur.json" },
        // Modul 10 — Internationalität
        internationalitaet: { $ref: "https://hrk.de/schemas/v1/studienangebot/internationalitaet.json" },
        // Modul 11 — Kontakt
        kontakt: { $ref: "https://hrk.de/schemas/v1/studienangebot/kontakt.json" },
        // Modul 12 — Hochschulporträt
        hochschulportrait: { $ref: "https://hrk.de/schemas/v1/studienangebot/hochschulportrait-modul.json" },
        // Modul 13 — Weiteres Interesse
        weiteresInteresse: { $ref: "https://hrk.de/schemas/v1/studienangebot/weiteres-interesse.json" },
        // Filter object for search indexing
        filter: { $ref: "https://hrk.de/schemas/v1/studienangebot/filter.json" },
    },
    required: ["steckbrief", "filter"],
    additionalProperties: false,
};

// Lazily initialised so that ajv.compile() does not run at module load time.
// Running compile() at the top level causes ajv's CodeGen class hierarchy to
// be instantiated during webpack module evaluation, which crashes with
// "Cannot read properties of undefined (reading 'reduce')" when the module
// is loaded in more than one webpack context (e.g. via different symlink paths).
var _validate;
function getValidator() {
    if (!_validate) {
        var ajv = new Ajv({
            allErrors: true,
            strict: true,
            coerceTypes: false,
            removeAdditional: false,
        });
        addFormats(ajv);
        // Common schemas (same set as WA validator — covers all transitive $refs)
        ajv.addSchema(AppLocaleSchema);
        ajv.addSchema(LinkTypeSchema);
        ajv.addSchema(LinkStatusSchema);
        ajv.addSchema(LinkVisualizationSchema);
        ajv.addSchema(MediaBundleTypeSchema);
        ajv.addSchema(FrontendIconKeySchema);
        ajv.addSchema(HrkIconNameSchema);
        ajv.addSchema(HrkColorSchema);
        ajv.addSchema(LinkBundleSchema);
        ajv.addSchema(MediaBundleSchema);
        ajv.addSchema(FristSchema);
        ajv.addSchema(AdresseSchema);
        ajv.addSchema(HausanschriftSchema);
        ajv.addSchema(PostanschriftSchema);
        ajv.addSchema(AnsprechpersonSchema);
        ajv.addSchema(KontaktstelleSchema);
        ajv.addSchema(StandortSchema);
        // Studiengang-specific sub-schemas
        ajv.addSchema(SAStudiengangbezeichnungSchema);
        ajv.addSchema(SASteckbriefSchema);
        ajv.addSchema(SASchwerpunkteSchema);
        ajv.addSchema(SAWeitereBasisinformationenSchema);
        ajv.addSchema(SALinksSchema);
        ajv.addSchema(SAZulassungsvoraussetzungenSchema);
        ajv.addSchema(SAFristenSchema);
        ajv.addSchema(SAStudienbeitragSchema);
        ajv.addSchema(SAStudierenOhneAbiturSchema);
        ajv.addSchema(SAInternationalitaetSchema);
        ajv.addSchema(SAKontaktSchema);
        ajv.addSchema(SAHochschulportraitModulSchema);
        ajv.addSchema(SAWeiteresInteresseSchema);
        ajv.addSchema(SAFilterSchema);
        _validate = ajv.compile(StudienangebotExportSchema);
    }
    return _validate;
}
function validateStudiengangExport(data) {
    var validate = getValidator();
    validate(data);
    return validate.errors || null;
}
function assertValidStudiengangExport(data) {
    var validate = getValidator();
    if (!validate(data)) {
        throw new ExportSchemaValidationError("StudiengangExport", validate.errors);
    }
}
function isValidStudiengangExport(data) {
    return getValidator()(data);
}

var BaseFilterValueSchema = {
    $id: "https://hrk.de/schemas/v1/filter-values/filter-value.json",
    type: "object",
    title: "Base Filter Value",
    description: "Base structure for a single filter value entry",
    properties: {
        id: { type: "integer", description: "Unique filter value identifier" },
        bezeichnung: { type: "string", description: "Display label for the filter value" },
    },
    required: ["id", "bezeichnung"],
};
var BaseFilterValueWithSortingOrderSchema = {
    $id: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json",
    title: "Base Filter Value with Sorting Order",
    description: "Extends the base filter value with a required sortingorder field",
    allOf: [
        { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
        {
            type: "object",
            properties: {
                sortingorder: { type: "integer", description: "Explicit sort position" },
            },
            required: ["sortingorder"],
        },
    ],
};

var AssociationSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/association.json",
    title: "association",
    description: "University association / Trägerschaft",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
// Filter value types for HSK.
// We transmit all filter values regardless of whether they are currently used in the data.
// The frontend filters the display to only show values that match actual data.
// However, we need all values transmitted because:
// 1. Additional metadata (sortingorder, verschlagwortung, gruppierung, studienbereichId, faechergruppeId)
// 2. The ID is required for language switching - it allows finding the equivalent filter value in the other language
// See: https://www.exxcellent.de/confluence/spaces/HOW/pages/360120340/2026-03-18+Weekly+Portale
// Studienangebot
// Geführte Suche
/**
 * Unlike other filters, this is not based on a Katalogtabelle but derived from business logic based on specific data constellations.
 * Entities like Studienangebot will have a field with this value.
 * The id for these values will be defined in the backend during creation.
 *
 * Options (de): "grundlegend" | "weiterführend"
 *
 * Note: The bezeichnung values are stored in translations to allow changes without redeployment.
 * We still transmit the options here to enable proper frontend selection and filter logic.
 */
var StudientypSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/studientyp.json",
    title: "studientyp",
    description: "Study type classification (grundlegend / weiterführend)",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
    minItems: 2,
    maxItems: 2,
};
var MasterTypSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/master-typ.json",
    title: "masterTyp",
    description: "Master degree type classification",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
var ZulassungsModusSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/zulassungs-modus.json",
    title: "zulassungsModus",
    description: "Admission mode (with/without NC)",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
/**
 * Three-tier subject hierarchy for Studienangebot: faechergruppe → studienbereich → studienfeld.
 *
 * Each tier carries its parent's ID (studienfeld.studienbereichId, studienbereich.faechergruppeId)
 * so the hierarchy can be reconstructed on the frontend from a flat list.
 *
 * Presence filtering must be processed bottom-up: first determine which studienfelder appear
 * in actual data, then derive which studienbereiche survive (those referenced by surviving
 * studienfelder), then which faechergruppen survive. A parent is only stored if at least one
 * of its children survived.
 */
var StudienfeldSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/studienfeld.json",
    title: "studienfeld",
    description: "Study field (lowest tier of the three-tier subject hierarchy)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    studienbereichId: {
                        type: "integer",
                        description: "studienbereichId is used to build the correct hierarchy of this three-tier-filter in the frontend",
                    },
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
                required: ['studienbereichId'],
            },
        ],
    },
};
var StudienbereichSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/studienbereich.json",
    title: "studienbereich",
    description: "Study area (middle tier of the three-tier subject hierarchy)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    faechergruppeId: {
                        type: "integer",
                        description: "faechergruppeId is used to build the correct hierarchy of this three-tier-filter in the frontend",
                    },
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
                required: ['faechergruppeId'],
            },
        ],
    },
};
var FaechergruppeSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/faechergruppe.json",
    title: "faechergruppe",
    description: "Subject group (top tier of the three-tier subject hierarchy)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
            },
        ],
    },
};
/**
 * Gruppierung is optional and only used to group all Studienformen that belong to Duales Studium
 */
var StudienformSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/studienform.json",
    title: "studienform",
    description: "Study format (e.g. Vollzeit, Teilzeit, Duales Studium)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    gruppierung: { type: "string", description: "Grouping label (e.g. Duales Studium)" },
                },
            },
        ],
    },
};
var LehramtTypSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/lehramt-typ.json",
    title: "lehramtTyp",
    description: "Teaching degree type classification",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
            {
                type: "object",
                properties: {
                    gruppierung: { type: "string", description: "Grouping label" },
                },
            },
        ],
    },
};
/**
 * The 16 German federal states. CMS-managed static list.
 * Sorted alphabetically (no sortingorder). Previously queried at runtime directly from Typesense
 * in the old HUW system — now a first-class CMS-sourced filter value like all others.
 */
var BundeslandSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/bundesland.json",
    title: "bundesland",
    description: "German federal states (alphabetically sorted)",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
};
// Detail-Suche
var AbschlussArtSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/abschluss-art.json",
    title: "abschlussArt",
    description: "Degree type classification",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
var ZulassungsSemesterSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/zulassungs-semester.json",
    title: "zulassungsSemester",
    description: "Admission semester options",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
/**
 * Unlike other filters, this is not based on a Katalogtabelle but derived from business logic based on specific data constellations.
 * Entities like Studienangebot will have a field with this value.
 * The id for these values will be defined in the backend during creation.
 *
 * Options (de):
 * "Meisterprüfung oder gleichwertige berufliche Aufstiegsfortbildung" | "Berufsausbildung"
 * "Berufsausbildung mit fachlicher Nähe zum Studienfach ohne Berufserfahrung" | "Berufsausbildung mit fachlicher Nähe zum Studienfach und Berufserfahrung"
 * "Berufsausbildung ohne fachliche Nähe zum Studienfach ohne Berufserfahrung" | "Berufsausbildung ohne fachliche Nähe zum Studienfach und Berufserfahrung"
 *
 * Note: The bezeichnung values are stored in translations to allow changes without redeployment.
 * We still transmit the options here to enable proper frontend selection and filter logic.
 */
var StudierenOhneAbiturSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/studieren-ohne-abitur.json",
    title: "studierenOhneAbitur",
    description: "Study-without-Abitur admission options",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
    minItems: 6,
    maxItems: 6,
};
/**
 * Language filter for HSK. Sorted alphabetically (no sortingorder).
 * Distinct from the HUW `LanguageSchema` above, which uses sortingorder.
 * Both represent the same concept but serve different portals with different ordering conventions.
 */
var SpracheSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/sprache.json",
    title: "sprache",
    description: "Teaching language filter (HSK, alphabetically sorted)",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
};
/**
 * University type filter. Only the basic university types (Universität, Fachhochschule, …),
 * matched via the `typ` field on the Hochschule entity.
 *
 * The three Promotionsrecht filter entries are NOT part of this CMS config — they are
 * synthesized during hsk-gatsby indexing from the `hochschultypPromotion` translations and
 * matched via the `promotionsrecht.*` booleans on the entity (see `schemas/hochschule/index.ts`
 * and `schemas/studienangebot/sa-filter.schema.ts`).
 */
var HochschulTypSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/hochschul-typ.json",
    title: "hochschulTyp",
    description: "University type filter",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
/**
 * HSK name for the same concept as `AssociationSchema` (HUW: "association" = "Trägerschaft").
 * Aliased here because the underlying structure is identical. If these ever need to diverge,
 * replace this alias with an independent schema definition.
 */
var TraegerschaftsTypSchema = AssociationSchema;
// Promotionsvarianten
// Detailsuche
var PromotionsTypSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/promotions-typ.json",
    title: "promotionsTyp",
    description: "Doctoral study type classification",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value-with-sorting-order.json" },
};
/**
 * Three-tier subject hierarchy for Promotionsvarianten: wissenschaftsbereich → fachgebiet → sachgebiet.
 *
 * Each tier carries its parent's ID (sachgebiet.fachgebietId, fachgebiet.wissenschaftsbereichId)
 * so the hierarchy can be reconstructed on the frontend from a flat list.
 *
 * Same bottom-up presence filtering applies as for the Studienangebot hierarchy above.
 */
var SachgebietSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/sachgebiet.json",
    title: "sachgebiet",
    description: "Subject area (lowest tier of the doctoral three-tier hierarchy)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    fachgebietId: {
                        type: "integer",
                        description: "fachgebietId is used to build the correct hierarchy of this three-tier-filter in the frontend",
                    },
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
                required: ['fachgebietId'],
            },
        ],
    },
};
var FachgebietSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/fachgebiet.json",
    title: "fachgebiet",
    description: "Discipline (middle tier of the doctoral three-tier hierarchy)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    wissenschaftsbereichId: {
                        type: "integer",
                        description: "wissenschaftsbereichId is used to build the correct hierarchy of this three-tier-filter in the frontend",
                    },
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
                required: ['wissenschaftsbereichId'],
            },
        ],
    },
};
var WissenschaftsbereichSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/wissenschaftsbereich.json",
    title: "wissenschaftsbereich",
    description: "Scientific domain (top tier of the doctoral three-tier hierarchy)",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
            },
        ],
    },
};
var DoktorGradSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/doktor-grad.json",
    title: "doktorGrad",
    description: "Doctoral degree type",
    type: "array",
    items: {
        allOf: [
            { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
            {
                type: "object",
                properties: {
                    gruppierung: { type: "string", description: "Grouping label" },
                    verschlagwortung: { type: "array", items: { type: "string" } },
                },
            },
        ],
    },
};
var ZulassungPromotionSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/zulassung-promotion.json",
    title: "zulassungPromotion",
    description: "Doctoral admission requirements",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
    minItems: 2,
    maxItems: 2,
};
var DissertationSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    $id: "https://hrk.de/schemas/v1/filter-values/dissertation.json",
    title: "dissertation",
    description: "Dissertation format options",
    type: "array",
    items: { $ref: "https://hrk.de/schemas/v1/filter-values/filter-value.json" },
    minItems: 4,
    maxItems: 4,
};

// Lazily initialised so that ajv.compile() does not run at module load time.
// Running compile() at the top level causes ajv's CodeGen class hierarchy to
// be instantiated during webpack module evaluation, which crashes with
// "Cannot read properties of undefined (reading 'reduce')" when the module
// is loaded in more than one webpack context (e.g. via different symlink paths).
var _validators;
function getValidators() {
    if (!_validators) {
        var ajv = new Ajv({
            allErrors: true,
            strict: true,
            coerceTypes: false,
            removeAdditional: false,
        });
        addFormats(ajv);
        ajv.addSchema(BaseFilterValueSchema);
        ajv.addSchema(BaseFilterValueWithSortingOrderSchema);
        _validators = {
            validateStudientyp: ajv.compile(StudientypSchema),
            validateMasterTyp: ajv.compile(MasterTypSchema),
            validateZulassungsModus: ajv.compile(ZulassungsModusSchema),
            validateStudienfeld: ajv.compile(StudienfeldSchema),
            validateStudienbereich: ajv.compile(StudienbereichSchema),
            validateFaechergruppe: ajv.compile(FaechergruppeSchema),
            validateStudienform: ajv.compile(StudienformSchema),
            validateLehramtTyp: ajv.compile(LehramtTypSchema),
            validateBundesland: ajv.compile(BundeslandSchema),
            validateAbschlussArt: ajv.compile(AbschlussArtSchema),
            validateZulassungsSemester: ajv.compile(ZulassungsSemesterSchema),
            validateStudierenOhneAbitur: ajv.compile(StudierenOhneAbiturSchema),
            validateSprache: ajv.compile(SpracheSchema),
            validateHochschulTyp: ajv.compile(HochschulTypSchema),
            validateTraegerschaftsTyp: ajv.compile(TraegerschaftsTypSchema),
            validatePromotionsTyp: ajv.compile(PromotionsTypSchema),
            validateSachgebiet: ajv.compile(SachgebietSchema),
            validateFachgebiet: ajv.compile(FachgebietSchema),
            validateWissenschaftsbereich: ajv.compile(WissenschaftsbereichSchema),
            validateDoktorGrad: ajv.compile(DoktorGradSchema),
            validateZulassungPromotion: ajv.compile(ZulassungPromotionSchema),
            validateDissertation: ajv.compile(DissertationSchema),
        };
    }
    return _validators;
}
var validateStudientyp = function (data) { return getValidators().validateStudientyp(data); };
var validateMasterTyp = function (data) { return getValidators().validateMasterTyp(data); };
var validateZulassungsModus = function (data) { return getValidators().validateZulassungsModus(data); };
var validateStudienfeld = function (data) { return getValidators().validateStudienfeld(data); };
var validateStudienbereich = function (data) { return getValidators().validateStudienbereich(data); };
var validateFaechergruppe = function (data) { return getValidators().validateFaechergruppe(data); };
var validateStudienform = function (data) { return getValidators().validateStudienform(data); };
var validateLehramtTyp = function (data) { return getValidators().validateLehramtTyp(data); };
var validateBundesland = function (data) { return getValidators().validateBundesland(data); };
var validateAbschlussArt = function (data) { return getValidators().validateAbschlussArt(data); };
var validateZulassungsSemester = function (data) { return getValidators().validateZulassungsSemester(data); };
var validateStudierenOhneAbitur = function (data) { return getValidators().validateStudierenOhneAbitur(data); };
var validateSprache = function (data) { return getValidators().validateSprache(data); };
var validateHochschulTyp = function (data) { return getValidators().validateHochschulTyp(data); };
var validateTraegerschaftsTyp = function (data) { return getValidators().validateTraegerschaftsTyp(data); };
var validatePromotionsTyp = function (data) { return getValidators().validatePromotionsTyp(data); };
var validateSachgebiet = function (data) { return getValidators().validateSachgebiet(data); };
var validateFachgebiet = function (data) { return getValidators().validateFachgebiet(data); };
var validateWissenschaftsbereich = function (data) { return getValidators().validateWissenschaftsbereich(data); };
var validateDoktorGrad = function (data) { return getValidators().validateDoktorGrad(data); };
var validateZulassungPromotion = function (data) { return getValidators().validateZulassungPromotion(data); };
var validateDissertation = function (data) { return getValidators().validateDissertation(data); };
var assertValidStudientyp = function (data) {
    var v = getValidators().validateStudientyp;
    if (!v(data))
        throw new ExportSchemaValidationError("Studientyp", v.errors);
};
var assertValidMasterTyp = function (data) {
    var v = getValidators().validateMasterTyp;
    if (!v(data))
        throw new ExportSchemaValidationError("MasterTyp", v.errors);
};
var assertValidZulassungsModus = function (data) {
    var v = getValidators().validateZulassungsModus;
    if (!v(data))
        throw new ExportSchemaValidationError("ZulassungsModus", v.errors);
};
var assertValidStudienfeld = function (data) {
    var v = getValidators().validateStudienfeld;
    if (!v(data))
        throw new ExportSchemaValidationError("Studienfeld", v.errors);
};
var assertValidStudienbereich = function (data) {
    var v = getValidators().validateStudienbereich;
    if (!v(data))
        throw new ExportSchemaValidationError("Studienbereich", v.errors);
};
var assertValidFaechergruppe = function (data) {
    var v = getValidators().validateFaechergruppe;
    if (!v(data))
        throw new ExportSchemaValidationError("Faechergruppe", v.errors);
};
var assertValidStudienform = function (data) {
    var v = getValidators().validateStudienform;
    if (!v(data))
        throw new ExportSchemaValidationError("Studienform", v.errors);
};
var assertValidLehramtTyp = function (data) {
    var v = getValidators().validateLehramtTyp;
    if (!v(data))
        throw new ExportSchemaValidationError("LehramtTyp", v.errors);
};
var assertValidBundesland = function (data) {
    var v = getValidators().validateBundesland;
    if (!v(data))
        throw new ExportSchemaValidationError("Bundesland", v.errors);
};
var assertValidAbschlussArt = function (data) {
    var v = getValidators().validateAbschlussArt;
    if (!v(data))
        throw new ExportSchemaValidationError("AbschlussArt", v.errors);
};
var assertValidZulassungsSemester = function (data) {
    var v = getValidators().validateZulassungsSemester;
    if (!v(data))
        throw new ExportSchemaValidationError("ZulassungsSemester", v.errors);
};
var assertValidStudierenOhneAbitur = function (data) {
    var v = getValidators().validateStudierenOhneAbitur;
    if (!v(data))
        throw new ExportSchemaValidationError("StudierenOhneAbitur", v.errors);
};
var assertValidSprache = function (data) {
    var v = getValidators().validateSprache;
    if (!v(data))
        throw new ExportSchemaValidationError("Sprache", v.errors);
};
var assertValidHochschulTyp = function (data) {
    var v = getValidators().validateHochschulTyp;
    if (!v(data))
        throw new ExportSchemaValidationError("HochschulTyp", v.errors);
};
var assertValidTraegerschaftsTyp = function (data) {
    var v = getValidators().validateTraegerschaftsTyp;
    if (!v(data))
        throw new ExportSchemaValidationError("TraegerschaftsTyp", v.errors);
};
var assertValidPromotionsTyp = function (data) {
    var v = getValidators().validatePromotionsTyp;
    if (!v(data))
        throw new ExportSchemaValidationError("PromotionsTyp", v.errors);
};
var assertValidSachgebiet = function (data) {
    var v = getValidators().validateSachgebiet;
    if (!v(data))
        throw new ExportSchemaValidationError("Sachgebiet", v.errors);
};
var assertValidFachgebiet = function (data) {
    var v = getValidators().validateFachgebiet;
    if (!v(data))
        throw new ExportSchemaValidationError("Fachgebiet", v.errors);
};
var assertValidWissenschaftsbereich = function (data) {
    var v = getValidators().validateWissenschaftsbereich;
    if (!v(data))
        throw new ExportSchemaValidationError("Wissenschaftsbereich", v.errors);
};
var assertValidDoktorGrad = function (data) {
    var v = getValidators().validateDoktorGrad;
    if (!v(data))
        throw new ExportSchemaValidationError("DoktorGrad", v.errors);
};
var assertValidZulassungPromotion = function (data) {
    var v = getValidators().validateZulassungPromotion;
    if (!v(data))
        throw new ExportSchemaValidationError("ZulassungPromotion", v.errors);
};
var assertValidDissertation = function (data) {
    var v = getValidators().validateDissertation;
    if (!v(data))
        throw new ExportSchemaValidationError("Dissertation", v.errors);
};
var isValidStudientyp = function (data) { return getValidators().validateStudientyp(data); };
var isValidMasterTyp = function (data) { return getValidators().validateMasterTyp(data); };
var isValidZulassungsModus = function (data) {
    return getValidators().validateZulassungsModus(data);
};
var isValidStudienfeld = function (data) { return getValidators().validateStudienfeld(data); };
var isValidStudienbereich = function (data) {
    return getValidators().validateStudienbereich(data);
};
var isValidFaechergruppe = function (data) { return getValidators().validateFaechergruppe(data); };
var isValidStudienform = function (data) { return getValidators().validateStudienform(data); };
var isValidLehramtTyp = function (data) { return getValidators().validateLehramtTyp(data); };
var isValidBundesland = function (data) { return getValidators().validateBundesland(data); };
var isValidAbschlussArt = function (data) { return getValidators().validateAbschlussArt(data); };
var isValidZulassungsSemester = function (data) {
    return getValidators().validateZulassungsSemester(data);
};
var isValidStudierenOhneAbitur = function (data) {
    return getValidators().validateStudierenOhneAbitur(data);
};
var isValidSprache = function (data) { return getValidators().validateSprache(data); };
var isValidHochschulTyp = function (data) { return getValidators().validateHochschulTyp(data); };
var isValidTraegerschaftsTyp = function (data) {
    return getValidators().validateTraegerschaftsTyp(data);
};
var isValidPromotionsTyp = function (data) { return getValidators().validatePromotionsTyp(data); };
var isValidSachgebiet = function (data) { return getValidators().validateSachgebiet(data); };
var isValidFachgebiet = function (data) { return getValidators().validateFachgebiet(data); };
var isValidWissenschaftsbereich = function (data) {
    return getValidators().validateWissenschaftsbereich(data);
};
var isValidDoktorGrad = function (data) { return getValidators().validateDoktorGrad(data); };
var isValidZulassungPromotion = function (data) {
    return getValidators().validateZulassungPromotion(data);
};
var isValidDissertation = function (data) { return getValidators().validateDissertation(data); };
var getStudientypErrors = function (data) {
    var v = getValidators().validateStudientyp;
    v(data);
    return v.errors || null;
};
var getMasterTypErrors = function (data) {
    var v = getValidators().validateMasterTyp;
    v(data);
    return v.errors || null;
};
var getZulassungsModusErrors = function (data) {
    var v = getValidators().validateZulassungsModus;
    v(data);
    return v.errors || null;
};
var getStudienfeldErrors = function (data) {
    var v = getValidators().validateStudienfeld;
    v(data);
    return v.errors || null;
};
var getStudienbereichErrors = function (data) {
    var v = getValidators().validateStudienbereich;
    v(data);
    return v.errors || null;
};
var getFaechergruppeErrors = function (data) {
    var v = getValidators().validateFaechergruppe;
    v(data);
    return v.errors || null;
};
var getStudienformErrors = function (data) {
    var v = getValidators().validateStudienform;
    v(data);
    return v.errors || null;
};
var getLehramtTypErrors = function (data) {
    var v = getValidators().validateLehramtTyp;
    v(data);
    return v.errors || null;
};
var getBundeslandErrors = function (data) {
    var v = getValidators().validateBundesland;
    v(data);
    return v.errors || null;
};
var getAbschlussArtErrors = function (data) {
    var v = getValidators().validateAbschlussArt;
    v(data);
    return v.errors || null;
};
var getZulassungsSemesterErrors = function (data) {
    var v = getValidators().validateZulassungsSemester;
    v(data);
    return v.errors || null;
};
var getStudierenOhneAbiturErrors = function (data) {
    var v = getValidators().validateStudierenOhneAbitur;
    v(data);
    return v.errors || null;
};
var getSpracheErrors = function (data) {
    var v = getValidators().validateSprache;
    v(data);
    return v.errors || null;
};
var getHochschulTypErrors = function (data) {
    var v = getValidators().validateHochschulTyp;
    v(data);
    return v.errors || null;
};
var getTraegerschaftsTypErrors = function (data) {
    var v = getValidators().validateTraegerschaftsTyp;
    v(data);
    return v.errors || null;
};
var getPromotionsTypErrors = function (data) {
    var v = getValidators().validatePromotionsTyp;
    v(data);
    return v.errors || null;
};
var getSachgebietErrors = function (data) {
    var v = getValidators().validateSachgebiet;
    v(data);
    return v.errors || null;
};
var getFachgebietErrors = function (data) {
    var v = getValidators().validateFachgebiet;
    v(data);
    return v.errors || null;
};
var getWissenschaftsbereichErrors = function (data) {
    var v = getValidators().validateWissenschaftsbereich;
    v(data);
    return v.errors || null;
};
var getDoktorGradErrors = function (data) {
    var v = getValidators().validateDoktorGrad;
    v(data);
    return v.errors || null;
};
var getZulassungPromotionErrors = function (data) {
    var v = getValidators().validateZulassungPromotion;
    v(data);
    return v.errors || null;
};
var getDissertationErrors = function (data) {
    var v = getValidators().validateDissertation;
    v(data);
    return v.errors || null;
};

var ComponentType;
(function (ComponentType) {
    ComponentType["TESTIMONAL_2_BUTTONS"] = "testimonial2buttonscomponent";
    ComponentType["GRID_TEASER"] = "gridteasercomponent";
    ComponentType["LANDSCAPE_TEASER"] = "landscapeteasercomponent";
    ComponentType["LINK"] = "link";
    ComponentType["ACCORDION"] = "accordioncomponent";
    ComponentType["ATTRACT"] = "Attract";
    ComponentType["DOWNLOAD"] = "Download";
    ComponentType["EXAMPLE"] = "example";
    ComponentType["LIST"] = "listcomponent";
    ComponentType["SEARCHINPUT"] = "searchcomponent";
    ComponentType["TESTIMONIAL"] = "testimonialcomponent";
    ComponentType["WIT_STARTER_CHOICE"] = "witstarterchoicecomponent";
    ComponentType["WIT_STARTER_PLAIN"] = "witstartercomponent";
    ComponentType["WIT_STARTER_SLIDER"] = "witstarterslidercomponent";
    ComponentType["PORTRAIT_TEASER"] = "portraitteasercomponent";
    ComponentType["BUTTON_SLIDER"] = "buttonslidercomponent";
    ComponentType["DYNAMIC_SLIDER_HSP"] = "dynamicsliderhsp";
    ComponentType["DYNAMIC_SLIDER_WA"] = "dynamicsliderwa";
    ComponentType["LINKSLIDER"] = "linkslidercomponent";
    ComponentType["MEDIASLIDER"] = "mediaslider";
    ComponentType["TEASER_3_COL"] = "teaser3colcomponent";
    ComponentType["TEXT_TESTIMONIAL"] = "texttestimonialcomponent";
    ComponentType["RICH_TEXT_BACKGROUND_COLOR"] = "richtextbackgroundcolorcomponent";
    ComponentType["RICH_TEXT"] = "richtextcomponent";
})(ComponentType || (ComponentType = {}));
var ComponentTypes = Object.keys(ComponentType).map(function (k) { return ({
    key: k,
    value: ComponentType[k],
}); });

/**
 * All valid filter_name values frontend-api's HSK filter-value search knows about.
 * Producers (hsk-gatsby's `filter_values_hsk` derivation/write pipeline) and consumers
 * (frontend-api's HskFilterValues GraphQL query) share this enum so a typo or a filter
 * frontend-api doesn't support can never reach the DB or the API as a bare string.
 *
 * Not every `filter_name` the CMS/derivation pipeline could theoretically produce has to
 * be listed here — only the ones frontend-api is meant to search.
 *
 * Prefixes encode the entity type scope:
 *   sg_ = Studiengänge (Studienangebot)
 *   hs_ = Hochschule
 *   pv_ = Promotionsvarianten
 */
var FrontendApiFilterNames;
(function (FrontendApiFilterNames) {
    // ── Studienangebot (sg_) ──────────────────────────────────────────────────
    FrontendApiFilterNames["sg_studientyp"] = "sg_studientyp";
    FrontendApiFilterNames["sg_studienform"] = "sg_studienform";
    FrontendApiFilterNames["sg_faechergruppe"] = "sg_faechergruppe";
    FrontendApiFilterNames["sg_studienbereich"] = "sg_studienbereich";
    FrontendApiFilterNames["sg_studienfeld"] = "sg_studienfeld";
    FrontendApiFilterNames["sg_bundesland"] = "sg_bundesland";
    FrontendApiFilterNames["sg_abschlussArt"] = "sg_abschlussArt";
    FrontendApiFilterNames["sg_masterTyp"] = "sg_masterTyp";
    FrontendApiFilterNames["sg_zulassungsModus"] = "sg_zulassungsModus";
    FrontendApiFilterNames["sg_zulassungsSemester"] = "sg_zulassungsSemester";
    FrontendApiFilterNames["sg_lehramtTyp"] = "sg_lehramtTyp";
    FrontendApiFilterNames["sg_sprache"] = "sg_sprache";
    FrontendApiFilterNames["sg_studierenOhneAbitur"] = "sg_studierenOhneAbitur";
    FrontendApiFilterNames["sg_hochschulName"] = "sg_hochschulName";
    FrontendApiFilterNames["sg_hochschulTyp"] = "sg_hochschulTyp";
    FrontendApiFilterNames["sg_traegerschaftsTyp"] = "sg_traegerschaftsTyp";
    // Synthetic: no filter_values_hsk row ever carries this filter_name. It merges sg_faechergruppe + sg_studienbereich + sg_studienfeld
    FrontendApiFilterNames["sg_fachlicheAusrichtung"] = "sg_fachlicheAusrichtung";
    // ── Hochschule (hs_) ──────────────────────────────────────────────────────
    FrontendApiFilterNames["hs_hochschulTyp"] = "hs_hochschulTyp";
    FrontendApiFilterNames["hs_traegerschaftsTyp"] = "hs_traegerschaftsTyp";
    FrontendApiFilterNames["hs_bundesland"] = "hs_bundesland";
    FrontendApiFilterNames["hs_hochschulName"] = "hs_hochschulName";
    FrontendApiFilterNames["hs_hrkMitglied"] = "hs_hrkMitglied";
    // ── Promotionsvarianten (pv_) ─────────────────────────────────────────────
    FrontendApiFilterNames["pv_wissenschaftsbereich"] = "pv_wissenschaftsbereich";
    FrontendApiFilterNames["pv_fachgebiet"] = "pv_fachgebiet";
    FrontendApiFilterNames["pv_sachgebiet"] = "pv_sachgebiet";
    FrontendApiFilterNames["pv_zulassungPromotion"] = "pv_zulassungPromotion";
    FrontendApiFilterNames["pv_bundesland"] = "pv_bundesland";
    FrontendApiFilterNames["pv_promotionsTyp"] = "pv_promotionsTyp";
    FrontendApiFilterNames["pv_doktorGrad"] = "pv_doktorGrad";
    FrontendApiFilterNames["pv_dissertation"] = "pv_dissertation";
    FrontendApiFilterNames["pv_hochschulTyp"] = "pv_hochschulTyp";
    FrontendApiFilterNames["pv_hochschulName"] = "pv_hochschulName";
    FrontendApiFilterNames["pv_traegerschaftsTyp"] = "pv_traegerschaftsTyp";
})(FrontendApiFilterNames || (FrontendApiFilterNames = {}));

// note: define headlineLevel ?
var isString = function (value) { return typeof value === "string" && value.length > 0; };
var isNumber = function (value) { return typeof value === "number"; };
var isBoolean = function (value) { return typeof value === "boolean"; };
var isGeoLocation = function (_a) {
    var name = _a.name, geoLocation = _a.geoLocation;
    return name && isLocation(geoLocation);
};
var isLocation = function (_a) {
    var lat = _a[0], lon = _a[1];
    return isNumber(lat) && isNumber(lon);
};
function isTypeOrNull(o, isType) {
    if (!o)
        return true;
    return isType(o);
}
function areType(oList, isType) {
    return oList.map(function (b) { return isType(b); }).filter(function (r) { return !r; }).length === 0;
}
function areTypeOrNull(oList, isType) {
    return areType(oList, function (v) { return isTypeOrNull(v, isType); });
}

var LinkType;
(function (LinkType) {
    LinkType["internal"] = "internal";
    LinkType["college"] = "college";
    LinkType["furtherEducationOffers"] = "furtherEducationOffers";
    LinkType["external"] = "external";
    LinkType["file"] = "file";
    LinkType["video"] = "video";
    LinkType["knowledgeGroup"] = "knowledgeGroup";
    LinkType["knowledgeArea"] = "knowledgeArea";
    LinkType["university"] = "university";
    LinkType["degreeProgramme"] = "degreeProgramme";
    LinkType["doctoralStudy"] = "doctoralStudy";
    LinkType["studyArea"] = "studyArea";
    LinkType["subjectGroup"] = "subjectGroup";
})(LinkType || (LinkType = {}));
var isLinkStatus = function (status) {
    return status === "available" || status === "unavailable" || status === "redirect" || status === "homepage";
};
var isLinkVisualization = function (visualization) {
    return visualization === "link" || visualization === "button" || visualization === "buttonFilled";
};
var isButtonIcon = function (icon) {
    // Check if it's a HUW icon (FrontendIconKey)
    if (icon in FrontendIconType) {
        return true;
    }
    // Check if it's an HSK icon (HrkIconName)
    return HrkIconNames.includes(icon);
};
var isLinkBundle = function (bundle) {
    return (isString(bundle.link) &&
        (bundle.language === "en" || bundle.language === "de") &&
        isTypeOrNull(bundle.description, isString) &&
        (bundle.target === "self" ||
            bundle.target === "blank" ||
            bundle.target === "_self" ||
            bundle.target === "_blank") &&
        (bundle.status ? isLinkStatus(bundle.status) : true) &&
        (bundle.visualization ? isLinkVisualization(bundle.visualization) : true) &&
        isTypeOrNull(bundle.buttonIcon, isButtonIcon));
};

var isMediaBundleType = function (type) {
    return type === "pixxio_image" || type === "pixxio_video" || type === "vimeo_video" || type === "youtube_video";
};
var isMediaBundle = function (bundle) {
    return (isTypeOrNull(bundle.fileName, isString) &&
        isTypeOrNull(bundle.caption, isString) &&
        isTypeOrNull(bundle.description, isString) &&
        isTypeOrNull(bundle.src, isString) &&
        isTypeOrNull(bundle.thumbnailSrc, isString) &&
        isTypeOrNull(bundle.videoSrc, isString) &&
        isTypeOrNull(bundle.pixxioFileId, isString) &&
        isTypeOrNull(bundle.playVideoOnHover, isBoolean) &&
        (bundle.type ? isMediaBundleType(bundle.type) : true));
};
/**
 * Returns a larger source for a staged MediaBundle from the CMS, e.g for a medium sized picture it will return a large version.
 * @param mediaBundle the mediaBundle to be analyzed
 * @returns the src path to the original image
 */
function determineLargeSrcFromMediaBundle(mediaBundle) {
    // since HOWI-3812
    // the lightbox must display a large image and all staged images in the the cms have prefixes. So we change the prefix and are done
    // see also downloadAssets.ts that is downloading the 'large' image from the cms into the frontend
    var lightBoxTargetSizeMap = new Map();
    lightBoxTargetSizeMap.set("xsmall", "large");
    lightBoxTargetSizeMap.set("small", "large");
    lightBoxTargetSizeMap.set("medium", "large");
    lightBoxTargetSizeMap.set("large", "xlarge");
    lightBoxTargetSizeMap.set("xlarge", "xlarge");
    var newSrc = mediaBundle.src;
    if (mediaBundle && mediaBundle.type === "pixxio_image" && mediaBundle.src) {
        var nameIndex = mediaBundle.src.lastIndexOf("/");
        var path = mediaBundle.src.substring(0, nameIndex);
        var fileName = mediaBundle.src.substring(nameIndex);
        // fileName = '/small_MSH_Harburg_02_ff0a0bf196.jpg'
        // extract the size
        var currentSize = fileName.substring(1, fileName.indexOf("_"));
        // see backend-cms strapi plugins.js for defined sizes in huw
        if (lightBoxTargetSizeMap.has(currentSize)) {
            var newSizeFilename = lightBoxTargetSizeMap.get(currentSize) + fileName.substring(fileName.indexOf("_"));
            newSrc = path + "/" + newSizeFilename;
        }
    }
    return newSrc;
}
/**
 * Returns the original source that was staged without any sizing.
 * @param mediaBundle the mediaBundle to be analyzed
 * @returns the src path to the original image
 */
function determineOriginalSrcFromMediaBundle(mediaBundle) {
    var newSrc = mediaBundle.src;
    if (mediaBundle && mediaBundle.type === "pixxio_image" && mediaBundle.src) {
        var nameIndex = mediaBundle.src.lastIndexOf("/");
        var fileName = mediaBundle.src.substring(nameIndex);
        var path = mediaBundle.src.substring(0, nameIndex);
        var originalName = fileName.substring(fileName.indexOf("_") + 1);
        var prefix = fileName.substring(1, fileName.indexOf("_"));
        // make sure, there is a valid prefix, otherwise don't touch it.
        if (["xsmall", "small", "medium", "large", "xlarge"].indexOf(prefix) !== -1) {
            newSrc = path + "/" + originalName;
        }
    }
    return newSrc;
}

var isTestimonial = function (testimonial) {
    return (isTypeOrNull(testimonial.quoteText, isString) &&
        isTypeOrNull(testimonial.quoteAuthor, isString) &&
        isTypeOrNull(testimonial.quoteRole, isString));
};
var isTestimonialWithLink = function (testimonial) {
    return (isTypeOrNull(testimonial.picture, isMediaBundle) &&
        isTypeOrNull(testimonial.link1, isLinkBundle) &&
        isTypeOrNull(testimonial.link2, isLinkBundle));
};

var HochschulPortraitBaseSlug = {
    en: "/en/higher-education-institutions/",
    de: "/hochschulen/",
};
var isHochschulportrait = function (hsp) {
    var result = [];
    // mandatory fields
    result.push(["id" in hsp && isString(hsp.id), !isString(hsp.id) ? "id" : null]);
    result.push(["type" in hsp && isString(hsp.type), !isString(hsp.type) ? "type" : null]);
    result.push(["association" in hsp && isString(hsp.association), !isString(hsp.association) ? "association" : null]);
    result.push(["pageSlug" in hsp && isString(hsp.pageSlug), !isString(hsp.pageSlug) ? "pageSlug" : null]);
    result.push(["addressName" in hsp && isString(hsp.addressName), !isString(hsp.addressName) ? "addressName" : null]);
    result.push(["management" in hsp && isString(hsp.management), !isString(hsp.management) ? "management" : null]);
    result.push([
        "federalState" in hsp && isString(hsp.federalState),
        !isString(hsp.federalState) ? "federalState" : null,
    ]);
    result.push(["foundation" in hsp && isNumber(hsp.foundation), !isNumber(hsp.foundation) ? "foundation" : null]);
    return result
        .filter(function (_a) {
        var f = _a[0];
        return !f;
    })
        .reduce(function (_a, _b) {
        var p = _a[0], rs = _a[1];
        var b = _b[0], r = _b[1];
        return [p && b, __spreadArray(__spreadArray([], rs, true), [r], false)];
    }, [true, []]);
};
var isIcon = function (icon) {
    return isString(icon.description);
};
var isContent = function (content) {
    var _a;
    return (isTypeOrNull(content.title, isString) &&
        isTypeOrNull(content.description, isString) &&
        isTypeOrNull(content.icon1, isIcon) &&
        isTypeOrNull(content.icon2, isIcon) &&
        areTypeOrNull((_a = content.multimedia) !== null && _a !== void 0 ? _a : [], isMediaBundle) &&
        isTypeOrNull(content.socialNetwork, isSocialNetwork));
};
var isSocialNetwork = function (network) {
    return (isTypeOrNull(network.facebookUrl, isLinkBundle) &&
        isTypeOrNull(network.twitterUrl, isLinkBundle) &&
        isTypeOrNull(network.instagramUrl, isLinkBundle) &&
        isTypeOrNull(network.linkedInUrl, isLinkBundle) &&
        isTypeOrNull(network.xingUrl, isLinkBundle));
};
var isGeneralContent = function (content) {
    return isContent(content) && isTypeOrNull(content.testimonial, isTestimonialWithLink);
};
var isCoursesContent = function (content) {
    return isContent(content) && isTypeOrNull(content.testimonial, isTestimonialWithLink);
};

var GenerateLocales;
(function (GenerateLocales) {
    GenerateLocales["de"] = "de";
    GenerateLocales["en"] = "en";
    GenerateLocales["all"] = "all";
})(GenerateLocales || (GenerateLocales = {}));
var DefaultLocale = GenerateLocales.de;
var AvailableLocales = [GenerateLocales.de, GenerateLocales.en];
/**
 * Returns 'de' for 'en' and 'en' for 'de'
 * @param locale
 * @returns
 */
var toggleLocale = function (locale) {
    if (locale === GenerateLocales.all) {
        return GenerateLocales.de; // Default to 'de' if 'all' is passed
    }
    return locale === GenerateLocales.de ? GenerateLocales.en : GenerateLocales.de;
};

var TestimonialColors = [
    "anthracite",
    "blue",
    "silver",
];
function isTestimonialColor(colorKey) {
    return TestimonialColors.includes(colorKey);
}

/**
 * Transforms key-value collection type to a single type.
 * Each entity is transformed to a key-value pair, where the key is the value of the "key" property and the value is the value of the "value" property.
 * If the "value" property is undefined or null, the key-value pair is not included in the resulting object.
 *
 * @param data - An array of objects containing an "attributes" property with "key" and "value" properties.
 * @returns An object where each key is derived from the "key" property and each value is derived from the "value" property of the input data.
 */
var transformCollectionToSingleType = function (data) {
    var _a, _b;
    if (!data)
        return null;
    var result = {};
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var item = data_1[_i];
        var key = (_a = item.attributes) === null || _a === void 0 ? void 0 : _a.key;
        var value = (_b = item.attributes) === null || _b === void 0 ? void 0 : _b.value;
        if (key && value !== undefined && value !== null) {
            result[key] = value;
        }
    }
    return result;
};

var WeiterbildungsAngebotBaseSlug = {
    en: "/en/continuing-education/",
    de: "/weiterbildungsangebote/",
};

export { AvailableLocales, ComponentType, ComponentTypes, DefaultLocale, ExportSchemaValidationError, FrontEndIcons, FrontendApiFilterNames, FrontendIconType, GenerateLocales, HochschulPortraitBaseSlug, HrkAppLocales, HrkBackgroundColors, HrkColors, HrkDesktopWidth, HrkHeadingLevels, HrkHeadingSizes, HrkIconNames, HrkLightBackgroundColors, HrkLinkTargets, HrkLinkTypes, HrkLinkVisualizations, HrkMediaTypes, HrkModuleTypes, HrkPhoneWidth, HrkPositions, HrkSocialMediaIconNames, HrkStatusVariants, HrkSystems, HrkTabletWidth, HrkUiIconNames, HrkVariants, HskLinkTypes, HuwLinkTypes, LinkType, WeiterbildungsAngebotBaseSlug, areType, areTypeOrNull, assertValidAbschlussArt, assertValidBundesland, assertValidDissertation, assertValidDoktorGrad, assertValidFachgebiet, assertValidFaechergruppe, assertValidHSPExport, assertValidHochschulTyp, assertValidLehramtTyp, assertValidMasterTyp, assertValidPromotionsTyp, assertValidSachgebiet, assertValidSprache, assertValidStudienbereich, assertValidStudienfeld, assertValidStudienform, assertValidStudiengangExport, assertValidStudientyp, assertValidStudierenOhneAbitur, assertValidTraegerschaftsTyp, assertValidWAExport, assertValidWissenschaftsbereich, assertValidZulassungPromotion, assertValidZulassungsModus, assertValidZulassungsSemester, determineLargeSrcFromMediaBundle, determineOriginalSrcFromMediaBundle, getAbschlussArtErrors, getBundeslandErrors, getDissertationErrors, getDoktorGradErrors, getFachgebietErrors, getFaechergruppeErrors, getHochschulTypErrors, getLehramtTypErrors, getMasterTypErrors, getPromotionsTypErrors, getSachgebietErrors, getSpracheErrors, getStudienbereichErrors, getStudienfeldErrors, getStudienformErrors, getStudientypErrors, getStudierenOhneAbiturErrors, getTraegerschaftsTypErrors, getWissenschaftsbereichErrors, getZulassungPromotionErrors, getZulassungsModusErrors, getZulassungsSemesterErrors, isBoolean, isButtonIcon, isContent, isCoursesContent, isGeneralContent, isGeoLocation, isHochschulportrait, isIcon, isLinkBundle, isLinkStatus, isLinkVisualization, isLocation, isMediaBundle, isMediaBundleType, isNumber, isSocialNetwork, isString, isTestimonial, isTestimonialColor, isTestimonialWithLink, isTypeOrNull, isValidAbschlussArt, isValidBundesland, isValidDissertation, isValidDoktorGrad, isValidFachgebiet, isValidFaechergruppe, isValidHSPExport, isValidHochschulTyp, isValidLehramtTyp, isValidMasterTyp, isValidPromotionsTyp, isValidSachgebiet, isValidSprache, isValidStudienbereich, isValidStudienfeld, isValidStudienform, isValidStudiengangExport, isValidStudientyp, isValidStudierenOhneAbitur, isValidTraegerschaftsTyp, isValidWAExport, isValidWissenschaftsbereich, isValidZulassungPromotion, isValidZulassungsModus, isValidZulassungsSemester, toggleLocale, transformCollectionToSingleType, validateAbschlussArt, validateBundesland, validateDissertation, validateDoktorGrad, validateFachgebiet, validateFaechergruppe, validateHSPExport, validateHochschulPortraitExport, validateHochschulTyp, validateLehramtTyp, validateMasterTyp, validatePromotionsTyp, validateSachgebiet, validateSprache, validateStudienbereich, validateStudienfeld, validateStudienform, validateStudiengangExport, validateStudientyp, validateStudierenOhneAbitur, validateTraegerschaftsTyp, validateWAExport, validateWeiterbildungsAngebotExport, validateWissenschaftsbereich, validateZulassungPromotion, validateZulassungsModus, validateZulassungsSemester };
